var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __pow = Math.pow;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/init-masonry-registry.ts
import {
  MasonryDriverNodeRenderersRegistry,
  MasonryDriverActionController,
  masonrySetTitleBaseActionHandler
} from "@leagueplatform/masonry";
import { DEFAULT_NAMESPACE } from "@leagueplatform/masonry-engine";
import {
  HEALTH_JOURNEY_NODE_TYPES,
  HEALTH_JOURNEY_NAMESPACE
} from "@leagueplatform/health-journey";

// src/components/masonry/masonry-vertical-layout-renderer/masonry-vertical-layout-renderer-override.tsx
import { MasonryVerticalLayoutRenderer } from "@leagueplatform/masonry-renderers";
import { queryHelpers, useMediaQuery } from "@leagueplatform/genesis-core";
import { jsx } from "react/jsx-runtime";
var MasonryVerticalLayoutRendererOverride = (props) => {
  const isMobile = useMediaQuery(queryHelpers.down("tablet"));
  if (!isMobile)
    return null;
  return /* @__PURE__ */ jsx(MasonryVerticalLayoutRenderer, __spreadValues({}, props));
};

// src/components/masonry/masonry-vertical-layout-sidebar-renderer/masonry-vertical-layout-sidebar-renderer-override.tsx
import { MasonryVerticalLayoutRenderer as MasonryVerticalLayoutRenderer2 } from "@leagueplatform/masonry-renderers";
import { queryHelpers as queryHelpers2, useMediaQuery as useMediaQuery2 } from "@leagueplatform/genesis-core";
import { jsx as jsx2 } from "react/jsx-runtime";
var MasonryVerticalLayoutSidebarRendererOverride = (props) => {
  const isMobile = useMediaQuery2(queryHelpers2.down("tablet"));
  if (isMobile)
    return null;
  return /* @__PURE__ */ jsx2(
    MasonryVerticalLayoutRenderer2,
    __spreadProps(__spreadValues({}, props), {
      css: { marginLeft: "$half", paddingLeft: "$twoAndHalf" }
    })
  );
};

// src/components/masonry/masonry-small-card-renderer/masonry-small-card-renderer-override.tsx
import { MasonrySmallCardRenderer } from "@leagueplatform/masonry-renderers";
import { jsx as jsx3 } from "react/jsx-runtime";
var MasonrySmallCardRendererOverride = (props) => /* @__PURE__ */ jsx3(
  MasonrySmallCardRenderer,
  __spreadValues({
    css: {
      ".GDS-heading-text": {
        paddingBlockEnd: "$threeQuarters",
        "> span": {
          typography: "$headingThree"
        }
      },
      "&": {
        backgroundColor: "$surfaceCardPrimary"
      }
    }
  }, props)
);

// src/components/masonry/masonry-micro-card-renderer-override/masonry-micro-card-renderer-override.tsx
import { MasonryMicroCardRenderer } from "@leagueplatform/masonry-renderers";
import { jsx as jsx4 } from "react/jsx-runtime";
var MasonryMicroCardRendererOverride = (props) => /* @__PURE__ */ jsx4(
  MasonryMicroCardRenderer,
  __spreadValues({
    css: {
      "& .GDS-heading-text": {
        maxWidth: "100px",
        overflowWrap: "break-word",
        hyphens: "auto"
      }
    }
  }, props)
);

// src/components/masonry/masonry-section-header-renderer-override/masonry-section-header-renderer-override.tsx
import { MasonrySectionHeaderRenderer } from "@leagueplatform/masonry-renderers";
import { jsx as jsx5 } from "react/jsx-runtime";
var MasonrySectionHeaderRendererOverride = (props) => /* @__PURE__ */ jsx5(
  MasonrySectionHeaderRenderer,
  __spreadValues({
    css: {
      "& .GDS-box": {
        display: "flex",
        alignSelf: "center"
      },
      "& .GDS-text-action": {
        typography: "$bodyOne",
        color: "$onSurfaceTextPrimary"
      }
    }
  }, props)
);

// src/components/rewards-banner-card/rewards-banner-card.component.tsx
import React from "react";
import {
  Card,
  StackLayout,
  HeadingText,
  Button,
  useMediaQuery as useMediaQuery3,
  queryHelpers as queryHelpers3,
  UtilityText
} from "@leagueplatform/genesis-core";
import { useInvokeAction } from "@leagueplatform/masonry-renderers";
import { jsx as jsx6, jsxs } from "react/jsx-runtime";
var RewardsBannerCard = ({
  image,
  imageAltText = "",
  heading,
  body,
  ctaLabel,
  onClick
}) => {
  var _a;
  const invokeAction = useInvokeAction();
  const handleOnClick = React.useCallback(
    (event) => {
      if (onClick) {
        invokeAction(__spreadValues({
          event
        }, onClick));
      }
    },
    [invokeAction, onClick]
  );
  const belowTabletBreakpoint = queryHelpers3.down("tablet");
  const isBelowTablet = useMediaQuery3(belowTabletBreakpoint);
  return /* @__PURE__ */ jsxs(
    Card.Elevated,
    {
      backgroundColor: "primary",
      imagePosition: isBelowTablet ? "top" : "end",
      children: [
        image && /* @__PURE__ */ jsx6(
          Card.Image,
          {
            image,
            imageAlt: imageAltText,
            css: {
              height: "auto",
              width: "100%",
              maxWidth: isBelowTablet ? "unset" : "440px"
            }
          }
        ),
        /* @__PURE__ */ jsx6(
          Card.Section,
          {
            css: {
              paddingBlock: isBelowTablet ? "$one" : "$three",
              paddingInline: isBelowTablet ? "$one" : "$twoAndHalf"
            },
            children: /* @__PURE__ */ jsxs(
              StackLayout,
              {
                spacing: "$half",
                orientation: "vertical",
                verticalAlignment: "center",
                horizontalAlignment: "stretch",
                children: [
                  /* @__PURE__ */ jsx6(
                    HeadingText,
                    {
                      level: "2",
                      size: "sm",
                      css: {
                        typography: "$headingThree"
                      },
                      children: heading
                    }
                  ),
                  /* @__PURE__ */ jsxs(
                    StackLayout,
                    {
                      spacing: isBelowTablet ? "$one" : "$two",
                      horizontalAlignment: "stretch",
                      children: [
                        /* @__PURE__ */ jsx6(UtilityText, { children: body }),
                        /* @__PURE__ */ jsx6(
                          Button,
                          {
                            as: "a",
                            href: (_a = onClick == null ? void 0 : onClick.payload.url) != null ? _a : "",
                            onClick: handleOnClick,
                            textAlign: "center",
                            width: isBelowTablet ? "fillContainer" : "hugContents",
                            children: ctaLabel
                          }
                        )
                      ]
                    }
                  )
                ]
              }
            )
          }
        )
      ]
    }
  );
};

// src/components/rewards-points-progress-card/rewards-points-progress-card.component.tsx
import {
  Card as Card2,
  Box,
  useClickableCard,
  StackLayout as StackLayout2,
  HeadingText as HeadingText2,
  TextAction,
  useMediaQuery as useMediaQuery4,
  queryHelpers as queryHelpers4,
  ProgressBar,
  Tag,
  VisuallyHidden
} from "@leagueplatform/genesis-core";
import {
  useInvokeAction as useInvokeAction2
} from "@leagueplatform/masonry-renderers";
import { useIntl } from "@leagueplatform/locales";
import { Link } from "react-router-dom";
import { jsx as jsx7, jsxs as jsxs2 } from "react/jsx-runtime";
var RewardsPointsProgressCard = ({
  body,
  progressBar,
  onCardClick
}) => {
  const { primaryActionRef, clickAreaRef, onCardMouseDown, onCardMouseUp } = useClickableCard();
  const invokeAction = useInvokeAction2();
  const { formatMessage, formatList } = useIntl();
  const onClickDeeplinkAction = onCardClick;
  const isMobile = useMediaQuery4(queryHelpers4.down("tablet"));
  const { heading, tags } = body || {};
  const {
    accessibilityLabel,
    fill,
    fillProgressValue,
    trailingValue,
    valuePosition
  } = progressBar || {};
  const trailingValueWithPoints = trailingValue ? formatMessage(
    { id: "PROGRESS_BAR_TRAILING_VALUE" },
    { value: trailingValue }
  ) : void 0;
  const tagsAccessibilityLabel = (tags == null ? void 0 : tags.length) ? formatList(
    tags.map(
      (tag) => tag.iconAltText ? formatMessage(
        { id: "TAG_ACCESSIBILITY_LABEL" },
        { iconAltText: tag.iconAltText, label: tag.label }
      ) : tag.label
    ),
    { type: "conjunction", style: "long" }
  ) : "";
  const detailedAccessibilityLabel = (() => {
    var _a;
    const [current, total] = (_a = trailingValue == null ? void 0 : trailingValue.split("/")) != null ? _a : [];
    if (current && total) {
      const pointsLabel = formatMessage(
        { id: "PROGRESS_BAR_ACCESSIBILITY_LABEL" },
        { current, total }
      );
      return accessibilityLabel ? `${accessibilityLabel}, ${pointsLabel}` : pointsLabel;
    }
    return accessibilityLabel;
  })();
  return /* @__PURE__ */ jsx7(Card2.Elevated, { backgroundColor: "secondary", children: /* @__PURE__ */ jsx7(
    Card2.ClickArea,
    {
      ref: clickAreaRef,
      onCardMouseUp,
      onCardMouseDown,
      children: /* @__PURE__ */ jsx7(Card2.Section, { css: { width: "100%" }, children: /* @__PURE__ */ jsxs2(
        StackLayout2,
        {
          orientation: isMobile ? "vertical" : "horizontal",
          verticalAlignment: "center",
          spacing: "$one",
          css: { width: "100%" },
          children: [
            /* @__PURE__ */ jsxs2(
              StackLayout2,
              {
                orientation: "vertical",
                spacing: "$one",
                css: { width: "100%" },
                children: [
                  heading && /* @__PURE__ */ jsx7(
                    HeadingText2,
                    {
                      level: "3",
                      size: "sm",
                      css: {
                        "& > a": {
                          all: "inherit"
                        },
                        overflowWrap: "anywhere"
                      },
                      children: /* @__PURE__ */ jsx7(
                        TextAction,
                        {
                          as: Link,
                          ref: primaryActionRef,
                          to: onClickDeeplinkAction == null ? void 0 : onClickDeeplinkAction.payload.url,
                          onClick: (event) => {
                            if (onClickDeeplinkAction) {
                              invokeAction(__spreadValues({
                                event
                              }, onClickDeeplinkAction));
                            }
                          },
                          children: heading
                        }
                      )
                    }
                  ),
                  (tags == null ? void 0 : tags.length) ? /* @__PURE__ */ jsxs2(Box, { children: [
                    /* @__PURE__ */ jsx7(VisuallyHidden, { children: tagsAccessibilityLabel }),
                    /* @__PURE__ */ jsx7(
                      StackLayout2,
                      {
                        "aria-hidden": "true",
                        orientation: "horizontal",
                        verticalAlignment: "center",
                        spacing: "$half",
                        css: {
                          flexWrap: "wrap"
                        },
                        children: tags.map((tag) => {
                          var _a;
                          return /* @__PURE__ */ jsx7(
                            Tag,
                            {
                              label: tag.label,
                              icon: tag.icon,
                              iconAltText: tag.iconAltText,
                              size: tag.size,
                              category: tag.category,
                              emphasis: tag.emphasis,
                              css: {
                                justifyContent: "center",
                                flexGrow: 0,
                                ".GDS-tag-label": {
                                  width: "max-content",
                                  typography: "$label"
                                }
                              }
                            },
                            `${String(tag.icon)}-${(_a = tag.iconAltText) != null ? _a : ""}-${tag.label}-${tag.category}-${tag.emphasis}`
                          );
                        })
                      }
                    )
                  ] }) : null
                ]
              }
            ),
            progressBar && /* @__PURE__ */ jsx7(
              ProgressBar,
              {
                accessibilityLabel: detailedAccessibilityLabel,
                fill,
                fillProgressValue,
                trailingValue: isMobile ? void 0 : trailingValueWithPoints,
                leadingValue: isMobile ? trailingValueWithPoints : void 0,
                valuePosition
              }
            )
          ]
        }
      ) })
    }
  ) });
};

// src/components/rewards-points-pill/rewards-points-pill.component.tsx
import {
  Box as Box2,
  Card as Card3,
  UtilityText as UtilityText2,
  VisuallyHidden as VisuallyHidden2
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl2 } from "@leagueplatform/locales";
import { jsx as jsx8, jsxs as jsxs3 } from "react/jsx-runtime";
var RewardsPointsPill = ({
  heading,
  image,
  imageAltText = ""
}) => {
  const { formatMessage } = useIntl2();
  return /* @__PURE__ */ jsxs3(
    Box2,
    {
      css: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "$half",
        border: "thin solid $onSurfaceBorderDefault",
        borderRadius: "$circle",
        width: "fit-content",
        padding: "$threeQuarters"
      },
      children: [
        /* @__PURE__ */ jsx8(VisuallyHidden2, { children: formatMessage({ id: "AEROPLAN_POINTS" }, { points: heading }) }),
        image && /* @__PURE__ */ jsx8(
          Card3.Image,
          {
            image,
            imageAlt: imageAltText,
            "aria-hidden": "true",
            css: {
              width: "$oneAndHalf",
              height: "$oneAndHalf"
            }
          }
        ),
        /* @__PURE__ */ jsx8(
          UtilityText2,
          {
            "aria-hidden": "true",
            css: {
              typography: "$headingThree",
              lineHeight: 1
            },
            children: heading
          }
        )
      ]
    }
  );
};

// src/hooks/useAnimatedCount/useAnimatedCount.hook.ts
import { useState, useEffect, useRef, useCallback } from "react";
import { useGetUserProfile } from "@leagueplatform/health-journey-common";
var STORAGE_KEY_PREFIX = "rewards-points-heading";
var DEFAULT_DURATION_MS = 800;
var ANIMATION_DELAY_MS = 1e3;
function easeOutCubic(t) {
  return 1 - __pow(1 - t, 3);
}
function parsePoints(value) {
  const digits2 = value.replace(/[^\d]/g, "");
  return digits2.length > 0 ? Number(digits2) : NaN;
}
function formatPoints(n) {
  return n.toLocaleString("en-US");
}
function getStorageKey(userId) {
  return `${STORAGE_KEY_PREFIX}-${userId}`;
}
function getStoredPoints(userId) {
  const stored = localStorage.getItem(getStorageKey(userId));
  return stored != null ? Number(stored) : null;
}
function storePoints(value, userId) {
  localStorage.setItem(getStorageKey(userId), value);
}
var useAnimatedCount = (targetValue, duration = DEFAULT_DURATION_MS) => {
  const { data: userProfile } = useGetUserProfile();
  const userId = userProfile == null ? void 0 : userProfile.userId;
  const target = parsePoints(targetValue);
  const [displayValue, setDisplayValue] = useState(() => {
    if (!userId)
      return targetValue;
    const stored = getStoredPoints(userId);
    return stored != null && stored !== target ? formatPoints(stored) : targetValue;
  });
  const animationFrameRef = useRef();
  const delayTimerRef = useRef();
  const visibilityHandlerRef = useRef();
  const lastSetValueRef = useRef(displayValue);
  const cancelAnimation = useCallback(() => {
    if (delayTimerRef.current != null) {
      clearTimeout(delayTimerRef.current);
      delayTimerRef.current = void 0;
    }
    if (animationFrameRef.current != null) {
      cancelAnimationFrame(animationFrameRef.current);
      animationFrameRef.current = void 0;
    }
    if (visibilityHandlerRef.current) {
      document.removeEventListener(
        "visibilitychange",
        visibilityHandlerRef.current
      );
      visibilityHandlerRef.current = void 0;
    }
  }, []);
  useEffect(() => {
    cancelAnimation();
    if (Number.isNaN(target)) {
      setDisplayValue(targetValue);
      lastSetValueRef.current = targetValue;
      return cancelAnimation;
    }
    if (!userId) {
      setDisplayValue(targetValue);
      lastSetValueRef.current = targetValue;
      return cancelAnimation;
    }
    const prevPoints = getStoredPoints(userId);
    storePoints(String(target), userId);
    const shouldAnimate = prevPoints != null && prevPoints !== target;
    if (!shouldAnimate) {
      setDisplayValue(targetValue);
      lastSetValueRef.current = targetValue;
      return cancelAnimation;
    }
    const prevValue = formatPoints(prevPoints);
    setDisplayValue(prevValue);
    lastSetValueRef.current = prevValue;
    const startAnimation = () => {
      delayTimerRef.current = setTimeout(() => {
        let startTime;
        const step = (timestamp) => {
          if (startTime == null)
            startTime = timestamp;
          const progress = Math.min((timestamp - startTime) / duration, 1);
          const interpolated = formatPoints(
            Math.round(
              prevPoints + (target - prevPoints) * easeOutCubic(progress)
            )
          );
          if (interpolated !== lastSetValueRef.current) {
            lastSetValueRef.current = interpolated;
            setDisplayValue(interpolated);
          }
          if (progress < 1) {
            animationFrameRef.current = requestAnimationFrame(step);
          }
        };
        animationFrameRef.current = requestAnimationFrame(step);
      }, ANIMATION_DELAY_MS);
    };
    if (document.visibilityState === "visible") {
      startAnimation();
    } else {
      const handleVisibilityChange = () => {
        if (document.visibilityState === "visible") {
          document.removeEventListener(
            "visibilitychange",
            handleVisibilityChange
          );
          visibilityHandlerRef.current = void 0;
          startAnimation();
        }
      };
      visibilityHandlerRef.current = handleVisibilityChange;
      document.addEventListener("visibilitychange", handleVisibilityChange);
    }
    return cancelAnimation;
  }, [target, targetValue, duration, cancelAnimation, userId]);
  return displayValue;
};

// src/hooks/useLiveRewardsBalance/useLiveRewardsBalance.hook.ts
import { useEffect as useEffect2, useRef as useRef2, useState as useState2 } from "react";
import { leagueFetch } from "@leagueplatform/league-fetch";
import { captureError } from "@leagueplatform/observability";
import { ReconnectingSocketController } from "@leagueplatform/league-socket";
var USER_REWARDS_UPDATES_MESSAGE_TYPE = "user_rewards_updates";
var REWARDS_USER_ACCOUNTS_PATH = "v1/rewards-user-accounts";
var REFRESH_DEBOUNCE_MS = 800;
function fetchRewardsBalance() {
  return __async(this, null, function* () {
    var _a, _b, _c;
    const response = yield leagueFetch(REWARDS_USER_ACCOUNTS_PATH, {
      method: "GET"
    });
    if (!response.ok) {
      throw new Error(`Failed to fetch points data: ${response.status}`);
    }
    const responseData = yield response.json();
    return (_c = (_b = (_a = responseData == null ? void 0 : responseData.data) == null ? void 0 : _a[0]) == null ? void 0 : _b.attributes) == null ? void 0 : _c.balance;
  });
}
function useLiveRewardsBalance(heading) {
  const [liveHeading, setLiveHeading] = useState2(null);
  const headingRef = useRef2(heading);
  const mountedRef = useRef2(true);
  useEffect2(() => {
    headingRef.current = heading;
    setLiveHeading(null);
  }, [heading]);
  useEffect2(() => {
    mountedRef.current = true;
    let debounceTimeout;
    const readBalance = () => __async(this, null, function* () {
      try {
        const balance = yield fetchRewardsBalance();
        if (!mountedRef.current || typeof balance !== "number")
          return;
        if (balance === parsePoints(headingRef.current))
          return;
        setLiveHeading(formatPoints(balance));
      } catch (error) {
        if (!mountedRef.current)
          return;
        captureError(
          new Error(
            "[manulife] Rewards balance re-read failed after a points update",
            { cause: error }
          )
        );
      }
    });
    const removeEventHandler = ReconnectingSocketController.addEventHandler(
      (event) => {
        if ((event == null ? void 0 : event.message_type) !== USER_REWARDS_UPDATES_MESSAGE_TYPE)
          return;
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(readBalance, REFRESH_DEBOUNCE_MS);
      }
    );
    return () => {
      mountedRef.current = false;
      clearTimeout(debounceTimeout);
      removeEventHandler();
    };
  }, []);
  return liveHeading != null ? liveHeading : heading;
}

// src/components/rewards-points-pill-animation/rewards-points-pill-animation.component.tsx
import { jsx as jsx9 } from "react/jsx-runtime";
var RewardsPointsPillAnimation = (_a) => {
  var _b = _a, {
    heading
  } = _b, rest = __objRest(_b, [
    "heading"
  ]);
  const liveHeading = useLiveRewardsBalance(heading);
  const animatedHeading = useAnimatedCount(liveHeading);
  return /* @__PURE__ */ jsx9(RewardsPointsPill, __spreadValues({ heading: animatedHeading }, rest));
};

// src/components/rewardable-task-card/rewardable-task-card.component.tsx
import {
  Box as Box3,
  Card as Card4,
  useClickableCard as useClickableCard2,
  StackLayout as StackLayout3,
  HeadingText as HeadingText3,
  TextAction as TextAction2,
  Tag as Tag2,
  UtilityText as UtilityText3,
  VisuallyHidden as VisuallyHidden3
} from "@leagueplatform/genesis-core";
import {
  useInvokeAction as useInvokeAction3
} from "@leagueplatform/masonry-renderers";
import { Link as Link2 } from "react-router-dom";
import { useIntl as useIntl3 } from "@leagueplatform/locales";
import lockIcon from "./assets/lock-icon.svg";
import { jsx as jsx10, jsxs as jsxs4 } from "react/jsx-runtime";
var RewardableTaskCardRenderer = ({
  body,
  onCardClick
}) => {
  const { formatMessage, formatList } = useIntl3();
  const { primaryActionRef, clickAreaRef, onCardMouseDown, onCardMouseUp } = useClickableCard2();
  const invokeAction = useInvokeAction3();
  const onClickDeeplinkAction = onCardClick;
  const {
    backgroundImage,
    imageAltText,
    heading,
    caption,
    tags,
    backgroundOverlay
  } = body || {};
  const tagsAccessibleLabel = tags ? formatList(
    tags.map(
      (tag) => tag.iconAltText ? `${tag.iconAltText}, ${tag.label}` : tag.label
    ),
    { type: "conjunction", style: "long" }
  ) : "";
  return /* @__PURE__ */ jsx10(
    Card4.Elevated,
    {
      css: {
        backgroundColor: "$surfaceBackgroundSecondary"
      },
      children: /* @__PURE__ */ jsxs4(
        Card4.ClickArea,
        {
          ref: clickAreaRef,
          onCardMouseUp,
          onCardMouseDown,
          imagePosition: "start",
          children: [
            /* @__PURE__ */ jsx10(Card4.Section, { children: /* @__PURE__ */ jsxs4(StackLayout3, { spacing: "$one", orientation: "vertical", children: [
              /* @__PURE__ */ jsxs4(StackLayout3, { spacing: "$none", orientation: "vertical", children: [
                caption && /* @__PURE__ */ jsx10(
                  UtilityText3,
                  {
                    css: {
                      typography: "$caption",
                      color: "$onSurfaceTextPrimary"
                    },
                    children: caption
                  }
                ),
                /* @__PURE__ */ jsx10(
                  HeadingText3,
                  {
                    level: "3",
                    size: "sm",
                    css: {
                      "& > a": {
                        all: "inherit"
                      },
                      // MANU-5348: break long unbreakable words so the card image
                      // isn't pushed out of view at narrow widths.
                      overflowWrap: "anywhere"
                    },
                    children: /* @__PURE__ */ jsx10(
                      TextAction2,
                      {
                        as: Link2,
                        ref: primaryActionRef,
                        to: onClickDeeplinkAction == null ? void 0 : onClickDeeplinkAction.payload.url,
                        onClick: (event) => {
                          if (onClickDeeplinkAction) {
                            invokeAction(__spreadValues({
                              event
                            }, onClickDeeplinkAction));
                          }
                        },
                        children: heading
                      }
                    )
                  }
                )
              ] }),
              tags && /* @__PURE__ */ jsxs4(
                StackLayout3,
                {
                  orientation: "horizontal",
                  verticalAlignment: "top",
                  spacing: "$half",
                  css: {
                    flexWrap: "wrap"
                  },
                  children: [
                    /* @__PURE__ */ jsx10(VisuallyHidden3, { children: tagsAccessibleLabel }),
                    tags.map((tag) => /* @__PURE__ */ jsx10(
                      Box3,
                      {
                        "aria-hidden": "true",
                        css: { display: "inline-flex" },
                        children: /* @__PURE__ */ jsx10(
                          Tag2,
                          {
                            label: tag.label,
                            icon: tag.icon,
                            iconAltText: tag.iconAltText,
                            size: tag.size,
                            category: tag.category,
                            emphasis: tag.emphasis,
                            css: {
                              flex: "0 1 auto",
                              alignItems: "baseline"
                            }
                          }
                        )
                      },
                      tag.label
                    ))
                  ]
                }
              )
            ] }) }),
            backgroundImage && /* @__PURE__ */ jsxs4(
              Box3,
              {
                css: __spreadValues({
                  position: "relative",
                  width: "120px",
                  flexShrink: 0,
                  overflow: "hidden"
                }, backgroundOverlay && {
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    background: "linear-gradient(152.95deg, rgba(155, 155, 155, 0.6) 17.45%, rgba(102, 102, 102, 0.6) 94.01%)",
                    // gradient value from Figma design specs
                    pointerEvents: "none"
                  }
                }),
                children: [
                  /* @__PURE__ */ jsx10(
                    Card4.Image,
                    {
                      image: backgroundImage,
                      imageAlt: backgroundOverlay ? [imageAltText, formatMessage({ id: "LOCKED" })].filter(Boolean).join(", ") : imageAltText,
                      css: __spreadValues({
                        height: "100%",
                        width: "100%",
                        objectFit: "cover"
                      }, backgroundOverlay && {
                        filter: "blur(4px)"
                      })
                    }
                  ),
                  backgroundOverlay && /* @__PURE__ */ jsx10(
                    Box3,
                    {
                      as: "img",
                      src: lockIcon,
                      alt: "",
                      css: {
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 1,
                        width: "$twoAndHalf",
                        height: "$twoAndHalf"
                      }
                    }
                  )
                ]
              }
            )
          ]
        }
      )
    }
  );
};

// src/components/composable-cta-card/components/composable-cta-card-headline/composable-cta-card-headline.component.tsx
import {
  Card as Card5,
  Icon,
  StackLayout as StackLayout4,
  UtilityText as UtilityText4
} from "@leagueplatform/genesis-core";
import { jsx as jsx11, jsxs as jsxs5 } from "react/jsx-runtime";
var ComposableCTACardHeadline = ({
  text,
  textEmphasis = "emphasized",
  size = "eyebrow",
  backgroundColor = "$decorativeBrandPrimaryDark",
  color = "$onSurfaceTextReversed",
  icon,
  iconAltText,
  css
}) => /* @__PURE__ */ jsx11(
  Card5.Section,
  {
    padding: "$threeQuarters $oneAndHalf",
    css: __spreadValues({
      backgroundColor,
      flexGrow: 0
    }, css),
    children: /* @__PURE__ */ jsxs5(
      StackLayout4,
      {
        orientation: "horizontal",
        verticalAlignment: "center",
        spacing: "$quarter",
        children: [
          icon && /* @__PURE__ */ jsx11(Icon, { icon, label: iconAltText, size: "$one" }),
          /* @__PURE__ */ jsx11(
            UtilityText4,
            {
              size,
              emphasis: textEmphasis,
              css: { color, textTransform: "uppercase" },
              children: text
            }
          )
        ]
      }
    )
  }
);

// src/components/composable-cta-card/composable-cta-card.component.tsx
import * as React3 from "react";
import {
  Card as Card6,
  HeadingText as HeadingText4,
  StackLayout as StackLayout5,
  useMediaQuery as useMediaQuery5,
  queryHelpers as queryHelpers5,
  Box as Box4
} from "@leagueplatform/genesis-core";
import { useUniqueId } from "@leagueplatform/web-common";

// src/components/composable-cta-card/components/composable-cta-card-button/composable-cta-card-button.component.tsx
import React2 from "react";
import { TextAction as TextAction3 } from "@leagueplatform/genesis-core";
import { Link as Link3 } from "react-router-dom";
import { useMasonryEngineActionEmitter } from "@leagueplatform/masonry-engine";
import { jsx as jsx12 } from "react/jsx-runtime";
var ComposableCTACardButton = ({
  text,
  onClick,
  titleId,
  indicator
}) => {
  var _a;
  const invokeAction = useMasonryEngineActionEmitter();
  const handleOnClick = React2.useCallback(
    (event) => {
      if (onClick) {
        invokeAction(__spreadValues({
          event
        }, onClick));
      }
    },
    [invokeAction, onClick]
  );
  return /* @__PURE__ */ jsx12(
    TextAction3,
    __spreadProps(__spreadValues({}, titleId && { "aria-describedby": titleId }), {
      as: Link3,
      to: (_a = onClick == null ? void 0 : onClick.payload.url) != null ? _a : "",
      onClick: handleOnClick,
      icon: "interfaceCTAIndicator",
      indicator,
      size: "medium",
      css: {
        fontWeight: "$bodyOne",
        color: "$onSurfaceTextPrimary",
        "& > .GDS-icon:first-child": {
          color: "$primaryBackgroundDefault"
        },
        "&:hover": {
          textDecoration: "none",
          "& > .GDS-icon:first-child": {
            color: "$primaryBackgroundHovered"
          }
        }
      },
      children: text
    })
  );
};

// src/components/composable-cta-card/components/composable-cta-card-badge/composable-cta-card-badge.component.tsx
import {
  Icon as Icon2,
  UtilityText as UtilityText5
} from "@leagueplatform/genesis-core";
import { Badge } from "@leagueplatform/web-common-components";
import { jsx as jsx13, jsxs as jsxs6 } from "react/jsx-runtime";
var ComposableCTACardBadge = ({
  image,
  imageTint,
  body,
  backgroundColor = "$surfaceBackgroundPrimary",
  testId,
  css
}) => /* @__PURE__ */ jsxs6(
  Badge,
  {
    "data-testid": testId,
    css: __spreadValues({
      backgroundColor,
      borderRadius: "$small"
    }, css),
    children: [
      image && /* @__PURE__ */ jsx13(Icon2, { icon: image, tint: imageTint, size: "$one" }),
      /* @__PURE__ */ jsx13(
        UtilityText5,
        {
          size: "eyebrow",
          emphasis: "emphasized",
          css: {
            paddingLeft: "$quarter"
          },
          children: body
        }
      )
    ]
  }
);

// src/components/composable-cta-card/composable-cta-card.component.tsx
import { jsx as jsx14, jsxs as jsxs7 } from "react/jsx-runtime";
var imagePositionTopHeight = "220px";
var imagePositionRightHeight = "150px";
var imagePositionResponsiveHeight = "auto";
var IMAGE_HEIGHT = {
  right: imagePositionRightHeight,
  top: imagePositionTopHeight,
  responsive: imagePositionResponsiveHeight
};
function ComposableCTACard({
  id,
  badge,
  body,
  contentSlot,
  cta,
  eyebrow,
  footer,
  headline,
  image,
  title,
  spacing,
  onClick,
  cardContentAlignment = "center",
  backgroundColor = "secondary"
}) {
  const aboveMobileBreakpoint = queryHelpers5.up("mobileLandscape");
  const belowMobileBreakpoint = queryHelpers5.down("mobileLandscape");
  const isBelowMobile = useMediaQuery5(belowMobileBreakpoint);
  const isImageResponsive = (image == null ? void 0 : image.imagePosition) === "responsive";
  const isImageRight = (image == null ? void 0 : image.imagePosition) === "right";
  const showBadgeOverImage = badge && (badge == null ? void 0 : badge.positionOverImage) && image && (!isImageRight || isBelowMobile);
  const autoId = useUniqueId({ prefix: "composable-cta-card" });
  const titleId = id ? `composable-cta-card_${id}` : autoId;
  const showCTA = cta && cta.text && onClick;
  const baseImageStyles = {
    borderWidth: "$card",
    borderColor: "$onSurfaceBorderCard",
    borderStyle: "solid",
    borderBottomStyle: "none",
    objectFit: "cover",
    objectPosition: "center",
    display: "block",
    height: "100%"
  };
  return /* @__PURE__ */ jsx14(
    Card6.Flat,
    {
      backgroundColor,
      css: {
        borderRadius: "$none",
        border: "none",
        height: "100%",
        containerType: isImageResponsive ? "inline-size" : "normal"
      },
      children: /* @__PURE__ */ jsxs7(
        StackLayout5,
        {
          horizontalAlignment: "stretch",
          css: {
            [`@container ${aboveMobileBreakpoint}`]: {
              flexDirection: "row"
            }
          },
          children: [
            image && !isImageRight && /* @__PURE__ */ jsxs7(
              Box4,
              {
                css: __spreadValues({
                  position: "relative",
                  width: "100%",
                  height: IMAGE_HEIGHT[image.imagePosition]
                }, isImageResponsive && {
                  maxWidth: "40%",
                  [`@container ${belowMobileBreakpoint}`]: {
                    height: IMAGE_HEIGHT.top,
                    maxWidth: "unset"
                  }
                }),
                children: [
                  showBadgeOverImage && /* @__PURE__ */ jsx14(
                    ComposableCTACardBadge,
                    {
                      testId: "cta-image-badge",
                      css: {
                        position: "absolute",
                        top: "$one",
                        right: "$one",
                        border: "thin solid $onSurfaceBorderCard"
                      },
                      backgroundColor: badge.backgroundColor,
                      image: badge.image,
                      imageTint: badge.imageTint,
                      body: badge.body
                    }
                  ),
                  /* @__PURE__ */ jsx14(
                    Card6.Image,
                    {
                      image: image.image,
                      imageAlt: image.altText,
                      css: __spreadValues({}, baseImageStyles)
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ jsxs7(
              StackLayout5,
              {
                horizontalAlignment: "stretch",
                verticalAlignment: "stretch",
                css: {
                  height: "auto"
                },
                children: [
                  headline,
                  /* @__PURE__ */ jsxs7(
                    Box4,
                    {
                      css: {
                        borderWidth: "$card",
                        borderColor: "$onSurfaceBorderCard",
                        borderStyle: "solid",
                        display: "flex",
                        flexDirection: "column",
                        flexGrow: 1
                      },
                      children: [
                        /* @__PURE__ */ jsx14(
                          Card6.Section,
                          {
                            css: {
                              display: "flex",
                              alignItems: cardContentAlignment
                            },
                            children: /* @__PURE__ */ jsxs7(
                              StackLayout5,
                              {
                                orientation: "horizontal",
                                spacing: "$threeQuarters",
                                verticalAlignment: "center",
                                children: [
                                  /* @__PURE__ */ jsxs7(StackLayout5, { spacing: spacing || "$threeQuarters", children: [
                                    badge && !showBadgeOverImage && /* @__PURE__ */ jsx14(
                                      ComposableCTACardBadge,
                                      {
                                        testId: "cta-card-badge",
                                        backgroundColor: badge.backgroundColor,
                                        image: badge.image,
                                        imageTint: badge.imageTint,
                                        body: badge.body
                                      }
                                    ),
                                    eyebrow,
                                    (title || body) && /* @__PURE__ */ jsxs7(
                                      StackLayout5,
                                      {
                                        spacing: spacing || "$threeQuarters",
                                        horizontalAlignment: "stretch",
                                        verticalAlignment: "center",
                                        css: {
                                          width: "100%"
                                        },
                                        children: [
                                          title && /* @__PURE__ */ jsx14(
                                            HeadingText4,
                                            {
                                              id: titleId,
                                              size: title.size || "sm",
                                              level: title.level,
                                              emphasis: title.textEmphasis,
                                              children: title.text
                                            }
                                          ),
                                          body
                                        ]
                                      }
                                    ),
                                    footer,
                                    contentSlot && /* @__PURE__ */ jsx14(Box4, { css: { width: "100%" }, children: contentSlot })
                                  ] }),
                                  image && isImageRight && /* @__PURE__ */ jsx14(
                                    Box4,
                                    {
                                      css: {
                                        $$maxImageWidth: "148px",
                                        $$maxWidthDesktop: "148px",
                                        maxHeight: "$$maxImageWidth",
                                        maxWidth: "$$maxImageWidth",
                                        aspectRatio: "1 / 1",
                                        flex: 1,
                                        overflow: "hidden",
                                        "@tablet": {
                                          maxHeight: "$$maxWidthDesktop",
                                          maxWidth: "$$maxWidthDesktop"
                                        },
                                        display: "block",
                                        [`@container ${aboveMobileBreakpoint}`]: {
                                          display: "none"
                                        }
                                      },
                                      children: /* @__PURE__ */ jsx14(
                                        Card6.Image,
                                        {
                                          image: image.image,
                                          imageAlt: image.altText,
                                          css: {
                                            // to make square image
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover"
                                          }
                                        }
                                      )
                                    }
                                  )
                                ]
                              }
                            )
                          }
                        ),
                        showCTA && /* @__PURE__ */ jsx14(
                          Box4,
                          {
                            css: {
                              width: "fillContainer",
                              borderTopWidth: "$thin",
                              borderTopColor: "$onSurfaceBorderCard",
                              borderTopStyle: "solid",
                              paddingTop: "$oneAndHalf"
                            },
                            children: /* @__PURE__ */ jsx14(Card6.Section, { css: { paddingTop: "$none", flexGrow: 0 }, children: React3.createElement(
                              (cta == null ? void 0 : cta.component) || ComposableCTACardButton,
                              {
                                text: cta.text,
                                onClick,
                                titleId: title ? titleId : void 0,
                                indicator: cta.indicator
                              }
                            ) })
                          }
                        )
                      ]
                    }
                  )
                ]
              }
            )
          ]
        }
      )
    }
  );
}

// src/components/rewards-hub-cta-card/rewards-hub-cta-card.component.tsx
import { jsx as jsx15 } from "react/jsx-runtime";
var RewardsHubCTACard = ({
  overline,
  cta,
  contentSlot,
  onClick
}) => {
  const headline = overline && overline.text && /* @__PURE__ */ jsx15(
    ComposableCTACardHeadline,
    {
      text: overline.text,
      icon: overline.icon,
      iconAltText: overline.iconAltText,
      backgroundColor: overline.backgroundColor,
      color: "$onSurfaceTextPrimary",
      css: {
        border: "thin solid $onSurfaceBorderDefault",
        borderBlockEnd: "none"
      }
    }
  );
  return /* @__PURE__ */ jsx15(
    ComposableCTACard,
    {
      backgroundColor: "primary",
      headline,
      contentSlot,
      cta: { text: (cta == null ? void 0 : cta.text) || "" },
      onClick
    }
  );
};

// src/components/rewards-hub-loader/rewards-hub-loader.component.tsx
import { useEffect as useEffect3, useState as useState3 } from "react";
import {
  Box as Box5,
  HeadingText as HeadingText5,
  Icon as Icon3,
  StackLayout as StackLayout6,
  VisuallyHidden as VisuallyHidden4,
  keyframes
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl4 } from "@leagueplatform/locales";
import giftIcon from "./assets/rewards-hub-loader-gift.svg";
import cafeIcon from "./assets/rewards-hub-loader-cafe.svg";
import retailIcon from "./assets/rewards-hub-loader-retail.svg";
import airplaneIcon from "./assets/rewards-hub-loader-airplane.svg";
import rewardsIcon from "./assets/rewards-hub-loader-rewards.svg";
import { jsx as jsx16, jsxs as jsxs8 } from "react/jsx-runtime";
var CYCLE_INTERVAL_MS = 5e3;
var shimmer = keyframes({
  "0%": { transform: "translateX(-100%)" },
  "100%": { transform: "translateX(100%)" }
});
var iconBounce = keyframes({
  "0%, 100%": { transform: "translateY(0)" },
  "50%": { transform: "translateY(-8px)" }
});
var MESSAGES = [
  { id: "REWARDS_HUB_LOADER_OFFERS_LOADING", icon: giftIcon },
  { id: "REWARDS_HUB_LOADER_WORKING_ON_IT", icon: cafeIcon },
  { id: "REWARDS_HUB_LOADER_PREPARING", icon: retailIcon },
  { id: "REWARDS_HUB_LOADER_ALMOST_THERE", icon: airplaneIcon },
  { id: "REWARDS_HUB_LOADER_FINALIZING", icon: rewardsIcon }
];
var RewardsHubLoader = ({
  rootElementRef
} = {}) => {
  const { formatMessage } = useIntl4();
  const [index, setIndex] = useState3(0);
  useEffect3(() => {
    const id2 = setInterval(() => {
      setIndex((prev) => (prev + 1) % MESSAGES.length);
    }, CYCLE_INTERVAL_MS);
    return () => clearInterval(id2);
  }, []);
  const { id, icon } = MESSAGES[index];
  return /* @__PURE__ */ jsxs8(
    Box5,
    {
      ref: rootElementRef,
      css: {
        backgroundColor: "$surfaceSkeletonShimmerBackground",
        borderRadius: "$medium",
        width: "100%",
        minHeight: "480px",
        padding: "$two",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          backgroundImage: "$surfaceSkeletonShimmerOverlay",
          animation: `${shimmer} 1.8s ease-in-out infinite`,
          pointerEvents: "none"
        },
        "@media (prefers-reduced-motion: reduce)": {
          "&::before": { animation: "none" }
        }
      },
      children: [
        /* @__PURE__ */ jsx16(VisuallyHidden4, { role: "status", children: formatMessage({ id: "REWARDS_HUB_LOADER_OFFERS_LOADING" }) }),
        /* @__PURE__ */ jsxs8(
          StackLayout6,
          {
            "aria-hidden": "true",
            horizontalAlignment: "center",
            verticalAlignment: "center",
            css: { gap: "$one", position: "relative", zIndex: 1 },
            children: [
              /* @__PURE__ */ jsx16(
                Box5,
                {
                  css: {
                    display: "flex",
                    animation: `${iconBounce} 1.2s ease-in-out infinite`,
                    "@media (prefers-reduced-motion: reduce)": { animation: "none" }
                  },
                  children: /* @__PURE__ */ jsx16(Icon3, { icon, size: "$oneAndHalf" })
                }
              ),
              /* @__PURE__ */ jsx16(
                HeadingText5,
                {
                  level: "3",
                  size: "md",
                  css: { color: "$onSurfaceTextPrimary" },
                  children: formatMessage({ id })
                }
              )
            ]
          }
        )
      ]
    }
  );
};

// src/components/masonry/masonry-content-block-renderer-override/masonry-content-block-renderer-override.component.tsx
import { MasonryContentBlockRenderer } from "@leagueplatform/masonry-renderers";
import { jsx as jsx17 } from "react/jsx-runtime";
var MasonryContentBlockRendererOverride = (props) => /* @__PURE__ */ jsx17(
  MasonryContentBlockRenderer,
  __spreadValues({
    css: {
      "& .GDS-paragraph-text": {
        typography: "$bodyOne"
      },
      "& .GDS-heading-text": {
        marginBottom: "$half"
      },
      "& .GDS-paragraph-text p": {
        marginBottom: "$half"
      },
      "& .GDS-paragraph-text p:last-child": {
        marginBottom: 0
      },
      '&[data-testid="contentBlock$rewardableTaskOverview$web$rootRewardsHowToEarnBody"] > .GDS-paragraph-text > p + h3.GDS-heading-text': {
        marginTop: "$one"
      }
    }
  }, props)
);

// src/components/masonry/masonry-modal-content-block-renderer-override/masonry-modal-content-block-renderer-override.component.tsx
import { MasonryContentBlockRenderer as MasonryContentBlockRenderer2 } from "@leagueplatform/masonry-renderers";
import { jsx as jsx18 } from "react/jsx-runtime";
var MasonryModalContentBlockRendererOverride = (props) => /* @__PURE__ */ jsx18(
  MasonryContentBlockRenderer2,
  __spreadValues({
    css: {
      ".GDS-modal-content:has(&)": {
        padding: "$three",
        paddingBlockStart: "$none"
      }
    }
  }, props)
);

// src/components/masonry/masonry-empty-state-content-block-renderer-override/masonry-empty-state-content-block-renderer-override.component.tsx
import { MasonryContentBlockRenderer as MasonryContentBlockRenderer3 } from "@leagueplatform/masonry-renderers";
import { jsx as jsx19 } from "react/jsx-runtime";
var MasonryEmptyStateContentBlockRendererOverride = (props) => /* @__PURE__ */ jsx19(
  MasonryContentBlockRenderer3,
  __spreadValues({
    css: {
      backgroundColor: "$surfaceBackgroundPrimary",
      borderColor: "$onSurfaceBorderSubdued",
      borderStyle: "solid",
      borderWidth: "$thin",
      paddingBlock: "$four",
      paddingInline: "$three",
      "& .GDS-paragraph-text": {
        typography: "$bodyTwo"
      },
      "& .GDS-heading-text": {
        typography: "$subtitleOne"
      }
    }
  }, props)
);

// src/components/browse-rewards-cta-card/browse-rewards-cta-card.component.tsx
import { ParagraphText } from "@leagueplatform/genesis-core";
import { useIntl as useIntl5 } from "@leagueplatform/locales";
import { isExternalUrl } from "@leagueplatform/web-common";
import { jsx as jsx20 } from "react/jsx-runtime";
var BrowseRewardsCtaCard = ({
  heading,
  body,
  image,
  imageAltText,
  ctaText,
  onClick
}) => {
  var _a;
  const onClickDeeplinkAction = onClick;
  const { formatMessage } = useIntl5();
  const isExternal = isExternalUrl((_a = onClickDeeplinkAction == null ? void 0 : onClickDeeplinkAction.payload) == null ? void 0 : _a.url);
  const imageProps = {
    image,
    altText: imageAltText,
    imagePosition: "top"
  };
  const bodyContent = body && /* @__PURE__ */ jsx20(ParagraphText, { children: body });
  return /* @__PURE__ */ jsx20(
    ComposableCTACard,
    {
      backgroundColor: "primary",
      title: { text: heading, level: "3" },
      body: bodyContent,
      image: imageProps,
      cta: __spreadValues({
        text: ctaText || formatMessage({ id: "EXPLORE_NOW" })
      }, isExternal && { indicator: "externalLink" }),
      onClick: onClickDeeplinkAction
    }
  );
};

// src/components/icon-text/icon-text.component.tsx
import {
  Box as Box6,
  Icon as Icon4,
  TextAction as TextAction4,
  UtilityText as UtilityText6,
  HeadingText as HeadingText6
} from "@leagueplatform/genesis-core";
import { useMasonryEngineActionEmitter as useMasonryEngineActionEmitter2 } from "@leagueplatform/masonry-engine";
import { jsx as jsx21, jsxs as jsxs9 } from "react/jsx-runtime";
var isLinkAction = (action) => {
  var _a;
  return Boolean((action == null ? void 0 : action.type) === "deeplink" && ((_a = action == null ? void 0 : action.payload) == null ? void 0 : _a.url));
};
var clickableFocusStyles = {
  width: "fit-content",
  "&:has(:focus)": {
    outline: "$borderWidths$outerFocus solid $interactiveFocusOuter",
    outlineOffset: "$borderWidths$outerFocus",
    borderRadius: "$small"
  }
};
var textActionStyles = {
  color: "$onSurfaceTextPrimary !important",
  "&:focus": {
    outline: "none !important",
    boxShadow: "none !important"
  }
};
var IconTextRenderer = ({
  icon,
  text,
  iconAltText,
  onClick,
  headingLevel
}) => {
  const invokeAction = useMasonryEngineActionEmitter2();
  const isLink = isLinkAction(onClick);
  const handleClick = (event) => onClick && invokeAction(__spreadValues({ event }, onClick));
  const textActionCss = __spreadValues({
    typography: "$buttonTwo"
  }, textActionStyles);
  const renderText = () => {
    var _a;
    if (!onClick) {
      return /* @__PURE__ */ jsx21(
        UtilityText6,
        {
          css: {
            typography: "$subtitleOne",
            display: "inline",
            verticalAlign: "middle"
          },
          children: text
        }
      );
    }
    if (isLink) {
      return /* @__PURE__ */ jsx21(
        TextAction4,
        {
          href: (_a = onClick.payload) == null ? void 0 : _a.url,
          onClick: handleClick,
          css: __spreadProps(__spreadValues({}, textActionCss), { verticalAlign: "middle" }),
          children: text
        }
      );
    }
    return /* @__PURE__ */ jsx21(
      TextAction4,
      {
        as: "button",
        onClick: handleClick,
        css: __spreadProps(__spreadValues({}, textActionCss), {
          display: "inline-block",
          verticalAlign: "middle"
        }),
        children: text
      }
    );
  };
  return /* @__PURE__ */ jsxs9(
    Box6,
    {
      css: __spreadValues({
        display: "block"
      }, onClick && clickableFocusStyles),
      children: [
        /* @__PURE__ */ jsx21(
          Icon4,
          {
            size: "$oneAndHalf",
            icon,
            label: iconAltText,
            css: {
              display: "inline-block",
              verticalAlign: "middle",
              marginInlineEnd: "$threeQuarters"
            }
          }
        ),
        headingLevel ? (
          // Heading variant (Aeroplan tile, MANU-5676) is intentionally never
          // interactive — the text is rendered directly in the heading so there is
          // no redundant <span> and no link/button inside the <h2>. UtilityText's
          // $subtitleOne typography is applied here so the appearance is unchanged.
          /* @__PURE__ */ jsx21(
            HeadingText6,
            {
              level: headingLevel,
              size: "sm",
              css: {
                margin: 0,
                typography: "$subtitleOne",
                display: "inline",
                verticalAlign: "middle"
              },
              children: text
            }
          )
        ) : renderText()
      ]
    }
  );
};
var IconTextHeadingRenderer = (props) => /* @__PURE__ */ jsx21(IconTextRenderer, __spreadProps(__spreadValues({}, props), { headingLevel: "2" }));

// src/components/rewards-points-disclaimer-header/rewards-points-disclaimer-header.component.tsx
import {
  HeadingText as HeadingText7,
  StackLayout as StackLayout7,
  UtilityText as UtilityText7
} from "@leagueplatform/genesis-core";
import { jsx as jsx22, jsxs as jsxs10 } from "react/jsx-runtime";
var RewardsPointsDisclaimerHeader = ({
  heading,
  headingLevel = "3",
  subtitle,
  paddingTop
}) => /* @__PURE__ */ jsxs10(
  StackLayout7,
  {
    verticalAlignment: "center",
    spacing: "$half",
    css: {
      paddingTop
    },
    children: [
      /* @__PURE__ */ jsx22(HeadingText7, { size: "lg", level: headingLevel, children: heading }),
      subtitle && /* @__PURE__ */ jsx22(UtilityText7, { size: "sm", children: subtitle })
    ]
  }
);

// src/components/points-history-month-year-section-header/points-history-month-year-section-header.component.tsx
import { MasonrySectionHeaderRenderer as MasonrySectionHeaderRenderer2 } from "@leagueplatform/masonry-renderers";
import { jsx as jsx23 } from "react/jsx-runtime";
var PointsHistoryMonthYearSectionHeader = (_a) => {
  var _b = _a, { css, headingLevel: _headingLevel } = _b, props = __objRest(_b, ["css", "headingLevel"]);
  return /* @__PURE__ */ jsx23(
    MasonrySectionHeaderRenderer2,
    __spreadProps(__spreadValues({}, props), {
      headingLevel: "display",
      css: __spreadProps(__spreadValues({}, css), {
        "& .GDS-heading-text": {
          typography: "$overline"
        }
      })
    })
  );
};

// src/components/rewards-history-points-card/rewards-history-points-card.component.tsx
import { useIntl as useIntl6 } from "@leagueplatform/locales";

// src/components/rewards-history-points-card/rewards-history-points-card-content.component.tsx
import {
  Box as Box7,
  HeadingText as HeadingText8,
  Icon as Icon5,
  ParagraphText as ParagraphText2,
  StackLayout as StackLayout8,
  UtilityText as UtilityText8,
  VisuallyHidden as VisuallyHidden5
} from "@leagueplatform/genesis-core";
import { Badge as Badge2 } from "@leagueplatform/web-common-components";
import { Fragment, jsx as jsx24, jsxs as jsxs11 } from "react/jsx-runtime";
function RewardsHistoryPointsCardContent({
  heading,
  body,
  badges
}) {
  var _a, _b, _c, _d, _e, _f;
  return /* @__PURE__ */ jsxs11(StackLayout8, { spacing: "$quarter", children: [
    /* @__PURE__ */ jsxs11(
      StackLayout8,
      {
        orientation: "horizontal",
        horizontalAlignment: "spaceBetween",
        spacing: "$two",
        css: {
          width: "100%"
        },
        children: [
          /* @__PURE__ */ jsx24(
            HeadingText8,
            {
              level: "3",
              size: "xs",
              css: {
                typography: "$subtitleTwo"
              },
              children: heading
            }
          ),
          /* @__PURE__ */ jsxs11(Box7, { css: { display: "inline-flex" }, children: [
            /* @__PURE__ */ jsx24(VisuallyHidden5, { children: ((_a = badges == null ? void 0 : badges[0]) == null ? void 0 : _a.imageAltText) ? `${badges[0].imageAltText}, ${(_b = badges == null ? void 0 : badges[0]) == null ? void 0 : _b.body}` : (_c = badges == null ? void 0 : badges[0]) == null ? void 0 : _c.body }),
            /* @__PURE__ */ jsx24(Box7, { "aria-hidden": "true", css: { display: "inline-flex" }, children: /* @__PURE__ */ jsx24(
              Badge2,
              {
                css: {
                  backgroundColor: "$surfaceBackgroundPrimary",
                  padding: "none"
                },
                children: /* @__PURE__ */ jsxs11(Fragment, { children: [
                  /* @__PURE__ */ jsx24(
                    Icon5,
                    {
                      icon: (_d = badges == null ? void 0 : badges[0]) == null ? void 0 : _d.image,
                      size: "$one",
                      label: (_e = badges == null ? void 0 : badges[0]) == null ? void 0 : _e.imageAltText
                    }
                  ),
                  /* @__PURE__ */ jsx24(UtilityText8, { size: "sm", emphasis: "emphasized", children: (_f = badges == null ? void 0 : badges[0]) == null ? void 0 : _f.body })
                ] })
              }
            ) })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsx24(
      ParagraphText2,
      {
        css: {
          typography: "$caption",
          color: "$onSurfaceTextSubdued"
        },
        children: body
      }
    )
  ] });
}

// src/components/rewards-history-points-card/rewards-history-points-card.component.tsx
import { jsx as jsx25 } from "react/jsx-runtime";
var RewardsHistoryPointsCard = ({
  heading,
  body,
  ctaLabel,
  badges,
  onClick
}) => {
  const { formatMessage } = useIntl6();
  return /* @__PURE__ */ jsx25(
    ComposableCTACard,
    {
      backgroundColor: "primary",
      body: /* @__PURE__ */ jsx25(
        RewardsHistoryPointsCardContent,
        {
          heading,
          body,
          badges
        }
      ),
      cta: {
        text: ctaLabel || formatMessage({ id: "VIEW_CONTENT" })
      },
      onClick
    }
  );
};

// src/components/masonry/masonry-points-history-small-card-renderer/masonry-points-history-small-card-renderer.tsx
import { MasonrySmallCardRenderer as MasonrySmallCardRenderer2 } from "@leagueplatform/masonry-renderers";
import { jsx as jsx26 } from "react/jsx-runtime";
var ZERO_WIDTH_SPACE = "\u200B";
var MasonryPointsHistorySmallCardRenderer = (_a) => {
  var _b = _a, { body } = _b, props = __objRest(_b, ["body"]);
  return /* @__PURE__ */ jsx26(
    MasonrySmallCardRenderer2,
    __spreadValues({
      body: body || ZERO_WIDTH_SPACE,
      css: __spreadProps(__spreadValues({}, !body && {
        "& .GDS-paragraph-text": {
          display: "none"
        }
      }), {
        "& .GDS-horizontal-stack-layout:has(> .GDS-icon)": {
          paddingBlock: "$eighth"
        },
        "& .GDS-vertical-stack-layout": {
          marginTop: "$none"
        },
        "& > :first-child": {
          padding: "$one"
        }
      })
    }, props)
  );
};

// src/components/masonry/masonry-tabs-renderer/masonry-tabs-renderer.component.tsx
import { MasonryTabsRenderer } from "@leagueplatform/masonry-renderers";
import { jsx as jsx27 } from "react/jsx-runtime";
var tabStyleOverrides = {
  ".GDS-tab-list": {
    gap: 0
  },
  ".GDS-tab-list > button, .GDS-tab-list, .GDS-tab-list-wrapper": {
    backgroundColor: "#ededed"
  },
  ".GDS-tab-list > button": {
    padding: "$oneAndHalf $threeQuarters",
    // Fix font color for inactive tabs
    color: "$onSurfaceTextSubdued",
    // Set all tabs to font-weight 500 to prevent layout shift
    fontWeight: "500",
    borderBlockEndWidth: "4px",
    borderBlockEndColor: "transparent",
    borderBlockEndStyle: "solid"
  },
  // Active tab styling - stroke width (4px), color (green), and font color
  '.GDS-tab-list > button[data-state="active"]': {
    color: "$onSurfaceTextPrimary",
    borderBlockEndColor: "$interactiveActionPrimary",
    // Add 0.5px text-stroke to simulate font-weight 600 without causing layout shift
    // This prevents layout shift when switching between tabs
    WebkitTextStroke: "0.5px currentColor"
  },
  // Hover state for inactive tabs only - active tab keeps green border
  '.GDS-tab-list > button:not([data-state="active"]):hover': {
    borderBlockEndColor: "$interactiveActionDisabled",
    WebkitTextStroke: "0.5px currentColor"
  }
};
var MasonryTabRendererOverride = (props) => /* @__PURE__ */ jsx27(MasonryTabsRenderer, __spreadValues({ css: tabStyleOverrides }, props));

// src/components/recommended-content-card/recommended-content-card.component.tsx
import { useIntl as useIntl7 } from "@leagueplatform/locales";
import { UtilityText as UtilityText10 } from "@leagueplatform/genesis-core";

// src/components/recommended-content-card/recommended-content-card-body/recommended-content-card-body.component.tsx
import {
  StackLayout as StackLayout9,
  StackItem,
  Icon as Icon6,
  UtilityText as UtilityText9
} from "@leagueplatform/genesis-core";
import { Badge as Badge3 } from "@leagueplatform/web-common-components";

// src/components/recommended-content-card/recommended-content-card.utils.ts
import {
  colorTokenMap
} from "@leagueplatform/genesis-core";
var isColorToken = (value) => Object.prototype.hasOwnProperty.call(colorTokenMap, value);
var resolveBadgeBackgroundColor = (color) => {
  if (!color)
    return colorTokenMap.surfaceBackgroundPrimary;
  if (isColorToken(color))
    return colorTokenMap[color];
  return color;
};

// src/components/recommended-content-card/recommended-content-card-body/recommended-content-card-body.component.tsx
import { jsx as jsx28, jsxs as jsxs12 } from "react/jsx-runtime";
var RecommendedContentCardBody = ({
  subheading,
  body,
  bodyBadges
}) => {
  const displayRecommendedContentCardBody = subheading || body || bodyBadges;
  const showBodyBadges = bodyBadges && bodyBadges.length > 0;
  if (!displayRecommendedContentCardBody)
    return null;
  return /* @__PURE__ */ jsxs12(StackLayout9, { spacing: "$half", children: [
    subheading && /* @__PURE__ */ jsx28(UtilityText9, { as: "p", css: { typography: "$bodyTwo" }, children: subheading }),
    body && /* @__PURE__ */ jsx28(UtilityText9, { as: "p", css: { color: "$onSurfaceTextSubdued" }, children: body }),
    showBodyBadges && /* @__PURE__ */ jsx28(
      StackItem,
      {
        horizontalAlignment: "center",
        css: {
          flexDirection: "row",
          gap: "$half"
        },
        children: bodyBadges.map((badge) => /* @__PURE__ */ jsxs12(
          Badge3,
          {
            css: {
              backgroundColor: resolveBadgeBackgroundColor(
                badge.backgroundColor
              )
            },
            children: [
              /* @__PURE__ */ jsx28(Icon6, { icon: badge.image, size: "$one" }),
              /* @__PURE__ */ jsx28(UtilityText9, { children: badge.label })
            ]
          },
          badge.label
        ))
      }
    )
  ] });
};

// src/components/recommended-content-card/recommended-content-card.component.tsx
import { jsx as jsx29 } from "react/jsx-runtime";
var RecommendedContentCard = ({
  image,
  imageAltText,
  heading,
  eyebrow,
  body,
  subheading,
  badge,
  bodyBadges,
  ctaText,
  onClick
}) => {
  const { formatMessage } = useIntl7();
  const imageProps = {
    image,
    altText: imageAltText || "",
    imagePosition: "responsive"
  };
  const formattedBadge = badge && badge.label && badge.backgroundColor ? {
    body: badge.label,
    image: badge.image,
    backgroundColor: resolveBadgeBackgroundColor(badge.backgroundColor),
    positionOverImage: true
  } : void 0;
  return /* @__PURE__ */ jsx29(
    ComposableCTACard,
    {
      body: /* @__PURE__ */ jsx29(
        RecommendedContentCardBody,
        {
          subheading,
          body,
          bodyBadges
        }
      ),
      image: imageProps,
      title: {
        text: heading,
        level: "3"
      },
      badge: formattedBadge,
      eyebrow: /* @__PURE__ */ jsx29(UtilityText10, { size: "eyebrow", css: { typography: "$overline" }, children: eyebrow }),
      cta: {
        text: ctaText || formatMessage({ id: "VIEW_CONTENT" })
      },
      spacing: "$half",
      onClick,
      cardContentAlignment: "start"
    }
  );
};

// src/components/activity-card/activity-card.component.tsx
import { useIntl as useIntl13 } from "@leagueplatform/locales";
import { CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION as CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION2 } from "@leagueplatform/health-journey-common";

// src/components/activity-card/components/activity-card-body/activity-card-body.component.tsx
import { useIntl as useIntl12 } from "@leagueplatform/locales";
import {
  StackLayout as StackLayout11,
  StackItem as StackItem3,
  Icon as Icon9,
  UtilityText as UtilityText13
} from "@leagueplatform/genesis-core";
import { Badge as Badge4 } from "@leagueplatform/web-common-components";
import { CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION } from "@leagueplatform/health-journey-common";
import aeroplanIcon from "./assets/aeroplan-icon.svg";
import rewardsIcon2 from "./assets/rewards-icon.svg";
import requiredIcon from "./assets/required-icon.svg";

// src/hooks/useActivityCardDate/useActivityCardDate.hook.tsx
import { useGetUserProfile as useGetUserProfile2 } from "@leagueplatform/health-journey-common";
import { useIntl as useIntl8 } from "@leagueplatform/locales";
import { SHORT_DATE_FORMAT } from "@leagueplatform/web-common";
var useActivityCardDate = (endDate, canExpire, required) => {
  const { formatMessage, formatDate } = useIntl8();
  const { data: userProfileData } = useGetUserProfile2();
  const { defaultTimezone } = userProfileData || {};
  const displayCompleteBy = canExpire && !!endDate && required;
  const displayExpiryDate = canExpire && !!endDate && !required;
  if (displayCompleteBy) {
    return formatMessage(
      { id: "COMPLETE_BY_DATE" },
      {
        date: formatDate(endDate, __spreadProps(__spreadValues({}, SHORT_DATE_FORMAT), {
          timeZone: defaultTimezone
        }))
      }
    );
  }
  if (displayExpiryDate) {
    return formatMessage(
      { id: "ACTIVITY_EXPIRY_DATE" },
      {
        date: formatDate(endDate, __spreadProps(__spreadValues({}, SHORT_DATE_FORMAT), {
          timeZone: defaultTimezone
        }))
      }
    );
  }
  return void 0;
};

// src/components/composable-cta-card/components/composable-cta-card-progress-bar/composable-cta-card-progress-bar.component.tsx
import {
  Box as Box8,
  Icon as Icon7,
  ParagraphText as ParagraphText3,
  StackItem as StackItem2,
  StackLayout as StackLayout10,
  UtilityText as UtilityText11
} from "@leagueplatform/genesis-core";
import { ProgressBar as ProgressBar2 } from "@leagueplatform/web-common-components";
import { useIntl as useIntl11 } from "@leagueplatform/locales";

// src/hooks/use-locale-metric-value-formatter/use-locale-metric-value-formatter.hook.ts
import { useIntl as useIntl9 } from "@leagueplatform/locales";
var digits = {
  distance: 1,
  steps: 0,
  active_duration: 0,
  mindful_duration: 0,
  floors_climbed: 0,
  energy_burned: 0
};
function useLocaleMetricValueFormatter() {
  const { formatNumber } = useIntl9();
  function formatMetricValue(value, type) {
    const maximumFractionDigits = digits[type];
    if (value === null) {
      return null;
    }
    return formatNumber(value, { maximumFractionDigits });
  }
  return { formatMetricValue };
}

// src/hooks/use-locale-unit-formatter/use-locale-unit-formatter.hook.ts
import { useIntl as useIntl10 } from "@leagueplatform/locales";

// src/types/metrics.types.ts
var metricUnits = [
  "count",
  "s",
  "m",
  "min",
  "cal",
  "kcal",
  "bmp",
  "km",
  "mg/dl"
];

// src/hooks/use-locale-unit-formatter/use-locale-unit-formatter.hook.ts
function useLocaleUnitFormatter() {
  const { $tmap } = useIntl10();
  const getMetricUnit = $tmap({
    steps: "INSIGHT_CARD_UNIT_STEPS",
    floors_climbed: "INSIGHT_CARD_UNIT_FLOORS_CLIMBED"
  });
  const getUnit = $tmap({
    count: "COUNT",
    s: "S",
    m: "M",
    min: "MIN",
    cal: "CAL",
    kcal: "KCAL",
    bmp: "BMP",
    km: "KM",
    "mg/dl": "MG/DL"
  });
  const formatUnit = (type, unit, value = 0) => {
    if (type === "steps" || type === "floors_climbed") {
      return getMetricUnit(type, { count: value });
    }
    if (metricUnits.includes(unit)) {
      return getUnit(unit, { count: value });
    }
    return `${value} ${unit}`;
  };
  return { formatUnit };
}

// src/components/composable-cta-card/components/composable-cta-card-progress-bar/composable-cta-card-progress-bar.component.tsx
import { jsx as jsx30, jsxs as jsxs13 } from "react/jsx-runtime";
var styledText = (msg) => /* @__PURE__ */ jsx30(
  UtilityText11,
  {
    emphasis: "emphasized",
    css: {
      color: "$onSurfaceTextSuccess"
    },
    children: msg
  }
);
var ComposableCTACardProgressBar = ({
  progress,
  goal,
  unit,
  type,
  icon
}) => {
  const { formatMessage } = useIntl11();
  const { formatMetricValue } = useLocaleMetricValueFormatter();
  const { formatUnit } = useLocaleUnitFormatter();
  return /* @__PURE__ */ jsxs13(StackLayout10, { spacing: "$half", css: { width: "100%" }, children: [
    /* @__PURE__ */ jsxs13(StackItem2, { css: { display: "block" }, children: [
      icon && /* @__PURE__ */ jsx30(
        Box8,
        {
          css: {
            display: "inline-block",
            verticalAlign: "middle",
            marginInlineEnd: "$quarter"
          },
          children: /* @__PURE__ */ jsx30(Icon7, { icon, size: "$one" })
        }
      ),
      /* @__PURE__ */ jsx30(ParagraphText3, { as: "span", emphasis: "subtle", children: formatMessage(
        { id: "X_OF_Y_COMPLETED_WITH_UNIT" },
        {
          progress: formatMetricValue(progress, type),
          goal: formatMetricValue(goal, type),
          unit: formatUnit(type, unit, progress),
          span: styledText
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx30(StackItem2, { css: { width: "100%" }, children: /* @__PURE__ */ jsx30(
      ProgressBar2,
      {
        current: progress,
        total: goal,
        customBarFillColor: "success.icon",
        customBarBackgroundColor: "input.background.disabled"
      }
    ) })
  ] });
};

// src/components/icon-text-layout/icon-text-layout.component.tsx
import {
  Box as Box9,
  Icon as Icon8,
  UtilityText as UtilityText12
} from "@leagueplatform/genesis-core";
import { jsx as jsx31, jsxs as jsxs14 } from "react/jsx-runtime";
var IconTextLayout = ({
  iconProps,
  textProps,
  css
}) => {
  const {
    icon,
    css: iconStyles,
    size = "$one",
    tint = "$decorativeBrandSecondaryDarkest",
    label
  } = iconProps;
  const { css: textStyles, title } = textProps;
  return /* @__PURE__ */ jsxs14(Box9, { css: __spreadValues({ display: "block" }, css), children: [
    /* @__PURE__ */ jsx31(
      Icon8,
      {
        icon,
        size,
        tint,
        label,
        css: __spreadValues({
          display: "inline-block",
          verticalAlign: "middle",
          marginInlineEnd: "$quarter"
        }, iconStyles)
      }
    ),
    /* @__PURE__ */ jsx31(
      UtilityText12,
      __spreadProps(__spreadValues({}, textProps), {
        css: __spreadValues({ display: "inline", verticalAlign: "middle" }, textStyles),
        children: title
      })
    )
  ] });
};

// src/utilities/check-progress-data.util.ts
function checkProgressData(data) {
  return data.currentProgress !== void 0 && data.currentProgress !== null && data.goalTotal !== void 0 && data.goalTotal !== null && data.dataType !== void 0 && data.dataType !== null && data.unit !== void 0 && data.unit !== null;
}

// src/components/activity-card/components/activity-card-body/activity-card-body.component.tsx
import { jsx as jsx32, jsxs as jsxs15 } from "react/jsx-runtime";
var ActivityCardBody = ({
  activity
}) => {
  const { formatMessage } = useIntl12();
  const {
    required,
    progress,
    campaign,
    canExpire,
    endDate,
    description,
    detailLevel,
    reward
  } = activity;
  const activityDate = useActivityCardDate(endDate, canExpire, required);
  const qualifiesForRewardProgram = campaign == null ? void 0 : campaign.qualifiesForRewardProgram;
  const showProgressBar = progress && checkProgressData(progress);
  const displayShortDescription = detailLevel === CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION.DETAILED && !showProgressBar && description !== void 0;
  let rewardsPoints;
  if ((reward == null ? void 0 : reward.type) === "reward_points") {
    rewardsPoints = reward.available;
  }
  const displayActivityCardBody = showProgressBar || displayShortDescription || !!rewardsPoints || !!activityDate || required || qualifiesForRewardProgram;
  if (!displayActivityCardBody)
    return null;
  return /* @__PURE__ */ jsxs15(StackLayout11, { spacing: "$threeQuarters", children: [
    showProgressBar && /* @__PURE__ */ jsx32(
      ComposableCTACardProgressBar,
      {
        progress: progress.currentProgress,
        goal: progress.goalTotal,
        unit: progress.unit,
        type: progress.dataType
      }
    ),
    displayShortDescription && /* @__PURE__ */ jsx32(UtilityText13, { as: "p", children: description }),
    !!rewardsPoints && /* @__PURE__ */ jsx32(
      IconTextLayout,
      {
        iconProps: {
          icon: aeroplanIcon
        },
        textProps: {
          title: formatMessage(
            { id: "AEROPLAN_POINTS" },
            { points: rewardsPoints }
          )
        }
      }
    ),
    activityDate && /* @__PURE__ */ jsx32(
      IconTextLayout,
      {
        iconProps: {
          icon: "descriptiveClock",
          size: "$one",
          tint: "$decorativeBrandSecondaryDarkest"
        },
        textProps: {
          title: activityDate
        }
      }
    ),
    required && /* @__PURE__ */ jsx32(
      IconTextLayout,
      {
        iconProps: {
          icon: requiredIcon
        },
        textProps: {
          title: formatMessage({ id: "REQUIRED" })
        }
      }
    ),
    qualifiesForRewardProgram && /* @__PURE__ */ jsx32(
      StackItem3,
      {
        horizontalAlignment: "center",
        css: {
          flexDirection: "row",
          gap: "$quarter"
        },
        children: /* @__PURE__ */ jsxs15(Badge4, { css: { backgroundColor: "$decorativeBrandSecondaryPastel" }, children: [
          /* @__PURE__ */ jsx32(Icon9, { icon: rewardsIcon2, size: "$one" }),
          /* @__PURE__ */ jsx32(UtilityText13, { children: formatMessage({ id: "REWARDS_PROGRAM_ELIGIBLE" }) })
        ] })
      }
    )
  ] });
};

// src/hooks/useActivityCardHeadline/useActivityCardHeadline.hook.tsx
import { CONFIGURABLE_ACTIVITY_PRIORITY } from "@leagueplatform/health-journey-common";
import { jsx as jsx33 } from "react/jsx-runtime";
var useActivityCardHeadline = (priority, tagline) => {
  if (!tagline) {
    return null;
  }
  switch (priority) {
    case CONFIGURABLE_ACTIVITY_PRIORITY.LOW:
      return null;
    case CONFIGURABLE_ACTIVITY_PRIORITY.MEDIUM: {
      return /* @__PURE__ */ jsx33(
        ComposableCTACardHeadline,
        {
          text: tagline,
          color: "$onSurfaceTextPrimary",
          backgroundColor: "$decorativeBrandPrimaryBrightest"
        }
      );
    }
    case CONFIGURABLE_ACTIVITY_PRIORITY.HIGH: {
      return /* @__PURE__ */ jsx33(
        ComposableCTACardHeadline,
        {
          text: tagline,
          color: "$onSurfaceTextReversed",
          backgroundColor: "$decorativeBrandPrimaryDark"
        }
      );
    }
    default:
      return null;
  }
};

// src/hooks/useActivityCardEyebrow/useActivityCardEyebrow.hook.tsx
import rewardsProgramIcon from "./assets/rewards-icon.svg";
import { jsx as jsx34 } from "react/jsx-runtime";
var useActivityCardEyebrow = (campaign) => {
  if (!campaign) {
    return null;
  }
  const { type: campaignType, name: campaignName } = campaign;
  switch (campaignType) {
    case "suggested":
      return null;
    case "opt-in": {
      return /* @__PURE__ */ jsx34(
        IconTextLayout,
        {
          iconProps: {
            icon: "descriptiveHeartFilled",
            tint: "$decorativeBrandPrimaryDarkest"
          },
          textProps: {
            title: campaignName,
            emphasis: "subtle",
            size: "xs"
          }
        }
      );
    }
    case "reward": {
      return /* @__PURE__ */ jsx34(
        IconTextLayout,
        {
          iconProps: {
            icon: rewardsProgramIcon
          },
          textProps: {
            title: campaignName,
            emphasis: "subtle",
            size: "xs"
          }
        }
      );
    }
    case "challenge": {
      return /* @__PURE__ */ jsx34(
        IconTextLayout,
        {
          iconProps: { icon: "tinyStar", tint: "$warningIcon" },
          textProps: {
            title: campaignName,
            emphasis: "subtle",
            size: "xs"
          }
        }
      );
    }
    default:
      return null;
  }
};

// src/components/activity-card/activity-card.component.tsx
import { jsx as jsx35 } from "react/jsx-runtime";
var ActivityCard = (activity) => {
  const { formatMessage } = useIntl13();
  const {
    image,
    imageAltText,
    imagePosition: imagePos,
    ctaText,
    heading,
    campaign,
    priority,
    tagline,
    id,
    detailLevel,
    onClick
  } = activity;
  const ActivityCardHeadline = useActivityCardHeadline(priority, tagline);
  const ActivityCardEyebrow = useActivityCardEyebrow(campaign);
  const displayImage = detailLevel !== CONFIGURABLE_ACTIVITY_DETAIL_COMPOSITION2.SIMPLE && image;
  const imageProps = displayImage && image ? {
    image,
    altText: imageAltText || "",
    imagePosition: imagePos === "top" ? "top" : "right"
  } : void 0;
  return /* @__PURE__ */ jsx35(
    ComposableCTACard,
    {
      id,
      body: /* @__PURE__ */ jsx35(ActivityCardBody, { activity }),
      headline: ActivityCardHeadline,
      image: imageProps,
      title: {
        text: heading,
        level: "3"
      },
      eyebrow: ActivityCardEyebrow,
      cta: {
        text: ctaText || formatMessage({ id: "ACTIVITY_CARD_CTA" })
      },
      onClick
    }
  );
};

// src/components/activity-completion-card/activity-completion-card.component.tsx
import {
  Card as Card7,
  HeadingText as HeadingText9,
  ParagraphText as ParagraphText4,
  StackItem as StackItem4,
  StackLayout as StackLayout12,
  TextAction as TextAction5,
  useClickableCard as useClickableCard3
} from "@leagueplatform/genesis-core";
import { Link as Link4 } from "react-router-dom";
import { useMasonryEngineActionEmitter as useMasonryEngineActionEmitter3 } from "@leagueplatform/masonry-engine";
import { jsx as jsx36, jsxs as jsxs16 } from "react/jsx-runtime";
var ActivityCompletionCard = ({
  heading,
  body,
  image,
  imageAltText = "",
  onClick
}) => {
  const { clickAreaRef, onCardMouseDown, onCardMouseUp, primaryActionRef } = useClickableCard3();
  const invokeAction = useMasonryEngineActionEmitter3();
  const onClickDeeplinkAction = onClick;
  return /* @__PURE__ */ jsx36(
    Card7.Elevated,
    {
      css: {
        backgroundColor: "$successBackgroundSecondary"
      },
      children: /* @__PURE__ */ jsx36(
        Card7.ClickArea,
        {
          ref: clickAreaRef,
          onCardMouseUp,
          onCardMouseDown,
          children: /* @__PURE__ */ jsx36(
            Card7.Section,
            {
              css: {
                paddingY: "$one"
              },
              children: /* @__PURE__ */ jsxs16(
                StackLayout12,
                {
                  orientation: {
                    "@initial": "horizontal",
                    "@mobile": "vertical",
                    "@mobileLandscape": "horizontal"
                  },
                  verticalAlignment: "center",
                  horizontalAlignment: "spaceBetween",
                  spacing: "$threeQuarters",
                  children: [
                    /* @__PURE__ */ jsxs16(StackItem4, { children: [
                      /* @__PURE__ */ jsx36(
                        HeadingText9,
                        {
                          level: "3",
                          size: "sm",
                          css: {
                            "& > a": {
                              all: "inherit"
                            }
                          },
                          children: /* @__PURE__ */ jsx36(
                            TextAction5,
                            {
                              as: Link4,
                              ref: primaryActionRef,
                              to: onClickDeeplinkAction == null ? void 0 : onClickDeeplinkAction.payload.url,
                              onClick: (event) => {
                                if (onClickDeeplinkAction) {
                                  invokeAction(__spreadValues({
                                    event
                                  }, onClickDeeplinkAction));
                                }
                              },
                              children: heading
                            }
                          )
                        }
                      ),
                      /* @__PURE__ */ jsx36(ParagraphText4, { css: { typography: "$bodyTwo" }, children: body })
                    ] }),
                    image && /* @__PURE__ */ jsx36(
                      Card7.Image,
                      {
                        image,
                        imageAlt: imageAltText,
                        css: {
                          height: 42,
                          width: 42,
                          contentFit: "cover",
                          contentPosition: "center"
                        }
                      }
                    )
                  ]
                }
              )
            }
          )
        }
      )
    }
  );
};

// src/components/layout-box-renderer/layout-box-renderer.component.tsx
import { Box as Box10 } from "@leagueplatform/genesis-core";
import { jsx as jsx37 } from "react/jsx-runtime";
var NODE_TYPE_LAYOUT_BOX_RENDERER = "boxLayout";
var LayoutBoxRenderer = ({
  backgroundColor = "$surfaceBackgroundPrimary",
  items
}) => {
  if (!(items == null ? void 0 : items.length)) {
    return null;
  }
  return /* @__PURE__ */ jsx37(
    Box10,
    {
      css: {
        height: "min-content",
        padding: "$oneAndHalf",
        overflowX: "hidden",
        width: "100%",
        backgroundColor,
        border: "1px solid $onSurfaceBorderCard"
      },
      id: "layout-box-renderer",
      "data-testid": "layout-box-renderer",
      children: items
    }
  );
};

// src/components/activity-points-card/activity-points-card.component.tsx
import {
  Button as Button2,
  Card as Card8,
  HeadingText as HeadingText10,
  StackLayout as StackLayout13,
  Tooltip
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl14 } from "@leagueplatform/locales";
import { jsx as jsx38, jsxs as jsxs17 } from "react/jsx-runtime";
var ActivityPointsCardRenderer = ({
  heading,
  body,
  image,
  imageAltText = ""
}) => {
  const { formatMessage } = useIntl14();
  return /* @__PURE__ */ jsx38(
    Card8.Flat,
    {
      backgroundColor: "primary",
      css: {
        borderWidth: "$card",
        borderColor: "$onSurfaceBorderDefault",
        borderStyle: "solid"
      },
      children: /* @__PURE__ */ jsx38(Card8.Section, { css: { paddingY: "$one" }, children: /* @__PURE__ */ jsxs17(
        StackLayout13,
        {
          orientation: "horizontal",
          verticalAlignment: "center",
          spacing: "$half",
          children: [
            image && /* @__PURE__ */ jsx38(
              Card8.Image,
              {
                image,
                imageAlt: imageAltText,
                css: {
                  width: "$one",
                  height: "$one"
                }
              }
            ),
            /* @__PURE__ */ jsxs17(StackLayout13, { orientation: "horizontal", verticalAlignment: "center", children: [
              /* @__PURE__ */ jsx38(HeadingText10, { level: "3", size: "xs", children: heading }),
              body && /* @__PURE__ */ jsx38(
                Tooltip,
                {
                  align: "end",
                  side: "bottom",
                  content: body,
                  css: { maxWidth: "288px" },
                  children: /* @__PURE__ */ jsx38(
                    Button2,
                    {
                      icon: "tinyHelper",
                      hideLabel: true,
                      quiet: true,
                      priority: "secondary",
                      size: "toolbar",
                      children: formatMessage({ id: "AEROPLAN_POINTS_INFO" })
                    }
                  )
                }
              )
            ] })
          ]
        }
      ) })
    }
  );
};

// src/components/rewards-hub-error-state/rewards-hub-error-state-renderer.component.tsx
import * as React4 from "react";
import { useInvokeAction as useInvokeAction4 } from "@leagueplatform/masonry-renderers";
import { ErrorState } from "@leagueplatform/web-common-components";
import { jsx as jsx39 } from "react/jsx-runtime";
var NODE_TYPE_REWARDS_HUB_ERROR_STATE = "rewardsHubErrorState";
function RewardsHubErrorStateRenderer({
  heading,
  description,
  buttonLabel,
  image,
  onRetry
}) {
  const invokeAction = useInvokeAction4();
  const handleRetry = React4.useCallback(
    (event) => {
      if (!onRetry)
        return;
      invokeAction(__spreadValues({ event }, onRetry));
    },
    [invokeAction, onRetry]
  );
  return (
    // Scoped styles for this container live in src/inject-styles.ts under the
    // MANU-4798 block — they override deep ImageMessage/ErrorState internals
    // (.error-state-container, .error-state-body-text, etc.) that can't be
    // styled via props.
    /* @__PURE__ */ jsx39("div", { className: "rewards-hub-error-container", children: /* @__PURE__ */ jsx39(
      ErrorState,
      {
        error: null,
        imageSrc: image == null ? void 0 : image.source,
        headingString: heading,
        bodyString: description,
        buttonText: buttonLabel,
        hideButton: !onRetry,
        onButtonClick: onRetry ? handleRetry : void 0
      }
    ) })
  );
}

// src/components/program-card/program-card.component.tsx
import { useIntl as useIntl15 } from "@leagueplatform/locales";
import { UtilityText as UtilityText16 } from "@leagueplatform/genesis-core";

// src/components/program-card/program-card-body/program-card-body.component.tsx
import { StackLayout as StackLayout15, UtilityText as UtilityText15 } from "@leagueplatform/genesis-core";

// src/components/progress-bar-layout/progress-bar-layout.component.tsx
import {
  StackItem as StackItem5,
  StackLayout as StackLayout14,
  Box as Box11,
  UtilityText as UtilityText14,
  Icon as Icon10
} from "@leagueplatform/genesis-core";
import { ProgressBar as ProgressBar3 } from "@leagueplatform/web-common-components";
import { jsx as jsx40, jsxs as jsxs18 } from "react/jsx-runtime";
var ProgressBarLayout = ({
  progress,
  prefixText,
  currentText,
  image,
  imageAltText,
  accessibilityLabel
}) => /* @__PURE__ */ jsxs18(
  StackLayout14,
  {
    spacing: "$half",
    css: {
      width: "100%"
    },
    children: [
      /* @__PURE__ */ jsxs18(Box11, { css: { display: "block" }, children: [
        image && /* @__PURE__ */ jsx40(
          Box11,
          {
            css: {
              display: "inline-block",
              verticalAlign: "middle",
              marginInlineEnd: "$quarter"
            },
            children: /* @__PURE__ */ jsx40(Icon10, { icon: image, label: imageAltText, size: "16px" })
          }
        ),
        prefixText && /* @__PURE__ */ jsx40(
          UtilityText14,
          {
            emphasis: "emphasized",
            size: "sm",
            css: {
              color: "$onSurfaceTextSuccess",
              display: "inline",
              marginInlineEnd: "$quarter"
            },
            children: prefixText
          }
        ),
        currentText && /* @__PURE__ */ jsx40(UtilityText14, { css: { display: "inline" }, children: currentText })
      ] }),
      progress && /* @__PURE__ */ jsx40(StackItem5, { css: { width: "100%" }, children: /* @__PURE__ */ jsx40(
        ProgressBar3,
        {
          screenReaderText: accessibilityLabel,
          current: progress.current,
          total: progress.total,
          customBarFillColor: "success.icon",
          customBarBackgroundColor: "input.background.disabled"
        }
      ) })
    ]
  }
);

// src/components/program-card/program-card-body/program-card-body.component.tsx
import { jsx as jsx41, jsxs as jsxs19 } from "react/jsx-runtime";
var ProgramCardBody = ({
  description,
  items
}) => /* @__PURE__ */ jsxs19(StackLayout15, { spacing: "$threeQuarters", children: [
  items == null ? void 0 : items.map((item, index) => {
    const { content, progressValue } = item;
    const progress = progressValue ? {
      current: progressValue,
      total: 100
    } : void 0;
    if (!content) {
      return null;
    }
    const { currentText, image, imageAltText = "", prefixText } = content;
    const contentKey = `content-${index}}`;
    return /* @__PURE__ */ jsx41(
      ProgressBarLayout,
      {
        progress,
        image,
        imageAltText,
        prefixText,
        currentText
      },
      contentKey
    );
  }),
  /* @__PURE__ */ jsx41(UtilityText15, { as: "p", children: description })
] });

// src/components/program-card/program-card.component.tsx
import { jsx as jsx42 } from "react/jsx-runtime";
var NODE_TYPE_PROGRAM_CARD_RENDERER = "programCard";
var ProgramCard = ({
  badge,
  description,
  eyebrow,
  heading,
  image,
  imageAltText,
  items,
  id,
  onClick
}) => {
  const { formatMessage } = useIntl15();
  const programCardBadge = badge && __spreadProps(__spreadValues({}, badge), { positionOverImage: true });
  return /* @__PURE__ */ jsx42(
    ComposableCTACard,
    {
      image: {
        image,
        altText: imageAltText,
        imagePosition: "responsive"
      },
      eyebrow: /* @__PURE__ */ jsx42(UtilityText16, { size: "eyebrow", css: { textTransform: "uppercase" }, children: eyebrow }),
      badge: programCardBadge,
      id,
      title: { text: heading, level: "3" },
      body: /* @__PURE__ */ jsx42(ProgramCardBody, { description, items }),
      cta: {
        text: `${formatMessage({ id: "PROGRAM_CARD_CTA" })}`
      },
      onClick
    }
  );
};

// src/components/progress-card/progress-card.component.tsx
import { UtilityText as UtilityText17 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl16 } from "@leagueplatform/locales";
import { jsx as jsx43 } from "react/jsx-runtime";
var ProgressCardBody = ({ progressBar }) => {
  const {
    leadingValue: prefixText,
    trailingValue: currentText,
    accessibilityLabel: label,
    fillProgressValue: current = 0,
    maxProgressValue: total
  } = progressBar;
  return /* @__PURE__ */ jsx43(
    ProgressBarLayout,
    {
      progress: {
        current,
        total
      },
      prefixText,
      currentText,
      accessibilityLabel: label
    }
  );
};
var ProgressCard = (props) => {
  const { formatMessage } = useIntl16();
  const { onCardClick, body, progressBar, nodeId, cta } = props;
  const onClickDeeplinkAction = onCardClick;
  if (!body || !progressBar) {
    return null;
  }
  const { heading = "", headingLevel = "3", tags } = body;
  const eyebrowText = tags == null ? void 0 : tags[0].label;
  const ctaText = cta == null ? void 0 : cta.firstCTA.label;
  return /* @__PURE__ */ jsx43(
    ComposableCTACard,
    {
      id: nodeId,
      body: /* @__PURE__ */ jsx43(ProgressCardBody, { progressBar }),
      title: {
        text: heading,
        level: headingLevel
      },
      eyebrow: /* @__PURE__ */ jsx43(UtilityText17, { size: "eyebrow", css: { textTransform: "uppercase" }, children: eyebrowText }),
      cardContentAlignment: "start",
      cta: {
        text: ctaText || formatMessage({ id: "PROGRESS_CARD_CTA" })
      },
      onClick: onClickDeeplinkAction
    }
  );
};

// src/components/masonry/masonry-status-banner-renderer-override/masonry-status-banner-renderer-override.tsx
import { MasonryStatusBannerRenderer } from "@leagueplatform/masonry-renderers";
import { jsx as jsx44 } from "react/jsx-runtime";
var MasonryStatusBannerRendererOverride = (props) => /* @__PURE__ */ jsx44(
  MasonryStatusBannerRenderer,
  __spreadProps(__spreadValues({}, props), {
    css: {
      backgroundColor: "$surfaceBackgroundPrimary",
      padding: "$half",
      span: {
        typography: "$bodyTwo",
        color: "$onSurfaceTextPrimary"
      },
      p: {
        typography: "$bodyTwo",
        color: "$onSurfaceTextPrimary",
        marginBottom: "$half",
        "&:last-child": {
          marginBottom: 0
        },
        // MANU-6520: SDK 2.43.x renders body links as an inline-flex TextAction,
        // an atomic box that can't wrap, so a long link (e.g. FR copy) drops to
        // its own line. Inline lets it flow with the surrounding text.
        "a.GDS-text-action": {
          display: "inline"
        }
      }
    }
  })
);

// src/components/masonry/masonry-composable-card-renderer/masonry-composable-card-renderer-override.tsx
import { MasonryComposableCardRenderer } from "@leagueplatform/masonry-renderers";
import { jsx as jsx45 } from "react/jsx-runtime";
var MasonryComposableCardRendererOverride = (props) => /* @__PURE__ */ jsx45(
  MasonryComposableCardRenderer,
  __spreadProps(__spreadValues({}, props), {
    css: {
      ".GDS-heading-text": {
        typography: "$headingFour"
      },
      "&": {
        backgroundColor: "$surfaceCardPrimary"
      },
      ".GDS-composable-card-body > :first-child": {
        padding: "$oneAndHalf"
      },
      ".GDS-tag-label": {
        width: "auto !important"
      },
      ".GDS-tag": {
        flexWrap: "wrap"
      }
    }
  })
);

// src/components/get-care-service-card/get-care-service-card-renderer.component.tsx
import { Box as Box13, Card as Card10 } from "@leagueplatform/genesis-core";
import {
  DismissButton
} from "@leagueplatform/masonry-renderers";

// src/components/get-care-service-card/get-care-service-card-content.component.tsx
import React5 from "react";
import {
  ParagraphText as ParagraphText5,
  StackLayout as StackLayout16,
  HeadingText as HeadingText11,
  UtilityText as UtilityText18,
  Box as Box12,
  TextAction as TextAction6,
  Card as Card9
} from "@leagueplatform/genesis-core";
import { useInvokeAction as useInvokeAction5 } from "@leagueplatform/masonry";
import { InternalOrExternalLinkButton } from "@leagueplatform/web-common-components";
import { useUniqueId as useUniqueId2 } from "@leagueplatform/web-common";
import {
  BadgeList,
  getTextActionIndicatorIconToken
} from "@leagueplatform/masonry-renderers";
import { useIntl as useIntl17 } from "@leagueplatform/locales";
import { jsx as jsx46, jsxs as jsxs20 } from "react/jsx-runtime";
var BodyTextHtmlTagOptions = {
  a: {
    component: InternalOrExternalLinkButton,
    props: {
      baseComponent: TextAction6,
      // Stop event propagation to prevent triggering on card click event on click of link inside paragraph text
      onClick: (e) => e.stopPropagation()
    }
  }
};
var GetCareServiceCardContent = ({
  eyebrow,
  heading,
  body,
  badges,
  badgeBackgroundColor,
  onClick,
  ctaLabel,
  ctaIndicator: _ctaIndicator,
  isCtaLabelledByHeading
}) => {
  var _a;
  const { formatMessage } = useIntl17();
  const eyebrowId = `get-care-service-card-${heading == null ? void 0 : heading.replace(/\s+/g, "-")}`;
  const headingId = useUniqueId2({ prefix: "GetCareServiceCardContent" });
  const ctaId = `${headingId}-cta`;
  const ctaLabelledById = `${ctaId} ${headingId}`;
  const ctaIndicator = _ctaIndicator ? getTextActionIndicatorIconToken(_ctaIndicator) : void 0;
  const invokeAction = useInvokeAction5();
  const handleOnClick = React5.useCallback(
    (event) => {
      if (onClick) {
        invokeAction(__spreadValues({
          event
        }, onClick));
      }
    },
    [invokeAction, onClick]
  );
  return /* @__PURE__ */ jsxs20(Box12, { css: { display: "flex", flexDirection: "column", height: "100%" }, children: [
    /* @__PURE__ */ jsx46(Card9.Section, { children: /* @__PURE__ */ jsxs20(StackLayout16, { spacing: "$threeQuarters", orientation: "vertical", children: [
      /* @__PURE__ */ jsxs20(StackLayout16, { spacing: "$half", orientation: "vertical", children: [
        eyebrow && /* @__PURE__ */ jsx46(UtilityText18, { id: eyebrowId, size: "eyebrow", as: "p", children: eyebrow }),
        heading && /* @__PURE__ */ jsx46(
          HeadingText11,
          {
            id: isCtaLabelledByHeading ? headingId : void 0,
            level: "3",
            size: "md",
            "aria-describedby": eyebrowId,
            children: heading
          }
        ),
        body && /* @__PURE__ */ jsx46(
          ParagraphText5,
          {
            htmlStringOptions: BodyTextHtmlTagOptions,
            emphasis: "subtle",
            children: body
          }
        )
      ] }),
      badges && /* @__PURE__ */ jsx46(Box12, { children: /* @__PURE__ */ jsx46(
        BadgeList,
        {
          badges,
          backgroundColor: badgeBackgroundColor
        }
      ) })
    ] }) }),
    onClick && /* @__PURE__ */ jsx46(
      Card9.Section,
      {
        css: {
          flexGrow: 0,
          borderTopWidth: "$card",
          borderTopColor: "$onSurfaceBorderSubdued",
          borderTopStyle: "solid"
        },
        children: /* @__PURE__ */ jsx46(
          TextAction6,
          {
            as: InternalOrExternalLinkButton,
            baseComponent: TextAction6,
            href: (_a = onClick == null ? void 0 : onClick.payload.url) != null ? _a : "",
            onClick: handleOnClick,
            id: isCtaLabelledByHeading ? ctaId : void 0,
            "aria-labelledby": isCtaLabelledByHeading ? ctaLabelledById : void 0,
            icon: "interfaceCTAIndicator",
            indicator: ctaIndicator,
            size: "medium",
            disableDefaultOnClick: true,
            css: {
              fontWeight: "$bodyOne",
              color: "$onSurfaceTextPrimary",
              fontSize: "$bodyOne",
              ".GDS-icon": {
                color: "$primaryBackgroundDefault"
              },
              "&:hover": {
                textDecoration: "none",
                ".GDS-icon": {
                  color: "$primaryBackgroundHovered"
                }
              }
            },
            content: void 0,
            nonce: void 0,
            rev: void 0,
            children: ctaLabel != null ? ctaLabel : formatMessage({ id: "GET_CARE_SERVICE_CARD_CTA" })
          }
        )
      }
    )
  ] });
};

// src/components/get-care-service-card/get-care-service-card-renderer.component.tsx
import { jsx as jsx47, jsxs as jsxs21 } from "react/jsx-runtime";
function GetCareServiceCardRenderer(_a) {
  var _b = _a, {
    isChildItem,
    image,
    imageAltText,
    showMobile,
    onDismiss
  } = _b, props = __objRest(_b, [
    "isChildItem",
    "image",
    "imageAltText",
    "showMobile",
    "onDismiss"
  ]);
  const showSmallerCard = isChildItem || showMobile;
  return /* @__PURE__ */ jsxs21(
    Card10.Flat,
    {
      imagePosition: showSmallerCard ? "top" : {
        "@initial": "end",
        "@mobile": "top"
      },
      backgroundColor: "secondary",
      css: {
        height: showSmallerCard ? "100%" : "auto",
        borderWidth: "$card",
        borderColor: "$onSurfaceBorderSubdued",
        borderStyle: "solid",
        borderRadius: "$card"
      },
      children: [
        onDismiss && /* @__PURE__ */ jsx47(
          DismissButton,
          {
            onDismiss,
            toolbarButton: true,
            css: {
              position: "absolute",
              insetBlockStart: "$half",
              insetInlineEnd: "$half",
              zIndex: 2
            }
          }
        ),
        image && /* @__PURE__ */ jsx47(
          Card10.Image,
          {
            image,
            imageAlt: imageAltText,
            css: { "@mobile": { height: "176px" } }
          }
        ),
        /* @__PURE__ */ jsx47(Box13, { css: { flexGrow: 1 }, children: /* @__PURE__ */ jsx47(
          GetCareServiceCardContent,
          __spreadValues({}, props)
        ) })
      ]
    }
  );
}

// src/components/masonry/masonry-carousel-renderer-override/masonry-carousel-renderer-override.component.tsx
import { MasonryCarouselRenderer } from "@leagueplatform/masonry-renderers";
import { jsx as jsx48 } from "react/jsx-runtime";
var listStyles = {};
var MasonryCarouselRendererOverride = (props) => /* @__PURE__ */ jsx48(
  MasonryCarouselRenderer,
  __spreadProps(__spreadValues({}, props), {
    css: listStyles,
    className: "masonry-carousel-renderer-override"
  })
);

// src/components/masonry/masonry-extra-small-card-renderer/masonry-extra-small-card-renderer-override.tsx
import { MasonryExtraSmallCardRenderer } from "@leagueplatform/masonry-renderers";
import { jsx as jsx49 } from "react/jsx-runtime";
var MasonryExtraSmallCardRendererOverride = (props) => /* @__PURE__ */ jsx49(
  MasonryExtraSmallCardRenderer,
  __spreadValues({
    css: {
      paddingY: "$one"
    }
  }, props)
);

// src/components/masonry/masonry-status-banner-desktop-renderer-override/masonry-status-banner-desktop-renderer-override.tsx
import { MasonryStatusBannerRenderer as MasonryStatusBannerRenderer2 } from "@leagueplatform/masonry-renderers";
import { queryHelpers as queryHelpers6, useMediaQuery as useMediaQuery6 } from "@leagueplatform/genesis-core";
import { jsx as jsx50 } from "react/jsx-runtime";
var MasonryStatusBannerDesktopRendererOverride = (props) => {
  const isMobile = useMediaQuery6(queryHelpers6.down("tablet"));
  if (isMobile)
    return null;
  return /* @__PURE__ */ jsx50(
    MasonryStatusBannerRenderer2,
    __spreadProps(__spreadValues({}, props), {
      css: {
        backgroundColor: "transparent",
        span: {
          typography: "$bodyTwo",
          color: "$onSurfaceTextPrimary"
        }
      }
    })
  );
};

// src/components/masonry/masonry-sidebar-layout-renderer-override/masonry-sidebar-layout-renderer-override.component.tsx
import { MasonrySidebarLayoutRenderer } from "@leagueplatform/masonry-renderers";
import { jsx as jsx51 } from "react/jsx-runtime";
var MasonrySidebarLayoutRendererOverride = (props) => /* @__PURE__ */ jsx51(
  MasonrySidebarLayoutRenderer,
  __spreadProps(__spreadValues({}, props), {
    css: {
      /* Stretch children so carousel and card match the tallest sibling's height */
      alignItems: "stretch"
    },
    className: "masonry-sidebar-layout-renderer-override"
  })
);

// src/components/masonry/masonry-grid-layout-renderer-override/masonry-grid-layout-renderer-override.component.tsx
import { MasonryGridLayoutRenderer } from "@leagueplatform/masonry-renderers";
import { jsx as jsx52 } from "react/jsx-runtime";
var MasonryGridLayoutRendererOverride = (_a) => {
  var _b = _a, { minGridItemWidth, mobileMinGridItemWidth } = _b, rest = __objRest(_b, ["minGridItemWidth", "mobileMinGridItemWidth"]);
  return /* @__PURE__ */ jsx52(
    MasonryGridLayoutRenderer,
    __spreadProps(__spreadValues({}, rest), {
      minGridItemWidth: minGridItemWidth ? `min(${minGridItemWidth}, 100%)` : minGridItemWidth,
      mobileMinGridItemWidth: mobileMinGridItemWidth ? `min(${mobileMinGridItemWidth}, 100%)` : mobileMinGridItemWidth
    })
  );
};

// src/components/masonry/masonry-text-action-renderer-override/masonry-text-action-renderer-override.tsx
import { MasonryTextActionRenderer } from "@leagueplatform/masonry-renderers";
import { jsx as jsx53 } from "react/jsx-runtime";
var MasonryTextActionRendererOverride = (_a) => {
  var _b = _a, { variant, css } = _b, props = __objRest(_b, ["variant", "css"]);
  return /* @__PURE__ */ jsx53(
    MasonryTextActionRenderer,
    __spreadProps(__spreadValues({}, props), {
      variant,
      css: !variant || variant === "default" ? __spreadValues({ color: "$tertiaryTextDefault" }, css) : css
    })
  );
};

// src/components/masonry/masonry-responsive-hidden-container/masonry-responsive-hidden-container.component.tsx
import { Box as Box14, useMediaQuery as useMediaQuery7, queryHelpers as queryHelpers7 } from "@leagueplatform/genesis-core";
import { jsx as jsx54 } from "react/jsx-runtime";
var ResponsiveHiddenContainerRenderer = ({
  breakpoints = {},
  content
}) => {
  const isMobile = useMediaQuery7(queryHelpers7.down("mobileLandscape"));
  const isMobileLandscape = useMediaQuery7(queryHelpers7.only("mobileLandscape"));
  const isTablet = useMediaQuery7(queryHelpers7.only("tablet"));
  const isLaptop = useMediaQuery7(queryHelpers7.only("laptop"));
  const isDesktop = useMediaQuery7(queryHelpers7.up("desktop"));
  if ((breakpoints == null ? void 0 : breakpoints.mobile) && isMobile)
    return null;
  if ((breakpoints == null ? void 0 : breakpoints.mobileLandscape) && isMobileLandscape)
    return null;
  if ((breakpoints == null ? void 0 : breakpoints.tablet) && isTablet)
    return null;
  if ((breakpoints == null ? void 0 : breakpoints.laptop) && isLaptop)
    return null;
  if ((breakpoints == null ? void 0 : breakpoints.desktop) && isDesktop)
    return null;
  return /* @__PURE__ */ jsx54(Box14, { className: "responsive-hidden-container", children: content });
};

// src/constants/session-storage-keys.ts
var SESSION_STORAGE_KEYS = {
  REWARDS_CTA_CLICKED: "rewards_cta_clicked",
  REWARDS_MODAL_SHOWN: "rewards_modal_shown",
  // Epoch ms of a task completion that redirected to the hub.
  REWARDS_TASK_COMPLETED_AT: "rewards_task_completed_at"
};

// src/masonry-actions/complete-rewardable-task.action.ts
import { leagueFetch as leagueFetch2 } from "@leagueplatform/league-fetch";
import { processUrl } from "@leagueplatform/league-routes";
import { captureError as captureError2 } from "@leagueplatform/observability";
var COMPLETE_REWARDABLE_TASK_ACTION_TYPE = "completeRewardableTask";
var USER_HEALTH_ACTIVITIES_PATH = "/v1/user-health-activities";
var REWARDS_HUB_URL = "/gb/member-portal/secured/member/rewards-hub";
var CONFLICT_STATUS = 409;
var REDIRECT_FALLBACK_MS = 2500;
var completeRewardableTaskActionHandler = ({ payload, event }, _invokeInnerAction, _stateController, _messagingController, _validationController, resources) => {
  event == null ? void 0 : event.preventDefault();
  const navigate = resources == null ? void 0 : resources.navigate;
  const originPath = window.location.pathname;
  const destination = (payload == null ? void 0 : payload.url) ? processUrl(payload.url) : void 0;
  const userHealthActivityId = payload == null ? void 0 : payload.userHealthActivityId;
  if (destination)
    window.open(destination, "_blank", "noreferrer");
  const goToRewardsHub = () => navigate == null ? void 0 : navigate(REWARDS_HUB_URL, { replace: true });
  if (!userHealthActivityId) {
    goToRewardsHub();
    return;
  }
  let redirected = false;
  let completed = false;
  const redirectOnce = (rewardMayBePending) => {
    if (redirected)
      return;
    redirected = true;
    if (window.location.pathname !== originPath)
      return;
    if (rewardMayBePending && typeof navigate === "function") {
      try {
        sessionStorage.setItem(
          SESSION_STORAGE_KEYS.REWARDS_TASK_COMPLETED_AT,
          String(Date.now())
        );
      } catch (e) {
      }
    }
    goToRewardsHub();
  };
  const fallbackTimer = setTimeout(
    () => redirectOnce(true),
    REDIRECT_FALLBACK_MS
  );
  leagueFetch2(`${USER_HEALTH_ACTIVITIES_PATH}/${userHealthActivityId}`, {
    method: "PATCH",
    // Suppress default capture — we decide from the status (a 409 is expected).
    skipErrorCapture: true,
    body: JSON.stringify({
      data: {
        id: userHealthActivityId,
        type: "user-health-activity",
        attributes: { status: "completed" }
      }
    })
  }).then((response) => {
    completed = response.ok;
    if (!response.ok && response.status !== CONFLICT_STATUS) {
      captureError2(
        new Error(
          `[manulife] Rewardable task completion failed (${response.status}) \u2014 activity ${userHealthActivityId}, url: ${destination}`
        )
      );
    }
  }).catch((error) => {
    const reason = error instanceof Error ? error.message : String(error);
    captureError2(
      new Error(
        `[manulife] Rewardable task completion request failed \u2014 activity ${userHealthActivityId}, url: ${destination} (${reason})`
      )
    );
  }).finally(() => {
    clearTimeout(fallbackTimer);
    redirectOnce(completed);
  });
};

// src/init-masonry-registry.ts
var NAMESPACE_HOMEPAGE_POINTS_CARD = "manulife_homepage_points_card";
var PROGRAM_OVERVIEW_PRIZE_CARD = "program_overview_prize_card";
var PROGRAM_OVERVIEW_DISCLAIMER = "program_overview_disclaimer";
var JOURNEY_PROGRAM_OVERVIEW_SIDEBAR = "journey_program_overview_sidebar";
var JOURNEY_PROGRAM_OVERVIEW_FOOTER = "journey_program_overview_footer";
var POINTS_HISTORY_OVERLINE = "pointsHistoryOverline";
var LINK_AEROPLAN_ACCOUNT_CARD = "linkAeroplanAccountCard";
var REWARDS_HUB_OVERVIEW_LOADER_NAMESPACE = "manulife_rewardsHubOverviewLoader";
var initMasonryRegistry = () => {
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    NAMESPACE_HOMEPAGE_POINTS_CARD,
    "extraSmallCard",
    ActivityPointsCardRenderer
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "statusBackgroundColor",
    "smallCard",
    ActivityCompletionCard
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "tooltip",
    "extraSmallCard",
    ActivityPointsCardRenderer
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    DEFAULT_NAMESPACE,
    NODE_TYPE_LAYOUT_BOX_RENDERER,
    LayoutBoxRenderer
  );
  MasonryDriverNodeRenderersRegistry.overrideRenderer(
    DEFAULT_NAMESPACE,
    "gridLayout",
    MasonryGridLayoutRendererOverride
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "rewardsHubBanner",
    "largeCard",
    RewardsBannerCard
  );
  MasonryDriverNodeRenderersRegistry.overrideRenderer(
    DEFAULT_NAMESPACE,
    HEALTH_JOURNEY_NODE_TYPES.ACTIVITY_CARD,
    ActivityCard
  );
  MasonryDriverNodeRenderersRegistry.overrideRenderer(
    "rewardsHubProgressCard",
    "composableCard",
    RewardsPointsProgressCard
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    DEFAULT_NAMESPACE,
    NODE_TYPE_PROGRAM_CARD_RENDERER,
    ProgramCard
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "rewardsHubPointsCard",
    "extraSmallCard",
    RewardsPointsPill
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "rewardsPointsPillAnimation",
    "extraSmallCard",
    RewardsPointsPillAnimation
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "rewardsHub",
    "composableCard",
    RewardableTaskCardRenderer
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    DEFAULT_NAMESPACE,
    "ctaCardWrapper",
    RewardsHubCTACard
  );
  MasonryDriverNodeRenderersRegistry.overrideRenderer(
    DEFAULT_NAMESPACE,
    "recommendedContentCard",
    RecommendedContentCard
  );
  MasonryDriverNodeRenderersRegistry.overrideRenderer(
    "rewardsHub",
    "recommendedContentCard",
    BrowseRewardsCtaCard
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    HEALTH_JOURNEY_NAMESPACE,
    "tabs",
    MasonryTabRendererOverride
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "journeyActivities",
    "composableCard",
    ProgressCard
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    PROGRAM_OVERVIEW_PRIZE_CARD,
    "verticalLayout",
    MasonryVerticalLayoutRendererOverride
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    PROGRAM_OVERVIEW_PRIZE_CARD,
    "smallCard",
    MasonrySmallCardRendererOverride
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    PROGRAM_OVERVIEW_DISCLAIMER,
    "statusBanner",
    MasonryStatusBannerDesktopRendererOverride
  );
  MasonryDriverNodeRenderersRegistry.overrideRenderer(
    DEFAULT_NAMESPACE,
    "statusBanner",
    MasonryStatusBannerRendererOverride
  );
  MasonryDriverNodeRenderersRegistry.overrideRenderer(
    JOURNEY_PROGRAM_OVERVIEW_SIDEBAR,
    "verticalLayout",
    MasonryVerticalLayoutSidebarRendererOverride
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    JOURNEY_PROGRAM_OVERVIEW_FOOTER,
    "smallCard",
    MasonrySmallCardRendererOverride
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    JOURNEY_PROGRAM_OVERVIEW_SIDEBAR,
    "composableCard",
    MasonryComposableCardRendererOverride
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "care_discovery",
    "largeCard",
    GetCareServiceCardRenderer
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "rewardsHub",
    "contentBlock",
    MasonryContentBlockRendererOverride
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "rewardableTaskOverview",
    "contentBlock",
    MasonryContentBlockRendererOverride
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "rewardsHubLinkingModal",
    "contentBlock",
    MasonryModalContentBlockRendererOverride
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "rewardsHubEmptyState",
    "contentBlock",
    MasonryEmptyStateContentBlockRendererOverride
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    DEFAULT_NAMESPACE,
    "iconText",
    IconTextRenderer
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    LINK_AEROPLAN_ACCOUNT_CARD,
    "iconText",
    IconTextHeadingRenderer
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "rewardsHub",
    "sectionHeader",
    RewardsPointsDisclaimerHeader
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "rewardsHubPointsHistory",
    "largeCard",
    RewardsHistoryPointsCard
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    POINTS_HISTORY_OVERLINE,
    "sectionHeader",
    PointsHistoryMonthYearSectionHeader
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "rewardsHubPointsHistory",
    "smallCard",
    MasonryPointsHistorySmallCardRenderer
  );
  MasonryDriverNodeRenderersRegistry.overrideRenderer(
    DEFAULT_NAMESPACE,
    "carousel",
    MasonryCarouselRendererOverride
  );
  MasonryDriverNodeRenderersRegistry.overrideRenderer(
    DEFAULT_NAMESPACE,
    "microCard",
    MasonryMicroCardRendererOverride
  );
  MasonryDriverNodeRenderersRegistry.overrideRenderer(
    DEFAULT_NAMESPACE,
    "sectionHeader",
    MasonrySectionHeaderRendererOverride
  );
  MasonryDriverNodeRenderersRegistry.overrideRenderer(
    DEFAULT_NAMESPACE,
    "extraSmallCard",
    MasonryExtraSmallCardRendererOverride
  );
  MasonryDriverNodeRenderersRegistry.overrideRenderer(
    "getCare",
    "sidebarLayout",
    MasonrySidebarLayoutRendererOverride
  );
  MasonryDriverNodeRenderersRegistry.overrideRenderer(
    DEFAULT_NAMESPACE,
    "textAction",
    MasonryTextActionRendererOverride
  );
  MasonryDriverNodeRenderersRegistry.overrideRenderer(
    DEFAULT_NAMESPACE,
    "responsiveHiddenContainer",
    ResponsiveHiddenContainerRenderer
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "manulife",
    NODE_TYPE_REWARDS_HUB_ERROR_STATE,
    RewardsHubErrorStateRenderer
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    REWARDS_HUB_OVERVIEW_LOADER_NAMESPACE,
    "containerSpinner",
    RewardsHubLoader
  );
  MasonryDriverActionController.overrideHandler(
    "handleActionException",
    DEFAULT_NAMESPACE,
    () => {
    }
  );
  MasonryDriverActionController.registerHandler(
    "deeplink",
    "rewards_hub_task_detail_cta",
    ({ payload, event }) => {
      event == null ? void 0 : event.preventDefault();
      sessionStorage.setItem(SESSION_STORAGE_KEYS.REWARDS_CTA_CLICKED, "true");
      const url = payload == null ? void 0 : payload.url;
      if (url) {
        window.open(url, "_blank", "noreferrer");
      }
    }
  );
  MasonryDriverActionController.registerHandler(
    COMPLETE_REWARDABLE_TASK_ACTION_TYPE,
    DEFAULT_NAMESPACE,
    completeRewardableTaskActionHandler
  );
  MasonryDriverActionController.overrideHandler(
    "setTitle",
    DEFAULT_NAMESPACE,
    masonrySetTitleBaseActionHandler
  );
};

// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
var MANULIFE_EXTENSIONS_ASSET_MAP = {};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(MANULIFE_EXTENSIONS_ASSET_MAP);
};

// src/inject-styles.ts
import iconInfoCircleUrl from "././assets/iconInfoCircle.svg";
import checkCircleUrl from "././assets/checkCircle.svg";
var SIGN_UP_PRIVACY = `.GDS-modal-content:has(> section > div > form input[name='confirmedPrivacyPolicy'])`;
var SIGN_UP_EXIT = `.GDS-modal-content:has(> section > button[data-testingid='backButton'])`;
var SIGN_UP_SUCCESS = `.GDS-modal-content:has(> section > div > div > [role='presentation'] + [role='presentation'])`;
var ACTIVITY_EXIT = `.GDS-modal-content:has(> .GDS-box > .GDS-box > img):has(> .GDS-box > button.GDS-button + button.GDS-button)`;
var CSS_STYLES = `
/* MANU-5719: Firefox tofus the precomposed raised trademark marks U+1F16A/B/C (MC/MD/MR) that only Apple system fonts ship; supply them from a synthesised Noto-derived woff2 in a separate family (used only for those codepoints via unicode-range + the rich-text font-family stack below). */
@font-face {
  font-family: 'ManulifeMDFallback';
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
  src: url("data:font/woff2;base64,d09GMgABAAAAAAJEAA0AAAAABGgAAAH2AAID1wAAAAAAAAAAAAAAAAAAAAAAAAAAGyAcQgZgADARCAqDUIJ+ATYCJAMQCwoABCAFBgcgGycDIAYeKM/+ZSZdpGvrA7oRvIG4AuziqbZW/Xsgi/JEgyP4YOcqnqcTK/gIRly3MaLRihyRurKKAmi44YGSV1BWhwkqgMEAACiARgZZGFGeAnqMGz6QqJ69Rsc06eb3Gd5rgD+w28jBUwaUd1WkKPPRgZgpmoDS/pPSQYySA0KvE6pOFUIFsLCyspCTBqtq+P8noPZUZgEKgHASlwEvjAABqIAdEi24GUg3yBWUT/0nHbgCFIMBSxTmYALVgHnAEYBHhyAQSKSqOrg6aCYOlqZ6nbna3Vxn1tqirdiA0KS+Wd+qF5qcsMlVa+oz8y7j7+lnXQhk81lt5v37yoQHD/SzisO2HtXEhoy/q2kyu3evbsL9hYgl3mzWPYe9+7hfvdagocl6Df2sE8qE6x2XV13uExPfM57v7rPHCBsPHzVmd9WkDjG1o3J3vLFXmJBzRr+bmF/RWl1V1FbiFjw6cmygX3ZjfEiP3OyI7q0JOXlBbUn/DM5nPxo4alC/sbsnZ3dExtDXzq+vrawoqErZK/vkrl1VpanpvrP7F448kdlnf/2BhN3Dw9PXZcX/DArxBQAFEPLB6yhDWKdl2jcTnXwJ8Gz8nRcAz3fatpIC8oC4CRghCt+hIe8DuXJMjB+uaqJDriIBuQRQapVoZM4iMkKSZFhNDA==") format('woff2');
  unicode-range: U+1F16A, U+1F16B, U+1F16C;
}
/* Append the fallback family after the brand font on the rich-text containers; unicode-range limits it to the mark codepoints, !important + descendant selector beat Genesis's per-component font-family. */
.toolbox-richtext,
.toolbox-richtext *,
.health-program-rich-text-content,
.health-program-rich-text-content * {
  font-family: 'Manulife JH Sans', 'ManulifeMDFallback', Helvetica, Arial, sans-serif !important;
}

/* MANU-4274: Journey + Rewards program (Overview/Progress) tab list styling - matching masonry tabs */
.league-legacy-global-styles :is(
  .journey-tab-list > .GDS-box,
  .journey-tab-list .GDS-tab,
  .GDS-tab-list-wrapper:not(:has(> .journey-tab-list)),
  .GDS-tab-list-wrapper .GDS-tab-list .GDS-tab
) {
  background-color: #ededed;
}
.league-legacy-global-styles .GDS-tab-list-wrapper:has(> .journey-tab-list) {
  border-block-end: none;
}

/* Set all journey + Rewards program tabs to font-weight 500 to prevent layout shift */
.league-legacy-global-styles :is(.journey-tab-list .GDS-tab, .GDS-tab-list-wrapper .GDS-tab-list .GDS-tab) {
  font-weight: 500;
  color: var(--GDS-onSurface-textSubdued, #5e6073);
  border-block-end-width: 4px;
  border-block-end-style: solid;
  border-block-end-color: transparent;
  padding: 24px 12px;
}

/* Active journey + Rewards program tab styling - stroke width (4px), color (green), and font color */
.league-legacy-global-styles :is(.journey-tab-list .GDS-tab, .GDS-tab-list-wrapper .GDS-tab-list .GDS-tab)[data-state='active'] {
  color: var(--GDS-onSurface-textPrimary, #282b3e);
  border-block-end-color: var(--GDS-interactive-actionPrimary, #046138);
  /* Add 0.5px text-stroke to simulate font-weight 600 without causing layout shift */
  -webkit-text-stroke: 0.5px currentColor;
  text-stroke: 0.5px currentColor;
}

/* Hover state for inactive journey + Rewards program tabs */
.league-legacy-global-styles :is(.journey-tab-list .GDS-tab, .GDS-tab-list-wrapper .GDS-tab-list .GDS-tab):not([data-state='active']):hover {
  border-block-end-color: var(--GDS-interactive-actionDisabled, #c2c3c9);
  -webkit-text-stroke: 0.5px currentColor;
  text-stroke: 0.5px currentColor;
}
/* MANU-5712: the journey hardcodes padding so anomaly extra whitespace appeared  */
.program-overview-progress-layout {
  padding: 0 !important;
}
@media (max-width: 768px) {
  .program-overview-header-layout {
    align-items: start !important;
  }
  .program-overview-progress-layout > div {
    align-items: start;
    justify-content: start;
  }
  .program-overview-progress-layout {
    padding-inline: 0 !important;
  }
}
.configurable-journey-experience-wrapper {
  background-color: inherit !important;
}
.configurable-journey-page-layout {
  max-width: 1200px !important;
}
.GDS-tab-panel {
  padding: var(--GDS-space-one) 0 !important;
}
.GDS-section-header {
  margin-block-start: 0 !important;
}
.GDS-text-action:hover .GDS-icon {
  --fill-color: currentColor;
  --outline-color: currentColor;
  --chevron-color: none;
}
.GDS-tab-list button {
  flex-shrink: 0;
}
.GDS-tab-list button span {
  flex-wrap: nowrap;
}
.GDS-scroll-button {
  border-radius: var(--GDS-radii-circle) !important;
}
/* MANU-5689: On the program detail screen ("Add to Journey" \u2192 Overview/Activities),
   Genesis renders a tab-list scroll button whenever scrollWidth exceeds the container
   width. At narrow widths the two program tabs barely overflow due to per-tab padding,
   so a chevron appears \u2014 but both tabs are already visible, so clicking it does nothing.
   Genesis nests the scroll buttons as siblings of .GDS-tab-list-wrapper inside an
   unnamed (Stitches-hashed) ScrollableWrapper, so we anchor on that wrapper via :has()
   keyed to the stable aria-label="program-tabs". Other tab lists (Health Journey nav,
   challenges) carry different labels and keep functional scroll. The :nth-child(2):last-child
   guard limits this to the current exactly-two-tab layout, so if a third program tab is ever
   added, functional scroll returns automatically rather than being silently suppressed. */
*:has(> .GDS-tab-list-wrapper > .GDS-tab-list[aria-label='program-tabs'] > .GDS-tab:nth-child(2):last-child) .GDS-scroll-button {
  display: none !important;
}
/* Carousel: Previous/Next buttons by aria-label (not other buttons in carousel) */
.masonry-carousel-renderer-override .GDS-button[aria-label="Previous"],
.masonry-carousel-renderer-override .GDS-button[aria-label="Next"] {
  color: var(--GDS-colors-interactiveIconDisabled);
}
.masonry-carousel-renderer-override .GDS-button[aria-label="Previous"] .GDS-icon,
.masonry-carousel-renderer-override .GDS-button[aria-label="Next"] .GDS-icon {
  --fill-color: currentColor;
  --outline-color: currentColor;
}
.masonry-carousel-renderer-override .GDS-button[aria-label="Previous"]:hover:not(:disabled),
.masonry-carousel-renderer-override .GDS-button[aria-label="Previous"]:not(:disabled),
.masonry-carousel-renderer-override .GDS-button[aria-label="Next"]:hover:not(:disabled),
.masonry-carousel-renderer-override .GDS-button[aria-label="Next"]:not(:disabled) {
  color: var(--GDS-colors-onSurfaceIconPrimary);
}
.masonry-carousel-renderer-override .GDS-button[aria-label="Previous"]:hover:not(:disabled),
.masonry-carousel-renderer-override .GDS-button[aria-label="Next"]:hover:not(:disabled) {
  background-color: var(--GDS-colors-inputBackgroundHovered) !important;
}
.masonry-carousel-renderer-override .GDS-button[aria-label="Previous"]:hover:not(:disabled) .GDS-icon,
.masonry-carousel-renderer-override .GDS-button[aria-label="Next"]:hover:not(:disabled) .GDS-icon {
  --fill-color: currentColor;
  --outline-color: currentColor;
}
/* Carousel: reduce gap between Previous/Next buttons */
.masonry-carousel-renderer-override .GDS-horizontal-stack-layout > .GDS-box:last-child > .GDS-box {
  gap: 0 !important;
}
/* Carousel: progress dots \u2013 inactive and active colours */
.masonry-carousel-renderer-override li[data-testid="progress-dot"] {
  background-color: var(--GDS-colors-interactiveIconDisabled);
}
.masonry-carousel-renderer-override li[data-testid="progress-dot"][aria-current="step"] {
  background-color: var(--GDS-colors-onSurfaceIconPrimary);
}
/* MANU-5007: Remove horizontal padding on header so heading/body aligns with tabs below (desktop only) */
@media (min-width: 768px) {
  .journey-header-container.configurable-journey-page-layout {
    padding-inline: 0 !important;
  }
}
/* MANU-5007: Reduce header-to-tabs spacing to 72px */
.journey-header-container {
  min-height: auto !important;
  padding-bottom: 64px !important;
}

.journey-header-content-wrapper > .GDS-heading-text {
  font-size: var(--GDS-fontSizes-headingOne);
  font-weight: var(--GDS-fontWeights-headingOne);
  line-height: var(--GDS-lineHeights-headingOne);
  /* MANU-5890: long single-token names (e.g. UAT test accounts) have a min-content
     width wider than the viewport, so the flex header overflows and clips instead of
     wrapping. 'anywhere' (unlike 'break-word') shrinks the intrinsic min-content, letting
     the header narrow to the viewport and wrap. Short names are untouched. */
  overflow-wrap: anywhere;
}

/* MANU-5924: host shell's global 'h1..h6 text-wrap: balance' (its @layer base) balances the
   RT/program Overview title into short equal lines. Unlayered here so it beats the host rule;
   reset to greedy wrap so the heading fills its line. */
.program-overview-header-layout .GDS-heading-text {
  text-wrap: wrap !important;
}

.configurable-journey-page-layout .GDS-section-header h2.GDS-heading-text {
  font-size: var(--GDS-fontSizes-headingTwo);
  font-weight: var(--GDS-fontWeights-headingTwo);
  line-height: var(--GDS-lineHeights-headingTwo);
  letter-spacing: var(--GDS-letterSpacings-headingTwo);
  text-transform: var(--GDS-textTransforms-headingTwo);
  text-decoration: var(--GDS-textDecorations-headingTwo);
}

.configurable-journey-page-layout .GDS-section-header h3.GDS-heading-text {
  font-size: var(--GDS-fontSizes-headingThree);
  font-weight: var(--GDS-fontWeights-headingThree);
  line-height: var(--GDS-lineHeights-headingThree);
  letter-spacing: var(--GDS-letterSpacings-headingThree);
  text-transform: var(--GDS-textTransforms-headingThree);
  text-decoration: var(--GDS-textDecorations-headingThree);
}

.league-legacy-global-styles .legacy-activity-footer {
  position: static !important;
}

.genesis.cc-page-header-background::before {
  display: none !important;
}

/* SidebarLayout sets flexBasis: 0 on main content; on mobile (column direction)
   this collapses its height to 0. Override to auto so content sizes naturally. */
@media (max-width: 767px) {
  .masonry-sidebar-layout-renderer-override > #layout-box-renderer {
    flex-basis: auto;
  }
}
/* Remove card height so it stretches to match carousel */
.masonry-sidebar-layout-renderer-override .GDS-flat-card {
  height: auto;
}
/* Align card content to top per design */
.masonry-sidebar-layout-renderer-override .GDS-card-section {
  align-items: start;
}

/* ==========================================================================
   Full-page / journey error: wrapper = direct div child of
   .league-css-reset.league-legacy-global-styles whose structure is
   > div > .GDS-image-message.error-state-container (Genesis stack \u2192 ImageMessage).
   ImageMessage internals use .error-state-container only.
   ========================================================================== */

div:has(> div > .GDS-image-message.error-state-container) {
  flex-direction: column;
  align-items: flex-start;
}

div:has(> div > .GDS-image-message.error-state-container) > div {
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin-top: var(--GDS-space-twoAndHalf);
}

/* Icon 48\xD748, 8px (half) gap below icon */
.error-state-container img {
  width: 48px;
  height: 48px;
}
.error-state-container > div:first-child {
  justify-content: flex-start;
  align-items: flex-start;
  margin-block-end: var(--GDS-space-half);
}

/* Content wrapper: no top spacing, twoAndHalf gap, left-aligned */
.error-state-container > div:nth-child(2) {
  margin-block-start: 0;
  padding-block-start: 0;
}
.error-state-container > div:nth-child(2) > div {
  margin-top: 0;
  gap: var(--GDS-space-twoAndHalf);
  align-items: flex-start;
}

/* Heading: GDS HeadingOne */
.error-state-container .error-state-heading-text {
  font-size: var(--GDS-fontSizes-headingOne);
  font-weight: var(--GDS-fontWeights-headingOne);
  font-family: var(--GDS-fonts-headingOne);
  line-height: var(--GDS-lineHeights-headingOne);
  letter-spacing: var(--GDS-letterSpacings-headingOne);
  text-transform: var(--GDS-textTransforms-headingOne);
  text-decoration: var(--GDS-textDecorations-headingOne);
  text-align: left;
}

/* Body text: GDS HeadingThree */
.error-state-container .error-state-body-text {
  font-size: var(--GDS-fontSizes-headingThree);
  font-weight: var(--GDS-fontWeights-headingThree);
  font-family: var(--GDS-fonts-headingThree);
  line-height: var(--GDS-lineHeights-headingThree);
  letter-spacing: var(--GDS-letterSpacings-headingThree);
  text-transform: var(--GDS-textTransforms-headingThree);
  text-decoration: var(--GDS-textDecorations-headingThree);
  text-align: left;
}

/* 8px (half) between heading and body; twoAndHalf above Try again button */
.error-state-container .error-state-text-wrapper > div {
  gap: var(--GDS-space-half);
}
.error-state-container .error-state-button-wrapper {
  margin-block-start: var(--GDS-space-twoAndHalf);
}

/* ==========================================================================
   MANU-4798: Rewards Hub error state \u2014 standalone ErrorState (no FullPageError
   wrapper). Forces the ImageMessage to stack icon-over-content vertically and
   cleans up the doubled spacing that FullPageError's wrapper selector adds.

   Paired with: src/components/rewards-hub-error-state/rewards-hub-error-state-renderer.component.tsx
   Scoped under: .rewards-hub-error-container (set by the renderer's wrapper div)
   ========================================================================== */

.rewards-hub-error-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-block: var(--GDS-space-twoAndHalf);
}

/* Force vertical stacking of icon wrapper and content wrapper */
.rewards-hub-error-container .error-state-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: auto;
}

/* 8px (half) gap below icon \u2014 matches full-page error */
.rewards-hub-error-container .error-state-container > div:first-child {
  margin-block-end: var(--GDS-space-half);
}

/* Content wrapper sits flush under the icon, left-aligned */
.rewards-hub-error-container .error-state-container > div:nth-child(2) > div {
  gap: var(--GDS-space-twoAndHalf);
  align-items: flex-start;
}

/* ErrorContent wraps heading + body in an inner StackLayout with
   horizontalAlignment="center"; force it left-aligned within our scope. */
.rewards-hub-error-container .error-state-container .error-state-text-wrapper > div {
  align-items: flex-start;
  text-align: left;
}

/* Single twoAndHalf (40px) above the Try again button \u2014 the shared rule adds a
   second 40px which stacks on the outer flex gap; override back down to 0. */
.rewards-hub-error-container .error-state-container .error-state-button-wrapper {
  margin-block-start: 0;
}

/* Description text: headingThree style + onSurfaceTextSubdued color per Figma. */
.rewards-hub-error-container .error-state-container .error-state-body-text {
  font-size: var(--GDS-fontSizes-headingThree);
  font-weight: var(--GDS-fontWeights-headingThree);
  line-height: var(--GDS-lineHeights-headingThree);
  letter-spacing: var(--GDS-letterSpacings-headingThree);
  color: var(--GDS-colors-onSurfaceTextSubdued);
}

/* MANU-5152: Toast close button a11y \u2014 add circular background for visibility and touch target.
   MANU-5380: Progress-only variant lives in BannerContainer (outside .toast-wrapper), so cover both. */
:is(.toast-wrapper, :has(> .badge-progress-wrapper)) .GDS-button {
  color: var(--GDS-colors-onSurfaceIconPrimary);
}

:is(.toast-wrapper, :has(> .badge-progress-wrapper)) .GDS-button:hover {
  background-color: var(--GDS-colors-onSurfaceIconPrimary) !important;
  color: var(--GDS-colors-onSurfaceTextReversed) !important;
}

/* MANU-5380: Rewards toast surfaces per Figma. !important wins specificity ties with Stitches. */

/* Header \u2014 no manulife theme token matches #E3F7F0 */
.toast-wrapper {
  background-color: #E3F7F0 !important;
}

/* Points-only variant \u2014 :last-child = no progress sibling */
.toast-wrapper:last-child {
  background-color: var(--GDS-colors-surfaceCardPrimary) !important;
}

/* Aeroplan pill \u2014 Badge renders as HorizontalStackLayout (no other stable class) */
.toast-wrapper .GDS-horizontal-stack-layout {
  background-color: var(--GDS-colors-surfaceCardSecondary) !important;
  border-radius: var(--GDS-radii-circle) !important;
}

/* Progress section (BannerContainer) */
:has(> .badge-progress-wrapper) {
  background-color: var(--GDS-colors-surfaceCardPrimary) !important;
}

/* Bar fill \u2014 only-child .GDS-box; excludes the empty track in isLoading state */
.badge-progress-wrapper .GDS-box > .GDS-box:only-child {
  background-color: var(--GDS-colors-interactiveActionPrimary) !important;
}

/* MANU-5234: Remove tag border so tag height matches Figma specs */
.league-legacy-global-styles .GDS-tag {
  border-width: 0;
}

/* MANU-5228: Modal border-radius and close button color overrides */
.GDS-modal {
  border-radius: 0;
}
.GDS-modal .GDS-modal-close-button-wrapper > .GDS-modal-close-button {
  color: #191C19;

  &:hover,
  &:active {
    background-color: transparent;
  }
}

/* MANU-5292: Ensure ProgramRichText paragraphs use Manulife JH Sans */
/* MANU-5009: Remove browser-default paragraph margin so heading-to-body spacing is 16px */
.health-program-rich-text-content > p {
  font-family: 'Manulife JH Sans', Helvetica, Arial, sans-serif;
  margin: 0;
}

/* MANU-5483: Rich-text links anywhere in the app \u2014 Tertiary/Text default token per Figma */
p .GDS-text-action {
  color: var(--GDS-colors-tertiaryTextDefault) !important;
}

/* MANU-5685: on narrow columns the sentence-ending "." after a rich-text link drops to the
   next line, because Genesis TextAction renders display:inline-flex (an atomic inline box)
   and forces a wrap right after the link. Setting it inline lets the punctuation line-break
   as continuous text with the link. Tablet & below only \u2014 wider columns don't wrap there. */
@media (max-width: 1023px) {
  .health-program-rich-text-content a.GDS-text-action {
    display: inline !important;
  }
}

/* MANU-5272: Remove top margin from the first h4 in a tab panel so it doesn't
   create excess spacing when rich text content opens with a heading */
.GDS-tab-panel h4:first-child {
  margin-top: 0;
}

/* MANU-5006: RP card background \u2014 surfaceBackgroundPrimary instead of Secondary.
   Post rewards-programs 2.43.x DOM change, the summary moved out of the trigger span
   into the GDS-Box wrapping the accordion header \u2014 scope to that box (stable hooks). */
.cc-accordion-root
  .cc-accordion-item
  > [data-testid="GDS-Box"]:has(> .cc-accordion-header) {
  background: var(--GDS-colors-surfaceBackgroundPrimary);
}

/* MANU-5359 Fixed height matches design and avoids tab scroll on mobile */
.GDS-tab-list {
  min-height:74px !important;
}

/* MLI-1148: RewardProgramsProgress value row \u2014 the installed SDK (v2.43.x) renders
   RewardPointsIcon + three separate UtilityText spans ("/", "100", "Aeroplan Points Earned")
   in a horizontal flex row. The outer StackLayout has align-items:flex-start so the row
   shrinks to ~156px, clamping "Aeroplan Points Earned" to its min-content (68px / longest word).
   This causes 3-line wrap; with align-items:center, "Aeroplan" appears above the icon.
   Fix: force the value row to full-width block+inline flow so all spans fit on one line.
   Two cases:
   - showProgress=true: SDK sets aria-hidden="true" on the value row.
   - showProgress=false: no aria-hidden; the value row is the :only-child of the outer StackLayout.
     The parent verticalAlignment-center class substring narrows this to RewardProgramsProgress.
   Fix-layer: inject-styles.ts interim (SDK fix needed in league-web). */
.GDS-vertical-stack-layout > .GDS-horizontal-stack-layout[aria-hidden="true"],
.GDS-vertical-stack-layout[class*="verticalAlignment-center"] > .GDS-horizontal-stack-layout:only-child {
  display: block !important;
  width: 100% !important;
}
/* RewardPointsIcon (itself a GDS-horizontal-stack-layout) \u2014 inline so it flows with text */
.GDS-vertical-stack-layout > .GDS-horizontal-stack-layout[aria-hidden="true"] > .GDS-horizontal-stack-layout,
.GDS-vertical-stack-layout[class*="verticalAlignment-center"] > .GDS-horizontal-stack-layout:only-child > .GDS-horizontal-stack-layout {
  display: inline-flex !important;
  vertical-align: middle !important;
  margin-inline-end: var(--GDS-space-quarter) !important;
}
/* Each UtilityText span ("/", "100", "Aeroplan Points Earned") \u2014 inline, with gap spacing */
.GDS-vertical-stack-layout > .GDS-horizontal-stack-layout[aria-hidden="true"] > .GDS-utility-text,
.GDS-vertical-stack-layout[class*="verticalAlignment-center"] > .GDS-horizontal-stack-layout:only-child > .GDS-utility-text {
  display: inline !important;
  vertical-align: middle !important;
  margin-inline-end: var(--GDS-space-quarter) !important;
}

/* MANU-5451: The Disclaimer section background color and icon is not matching Figma.
   The Group challenge page has a legacy realization in sdk
   with a hardcoded LegalDisclaimer StatusBanner.
   So the solution overrides neutral grey to surfaceBackgroundPrimary (white),
   and swaps the hardcoded interfaceQuestionCircleFilled icon to the (iconInfoCircle.svg).
   Icon swap: hide the <svg> via display:none,
   then render the replacement as a background-image on ::before.

   Page-scope guard matches BOTH icon render shapes: the Vite dev server serves
   genesis-core icons as standalone assets referenced via <use href=".../foo.svg#id">,
   while the bundled build inlines the symbol as <svg id="capabilityGroupChallenges">.
   Matching only the <use> form silently no-ops on bundled builds. */
body:has(use[href$="#capabilityGroupChallenges"], svg#capabilityGroupChallenges) .GDS-tab-panel[aria-labelledby$="-trigger-overview"] > .GDS-vertical-stack-layout > .GDS-status-banner {
  background-color: var(--GDS-colors-surfaceBackgroundPrimary) !important;
}
body:has(use[href$="#capabilityGroupChallenges"], svg#capabilityGroupChallenges) .GDS-tab-panel[aria-labelledby$="-trigger-overview"] > .GDS-vertical-stack-layout > .GDS-status-banner .GDS-icon {
  display: none;
}
body:has(use[href$="#capabilityGroupChallenges"], svg#capabilityGroupChallenges) .GDS-tab-panel[aria-labelledby$="-trigger-overview"] > .GDS-vertical-stack-layout > .GDS-status-banner > .GDS-stack-item:first-child {
  width: 1rem;
  height: 1rem;
  min-width: 1rem;
  min-height: 1rem;
  margin-top: 4px;
  background-image: url("${iconInfoCircleUrl}");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

/* MANU-5623: Group challenge leaderboard "all-time ranking" tooltip restyle.
   The popover is SDK-rendered (genesis-core Popover.Content) with no Manulife-only prop
   hook, so we override via CSS. It renders in a portal but stays a descendant of <body>,
   so the body:has() page-scope still matches.
   - Remove the close (X) button: showCloseButton defaults to true at the league-web
     call site, so hide the heading bar (display:none also drops it from the a11y tree).
     The popover still dismisses on outside-click / Escape.
   - Dark background (#282B3E) + white text (#FFFFFF) + square corners (override the
     component's $medium 6px radius to 0) per design.
   - Caret pointing at the trigger icon: Genesis renders no Radix arrow, so fake one with a
     rotated-square ::after straddling the edge (see caret rules below). position:relative
     anchors it; the right-offset is approximate and may need a px nudge after a visual check. */
body:has(use[href$="#capabilityGroupChallenges"], svg#capabilityGroupChallenges) .GDS-popover-heading-bar {
  display: none;
}
body:has(use[href$="#capabilityGroupChallenges"], svg#capabilityGroupChallenges) .GDS-popover-content {
  background-color: #282b3e !important;
  border-radius: 0 !important;
  position: relative !important;
}
body:has(use[href$="#capabilityGroupChallenges"], svg#capabilityGroupChallenges) .GDS-popover-content .GDS-paragraph-text {
  color: #ffffff !important;
}
/* Caret: rotated 10px square straddling the popover edge near the end (under the icon).
   Solid dark fill, no border. Separate
   rules for side="top" (caret below, the default) and the collision-flipped side="bottom". */
body:has(use[href$="#capabilityGroupChallenges"], svg#capabilityGroupChallenges) .GDS-popover-content[data-side="top"]::after,
body:has(use[href$="#capabilityGroupChallenges"], svg#capabilityGroupChallenges) .GDS-popover-content[data-side="bottom"]::after {
  content: "";
  position: absolute;
  right: 14px;
  width: 10px;
  height: 10px;
  background-color: #282b3e;
  transform: rotate(45deg);
}
body:has(use[href$="#capabilityGroupChallenges"], svg#capabilityGroupChallenges) .GDS-popover-content[data-side="top"]::after {
  top: 100%;
  margin-top: -5px;
}
body:has(use[href$="#capabilityGroupChallenges"], svg#capabilityGroupChallenges) .GDS-popover-content[data-side="bottom"]::after {
  bottom: 100%;
  margin-bottom: -5px;
}

/* MANU-5348: Activity cards on Reward Program detail page \u2014 flatten the per-card
   borders, replace with margin/padding around content per MLI Option A design.
   Mobile only; desktop (>=1024px) layout unchanged. */
@media (max-width: 1023px) {
  .cc-accordion-content [data-testid="GDS-CardClickArea"] {
    margin: var(--GDS-space-half);
    padding: var(--GDS-space-half);
  }
  .cc-accordion-content [data-testid="GDS-CardClickArea"]:hover {
    border: var(--GDS-borderWidths-card) solid var(--GDS-colors-interactiveFocusOuter);
  }
/* Rewards program activity list (mobile) \u2014 hide league-web's StackLayout
divider between activity cards and tighten card-to-card spacing. */
  .cc-accordion-content
  .GDS-flat-card
  + [data-testid="GDS-Box"] {
  height: 0 !important;
  background-color: transparent !important;
  margin-block: -8px;
}

}

/* MANU-5616: Reward Program activity completion banner \u2014 the "Completed"
   h3 uses $onSurfaceTextSuccess (#06874E) on $successBackgroundSecondary
   (#CAEED9), yielding 3.65:1 which fails WCAG AA. Darken to
   $onSurfaceTextPrimary so the heading reaches AA on the same banner
   background.
   Scope: the banner is rendered inside the always-visible
   .cc-accordion-trigger (not .cc-accordion-content) because rewards-programs
   places the completion summary in the accordion header. The only h3 that
   sits as a direct sibling of a .GDS-icon (the IconText pattern) is the
   "Completed" heading \u2014 every other IconText caller in the SDK and in
   manulife-web passes a UtilityText/span, not an h3. */
.cc-accordion-trigger
  .GDS-horizontal-stack-layout:has(> .GDS-icon)
  > h3.GDS-heading-text {
  color: var(--GDS-colors-onSurfaceTextPrimary) !important;
}

/* MANU-5350: Unlinked "Ways to earn" renders as a plain full-width grid (no
   sidebar, unlike the linked layout). The SDK auto-fill grid therefore drops to
   2 columns as soon as two ~300px cards fit (~728px viewport), so the cards
   re-grid on small/tablet screens instead of staying stacked. Design wants them
   as a single stacked column below 810px and 2-up only at >=810px (matching
   where the linked layout's sidebar naturally yields 2 columns).
   Scoped to the unlinked Ways-to-Earn grid node by its stable Masonry testid, so
   linked and every other grid in the app are untouched. The grid element is the
   direct .GDS-box (display:grid) child of that node's vertical stack. */
@media (max-width: 809px) {
  [data-testid="gridLayout$rewardsHub$web$unlinkedExperience$rootWaysToEarnWebContentUnlinked"]
    > .GDS-box {
    grid-template-columns: 1fr !important;
  }
}

/* MANU-5664: Flicker on SDK loading screens when the browser window is shrunk
   vertically (most visibly the rewards-programs reward-program landing page in
   UAT, where real network latency keeps the loader on screen long enough to see it).

   Root cause: @leagueplatform/web-common-components' <LoadingIndicator/> is
   rendered without the "inline" prop across the SDK, so its LoaderContainer
   (a genesisStyled Box) takes the absolute branch:
     position:absolute; top:0; inset-inline-start:0; height:100%; width:100%; min-height:300px.
   Out of flow, it contributes no height to its parent yet depends on the parent's
   height \u2014 a non-converging vertical layout when the viewport height shrinks,
   which oscillates (the "ResizeObserver loop" console warnings) and flickers.
   Confirmed in DevTools: forcing the wrapper back into flow (position:relative)
   stops it; changing height alone does not.

   Fix: pull the loader back into normal flow so it reserves its own min-height
   (the safe pattern RewardsHubLoader already uses). height:auto is insurance so the
   leftover height:100% can't stretch the box if an ancestor has a definite height.

   Scoped by stable, non-hashed hooks only: the two legacy-scope classes web-common
   puts on the wrapper (Manulife runs embedded with shouldApply*Styles=false, so
   these are always present) + the "genesis" class (distinguishes the LoaderContainer
   from its plain parent) + a :has() fingerprint of the default genesis spinner
   (aria-hidden span > svg > use). The :has() excludes FullPageError/error states
   (no spinner) and the host harness's own shared-module loader (different DOM).
 */
.genesis.league-css-reset.league-legacy-global-styles:has(
    > div span[aria-hidden="true"] svg use
  ) {
  position: relative !important;
  height: auto !important;
}

/* MLI-1099 follow-up (manulife-web local patch):
   Achievement Unlocked celebration modal \u2014 long unbroken celebration_title
   names (e.g. interpolated test usernames) get clipped inside the multi-
   achievement carousel because the SDK's overflow-wrap: break-word does
   not influence min-content sizing in the heading's flex (StackLayout)
   parent. The heading expands to the long word's width, overflows the
   368px container, and gets clipped by the carousel's overflow: hidden.

   */
.GDS-modal:has(
    > .GDS-modal-content
    > .GDS-vertical-stack-layout
    > .GDS-box
    > .GDS-box
    > svg
  )
  h1 {
  word-break: break-word !important;
}

/* MANU-5885: SDK Carousel's <ul> track relies on the global CSS reset Manulife
   disables, so slide <li> markers show as a stray dot. Proper fix belongs in the SDK. */
.GDS-modal:has(
    > .GDS-modal-content
    > .GDS-vertical-stack-layout
    > .GDS-box
    > [data-testid="carousel"]
  )
  [data-testid="carousel"]
  > div
  > ul {
  list-style: none !important;
}

/* MANU-6460: SDK challenge Prize/Details/Rules bullets use an unquoted url(), which MLI's
   inlined SVG breaks \u2014 re-apply quoted. ul.genesis keeps other overview lists out.
   Proper fix belongs in the SDK. */
.GDS-tab-panel[aria-labelledby$="-trigger-overview"]
  > .GDS-vertical-stack-layout
  > .GDS-vertical-stack-layout
  > h2.GDS-heading-text:first-child
  ~ ul.genesis
  > li {
  background-image: url("${checkCircleUrl}") !important;
}

/* MANU-5697: the health-activity flow renders an sr-only role=status */
.health-activity-content-wrapper > [role="status"][aria-live="polite"] {
  display: none !important;
}

/* MANU-5637: SDK renders this CTA as a position:fixed bar that lands behind Manulife's
   footer \u2014 drop it into flow. Keep all three scope conditions: the icon hook alone also
   matches card pages, and its <use>-only form no-ops on bundled builds (MANU-5451 above). */
@media (max-width: 1023px) {
  body:has(use[href$="#capabilityGroupChallenges"], svg#capabilityGroupChallenges)
    [data-testid="GDS-Tabs"]
    + div
    > .GDS-vertical-stack-layout:has(
      > button[data-testid="GDS-Button"]:only-child
    ) {
    position: static !important;
    background-color: #fafafa !important;
  }
}

/* MANU-5755: Group challenge Leaderboard "Top Ranked" podium overlaps at narrow
   widths. The SDK PodiumMedalist (league-web challenges) gives each of the three
   medalists a fixed-px avatar (rank-1 = 90px, others = 75px at the base "_"
   breakpoint, i.e. below genesis-commons' phone = 480px) inside a width:33% column,
   and renders the name as a plain <p> with no wrap. In Manulife's embedded shell the
   leaderboard card is narrower than league-web assumes, so below 480px the avatars
   are wider than their column (circles overlap) and long single-token usernames
   overflow the column (names overlap \u2014 see ticket screenshot).
   Manulife-only interim fix (proper fix belongs in the SDK):
   - drop the per-column horizontal margin to reclaim width;
   - shrink the avatars fluidly (min(80px, 22vw)) so they always fit the column,
     capped at 80px so they never exceed the SDK's own base size;
   - let usernames wrap instead of overflowing.
   Scope: group-challenge page (#capabilityGroupChallenges, both icon render shapes \u2014
   see the MANU-5451 note above) + Leaderboard tab panel + the podium <ol>. The
   all-time ranking <ol> carries aria-labelledby; the podium one does not \u2014
   :not([aria-labelledby]) isolates the podium and leaves the list alone.
   The avatar wrapper is the only <li> child <div> holding an aria-hidden subtree
   (the decorative avatar); the activity-count badge and crown <img> don't match.
   The size cap only applies below phone (480px), where the SDK uses the small sizes;
   at/above 480px the SDK avatars grow and the wider card fits them without help. */
@media (max-width: 479px) {
  body:has(use[href$="#capabilityGroupChallenges"], svg#capabilityGroupChallenges)
    .GDS-tab-panel[aria-labelledby$="-trigger-leaderboard"]
    ol:not([aria-labelledby]) > li {
    margin-inline: 2px !important;
  }
  body:has(use[href$="#capabilityGroupChallenges"], svg#capabilityGroupChallenges)
    .GDS-tab-panel[aria-labelledby$="-trigger-leaderboard"]
    ol:not([aria-labelledby]) > li > div:has(> [aria-hidden="true"]) {
    width: min(80px, 22vw) !important;
    height: min(80px, 22vw) !important;
  }
}
/* Username wrap \u2014 harmless at all widths, prevents name overflow everywhere */
body:has(use[href$="#capabilityGroupChallenges"], svg#capabilityGroupChallenges)
  .GDS-tab-panel[aria-labelledby$="-trigger-leaderboard"]
  ol:not([aria-labelledby]) > li > p {
  overflow-wrap: anywhere;
  word-break: break-word;
  max-width: 100%;
  text-align: center;
}

/* MLI-1368: Group challenge Activities tab cards blend into the page \u2014 the SDK
   ComposableActivityCard hardcodes $surfaceCardSecondary (#FAFAFA, same as the page
   bg). Design wants Surface/Card Primary. Scoped to this tab (page guard: see
   MANU-5451) since the card is reused on Journey. Interim \u2014 fix belongs in the SDK. */
body:has(use[href$="#capabilityGroupChallenges"], svg#capabilityGroupChallenges)
  .GDS-tab-panel[aria-labelledby$="-trigger-activities"]
  .GDS-elevated-card {
  background-color: var(--GDS-colors-surfaceCardPrimary) !important;
}

/* MLI-1029: Reward Program detail cards (Program Progress / Program Details) \u2014
   match Figma spec. These are SDK ProgramDetailCards (health-journey-common):
   Card.Elevated > Card.Section (24px padding all round) > StackLayout
   spacing="$oneAndHalf" (24px heading\u2192content gap). Figma wants top/bottom padding
   22px (left/right stay 24px) and a 16px heading\u2192content gap.
   No Manulife/SDK class hook on the card and it's a plain nested component (not a
   Masonry node), so scope to the reward-program page via the SDK's stable
   .reward-program-header-badge (set in reward-program-header.component.tsx). On this
   page every .GDS-elevated-card is a ProgramDetailCard; challenges/other pages lack
   the badge so they're untouched. Interim \u2014 proper fix belongs in the SDK. */
body:has(.reward-program-header-badge) .GDS-elevated-card > .GDS-card-section {
  padding-block: 22px !important;
}
body:has(.reward-program-header-badge)
  .GDS-elevated-card
  > .GDS-card-section
  > .GDS-vertical-stack-layout {
  gap: 16px !important;
}

/* MANU-5887 (interim): Manulife host shell (mux) sizes .mux-Layout-Container to full viewport
   width but offsets it by the 80px rail, clipping its right edge off-screen \u2014 visible on
   Journey \u2192 Explore where masonry grids stretch to fill. Cap to (100% \u2212 rail) to keep gutters
   symmetric. Scoped to the journey page (:has) and rail-present widths (@media \u2265768; below that
   the rail collapses). Proper fix belongs in the host shell; remove once fixed. */
@media (min-width: 768px) {
  .mux-Layout-Container:has(.configurable-journey-experience-wrapper) {
    max-width: calc(100% - var(--mux-Layout-MainNav-width, 80px)) !important;
  }
}

/* Honor the success body's "\\n\\n" paragraph break; scoped to the success content column only. */
body:has(use[href$="#capabilityGroupChallenges"], svg#capabilityGroupChallenges)
  .GDS-modal-content
  div:has(> [role='presentation']) + div p {
  white-space: pre-line !important;
}

/* MANU-6207: sign-up success screen \u2014 SDK builds both CTAs from commons BaseButtons (body1/medium), spec wants buttonOne. Matches a/button because userCanJoinTeam renders the primary CTA as a router Link. Proper fix belongs in the SDK. */
${SIGN_UP_SUCCESS} :is(button, a) {
  font-family: var(--GDS-fonts-buttonOne) !important;
  font-size: var(--GDS-fontSizes-buttonOne) !important;
  font-weight: var(--GDS-fontWeights-buttonOne) !important;
  line-height: var(--GDS-lineHeights-buttonOne) !important;
}

/* MANU-6207: same screen \u2014 image column hardcodes marginInlineEnd $four (64px) from tablet up, spec is 32px; below tablet the SDK uses auto to centre it, so leave that alone. */
@media (min-width: 768px) {
  ${SIGN_UP_SUCCESS} > section > div > div:has(> [role='presentation']) {
    margin-inline-end: var(--GDS-space-two) !important;
  }
}

/* MANU-6207: same screen stacked \u2014 CTAs are spaced by the primary's marginBottom $oneAndHalf (24px), spec is 16px; from tablet up they sit side by side on $one already. */
@media (max-width: 767.99px) {
  ${SIGN_UP_SUCCESS} :is(button, a):has(+ :is(button, a)) {
    margin-bottom: var(--GDS-space-one) !important;
  }
}

/* MANU-6207: sign-up exit screen \u2014 SDK's wrapper sets alignItems/justifyContent but Genesis Box is display:block, so nothing centers. Proper fix belongs in the SDK. */
${SIGN_UP_EXIT} > section > .GDS-box {
  display: flex !important;
}

/* MANU-6207: same screen \u2014 Exit CTA wrapper hardcodes marginTop $four (64px), spec is 8px. */
${SIGN_UP_EXIT} > section > .GDS-box .GDS-box:has(> button.GDS-button) {
  margin-top: var(--GDS-space-half) !important;
}

/* MANU-6207: same screen below tablet \u2014 SDK stacks the column and auto-centers only the image, leaving copy + CTA (inline-flex, so text-align centers it) left-aligned. */
@media (max-width: 767.99px) {
  ${SIGN_UP_EXIT} > section > .GDS-box > div.genesis > div.genesis {
    text-align: center !important;
  }
}

/* MANU-6207: same screen at mobile \u2014 SDK switches the modal to align-items: flex-start; auto margins re-center it and still collapse to top when content outgrows the viewport. */
@media (max-width: 640.99px) {
  ${SIGN_UP_EXIT} > section {
    margin-block: auto !important;
  }
}

/* MANU-6207: sign-up privacy screen \u2014 top-aligned at every width (SDK's align-items: center never wins, and @mobile flips it to flex-start anyway), so auto margins take the cross-axis instead. */
${SIGN_UP_PRIVACY} > section {
  margin-block: auto !important;
}

/* MANU-6207: same screen \u2014 SDK's StyledUL leaves the UA ul margin, which Manulife keeps (no CSS reset). Proper fix belongs in the SDK. */
${SIGN_UP_PRIVACY} ul {
  margin-block-start: 0 !important;
}

/* MANU-6207: same screen \u2014 SDK builds Sign up from a commons BaseButton (body1/medium), so only Close (core Button, size large) gets buttonOne; match them. */
${SIGN_UP_PRIVACY} form button[type='submit'] {
  font-family: var(--GDS-fonts-buttonOne) !important;
  font-size: var(--GDS-fontSizes-buttonOne) !important;
  font-weight: var(--GDS-fontWeights-buttonOne) !important;
  line-height: var(--GDS-lineHeights-buttonOne) !important;
}

/* MANU-6309: SDK ships Keep Going as tertiary+quiet; spec wants the secondary outline at a 2pt stroke. Proper fix belongs in the SDK. */
${ACTIVITY_EXIT} > .GDS-box > button.GDS-button:first-child {
  background-color: var(--GDS-colors-secondaryBackgroundDefault) !important;
  border-color: var(--GDS-colors-secondaryBorderDefault) !important;
  border-width: var(--GDS-borderWidths-thick) !important;
  color: var(--GDS-colors-secondaryTextDefault) !important;
}

/* MANU-6309: same button \u2014 secondary drops its border and flips the label on hover/active. */
${ACTIVITY_EXIT} > .GDS-box > button.GDS-button:first-child:hover {
  background-color: var(--GDS-colors-secondaryBackgroundHovered) !important;
  border-color: transparent !important;
  color: var(--GDS-colors-secondaryTextHovered) !important;
}

${ACTIVITY_EXIT} > .GDS-box > button.GDS-button:first-child:active {
  background-color: var(--GDS-colors-secondaryBackgroundPressed) !important;
  border-color: transparent !important;
  color: var(--GDS-colors-secondaryTextHovered) !important;
}

/* MANU-6309: SDK justifies the footer flex-end; spec centres it. No-op at mobile, where both buttons fill the row. */
${ACTIVITY_EXIT} > .GDS-box:has(> button.GDS-button) {
  justify-content: center !important;
}

`;
var injectStyles = () => {
  if (typeof document === "undefined" || document.getElementById("manulife-web-extensions-styles")) {
    return;
  }
  const style = document.createElement("style");
  style.id = "manulife-web-extensions-styles";
  style.textContent = CSS_STYLES;
  document.head.appendChild(style);
};

// src/utilities/setup-locale-profile-sync.util.ts
import { getConfig, subscribeToConfig } from "@leagueplatform/config";
import { getCurrentLocale } from "@leagueplatform/locales";
import { setUserProfile } from "@leagueplatform/user-profile-api";
import { captureError as captureError3 } from "@leagueplatform/observability";

// src/utilities/normalize-ca-locale.util.ts
function normalizeCaLocale(locale) {
  switch (locale == null ? void 0 : locale.toLowerCase().split(/[-_]/)[0]) {
    case "en":
      return "en-CA";
    case "fr":
      return "fr-CA";
    default:
      return locale;
  }
}

// src/utilities/setup-locale-profile-sync.util.ts
var isInitialized = false;
var lastSyncedLocale;
function syncLocaleToUserProfile() {
  return __async(this, null, function* () {
    const locale = normalizeCaLocale(getCurrentLocale());
    if (!locale || locale === lastSyncedLocale)
      return;
    try {
      yield setUserProfile({ locale });
      lastSyncedLocale = locale;
    } catch (error) {
      captureError3(
        error instanceof Error ? error : new Error("[manulife] Failed to sync locale to user profile")
      );
    }
  });
}
function setupLocaleProfileSync() {
  if (isInitialized || typeof window === "undefined")
    return;
  isInitialized = true;
  subscribeToConfig(
    (configWithStatus) => configWithStatus.config.core.api.wsUrl,
    (wsUrl) => {
      if (wsUrl)
        syncLocaleToUserProfile();
    }
  );
  const observer = new MutationObserver(() => {
    var _a, _b;
    const { config } = getConfig(false);
    if (!((_b = (_a = config == null ? void 0 : config.core) == null ? void 0 : _a.api) == null ? void 0 : _b.wsUrl))
      return;
    syncLocaleToUserProfile();
  });
  observer.observe(document.documentElement, { attributeFilter: ["lang"] });
}

// src/components/configurable-back-button/configurable-back-button.component.tsx
import { TextAction as TextAction7 } from "@leagueplatform/genesis-core";
import { useNavigate } from "react-router-dom";
import { useIntl as useIntl18 } from "@leagueplatform/locales";
import { jsx as jsx55 } from "react/jsx-runtime";
var BackButton = () => {
  const navigate = useNavigate();
  const { formatMessage } = useIntl18();
  const backArrowLabel = formatMessage({ id: "BACK" });
  const handleClick = () => navigate(-1);
  return /* @__PURE__ */ jsx55(
    TextAction7,
    {
      as: "button",
      icon: "interfaceCTAIndicator",
      size: "medium",
      css: {
        color: "$onSurfaceTextPrimary",
        borderColor: "transparent",
        margin: "$one $none",
        typography: "$bodyOne",
        "& > .GDS-icon:first-child": {
          color: "$primaryBackgroundDefault",
          // Rotate 180 degrees to point left (back direction)
          transform: "rotate(180deg)"
        },
        "&:hover": {
          textDecoration: "none",
          "& > .GDS-icon:first-child": {
            color: "$primaryBackgroundHovered",
            // Global styles in inject-styles.ts handle fill inversion on hover
            transform: "rotate(180deg)"
          }
        }
      },
      onClick: handleClick,
      "aria-label": backArrowLabel,
      children: backArrowLabel
    }
  );
};

// src/components/points-pill/points-pill.component.tsx
import {
  ParagraphText as ParagraphText6,
  StackLayout as StackLayout17,
  TextAction as TextAction8
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl19 } from "@leagueplatform/locales";
import { InternalOrExternalLinkButton as InternalOrExternalLinkButton2 } from "@leagueplatform/web-common-components";

// src/hooks/usePointsData/usePointsData.hook.ts
import { useState as useState4, useEffect as useEffect4, useCallback as useCallback3 } from "react";
import { leagueFetch as leagueFetch3 } from "@leagueplatform/league-fetch";
var usePointsData = () => {
  const [data, setData] = useState4(null);
  const [isLoading, setIsLoading] = useState4(false);
  const [error, setError] = useState4(null);
  const fetchPointsData = useCallback3(() => __async(void 0, null, function* () {
    setIsLoading(true);
    setError(null);
    try {
      const response = yield leagueFetch3("v1/rewards-user-accounts", {
        method: "GET"
      });
      if (!response.ok) {
        throw new Error(`Failed to fetch points data: ${response.status}`);
      }
      const responseData = yield response.json();
      setData(responseData.data);
    } catch (err) {
      setError(
        err instanceof Error ? err : new Error("Unknown error occurred")
      );
    } finally {
      setIsLoading(false);
    }
  }), []);
  useEffect4(() => {
    fetchPointsData();
  }, [fetchPointsData]);
  return {
    data,
    isLoading,
    error,
    refetch: fetchPointsData
  };
};

// src/components/points-pill/points-pill.component.tsx
import { jsx as jsx56 } from "react/jsx-runtime";
var PointsPill = () => {
  const { data: pointsData, isLoading, error } = usePointsData();
  const { formatMessage } = useIntl19();
  if (error || !pointsData || isLoading) {
    return null;
  }
  return /* @__PURE__ */ jsx56(
    StackLayout17,
    {
      orientation: "horizontal",
      spacing: "$one",
      verticalAlignment: "center",
      className: "reward-accounts-list",
      css: { width: "fit-content", flexGrow: 0 },
      children: /* @__PURE__ */ jsx56(StackLayout17, { orientation: "vertical", spacing: "$oneAndHalf", children: /* @__PURE__ */ jsx56(
        ParagraphText6,
        {
          size: "base",
          as: "p",
          htmlStringOptions: {
            a: {
              component: InternalOrExternalLinkButton2,
              props: {
                baseComponent: TextAction8,
                onClick: (e) => e.stopPropagation(),
                href: "https://aircanada.com/aeroplan"
              }
            },
            br: {
              component: "br"
            }
          },
          children: formatMessage({ id: "CONFIGURABLE_JOURNEY_HEADER_SUB_TITLE" })
        }
      ) })
    }
  );
};

// src/routes/rewards-hub-routes.tsx
import { Routes, Route } from "react-router-dom";

// src/pages/rewards-hub-overview/rewards-hub-overview.page.tsx
import { useCallback as useCallback4, useEffect as useEffect6, useMemo as useMemo2, useRef as useRef4, useState as useState5 } from "react";
import { useIntl as useIntl21 } from "@leagueplatform/locales";
import { useQueryClient as useQueryClient2 } from "@tanstack/react-query";
import { clearNodeCache as clearNodeCache2 } from "@leagueplatform/masonry-engine";
import { useDocumentTitle } from "@leagueplatform/web-common";

// src/hooks/useSponsorId/useSponsorId.hook.ts
import { useUnknownConfigProperty } from "@leagueplatform/core";
function useSponsorId() {
  return useUnknownConfigProperty("rewardsHub.sponsorId");
}

// src/hooks/useRecentActivityCatchUp/useRecentActivityCatchUp.hook.ts
import { useEffect as useEffect5, useRef as useRef3 } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { clearNodeCache } from "@leagueplatform/masonry-engine";
var RECENT_ACTIVITY_NODE_ID = "rewardsHub$web$linkedExperience$rootRecentActivity";
var CATCH_UP_DELAYS_MS = [3e3, 8e3, 2e4];
var CATCH_UP_FLAG_MAX_AGE_MS = 3e4;
var consumeCompletedAt = () => {
  let flag;
  try {
    flag = sessionStorage.getItem(
      SESSION_STORAGE_KEYS.REWARDS_TASK_COMPLETED_AT
    );
    if (flag === null)
      return null;
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.REWARDS_TASK_COMPLETED_AT);
  } catch (e) {
    return null;
  }
  const completedAt = Number(flag);
  const age = Date.now() - completedAt;
  if (!Number.isFinite(completedAt) || age < 0 || age > CATCH_UP_FLAG_MAX_AGE_MS) {
    return null;
  }
  return completedAt;
};
function useRecentActivityCatchUp() {
  const queryClient = useQueryClient();
  const completedAtRef = useRef3(void 0);
  useEffect5(() => {
    if (completedAtRef.current === void 0) {
      completedAtRef.current = consumeCompletedAt();
    }
    const completedAt = completedAtRef.current;
    if (completedAt === null)
      return void 0;
    const elapsed = Date.now() - completedAt;
    const upcoming = CATCH_UP_DELAYS_MS.filter((delay) => delay > elapsed).map(
      (delay) => delay - elapsed
    );
    const waits = upcoming.length < CATCH_UP_DELAYS_MS.length ? [0, ...upcoming] : upcoming;
    const timers = waits.map(
      (wait) => setTimeout(() => {
        clearNodeCache({
          id: RECENT_ACTIVITY_NODE_ID,
          queryClient,
          strategy: "invalidate",
          self: true
        });
      }, wait)
    );
    return () => timers.forEach(clearTimeout);
  }, [queryClient]);
}

// src/components/rewards-points-update-modal/rewards-points-update-modal.component.tsx
import {
  Modal,
  HeadingText as HeadingText12,
  ParagraphText as ParagraphText7,
  Button as Button3,
  StackLayout as StackLayout18
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl20 } from "@leagueplatform/locales";
import { jsx as jsx57, jsxs as jsxs22 } from "react/jsx-runtime";
function RewardsPointsUpdateModal({
  open,
  onClose
}) {
  const { formatMessage } = useIntl20();
  return /* @__PURE__ */ jsx57(Modal.Root, { open, onOpenChange: (isOpen) => !isOpen && onClose(), children: /* @__PURE__ */ jsxs22(Modal.Content, { children: [
    /* @__PURE__ */ jsx57(Modal.Close, {}),
    /* @__PURE__ */ jsxs22(
      StackLayout18,
      {
        horizontalAlignment: "center",
        css: {
          padding: "$oneAndHalf",
          paddingBlockStart: "$none",
          textAlign: "center",
          gap: "$one"
        },
        children: [
          /* @__PURE__ */ jsx57(Modal.Title, { children: /* @__PURE__ */ jsx57(HeadingText12, { level: "2", size: "lg", children: formatMessage({ id: "REWARDS_POINTS_UPDATE_MODAL_TITLE" }) }) }),
          /* @__PURE__ */ jsx57(Modal.Description, { children: /* @__PURE__ */ jsx57(ParagraphText7, { css: { whiteSpace: "pre-line" }, children: formatMessage({
            id: "REWARDS_POINTS_UPDATE_MODAL_DESCRIPTION"
          }) }) }),
          /* @__PURE__ */ jsx57(Button3, { onClick: onClose, width: "fillContainer", position: "center", children: formatMessage({ id: "REWARDS_POINTS_UPDATE_MODAL_CLOSE" }) })
        ]
      }
    )
  ] }) });
}

// src/pages/rewards-hub-masonry.page.tsx/rewards-hub-masonry.page.tsx
import { useMemo } from "react";
import {
  Box as Box15,
  HeadingText as HeadingText13,
  ParagraphText as ParagraphText8,
  queryHelpers as queryHelpers8,
  StackLayout as StackLayout19,
  useMediaQuery as useMediaQuery8
} from "@leagueplatform/genesis-core";
import { getMasonryDriver } from "@leagueplatform/masonry";
import {
  MasonryEngine
} from "@leagueplatform/masonry-engine";
import { jsx as jsx58, jsxs as jsxs23 } from "react/jsx-runtime";
var LAYOUT_MAX_WIDTH = "1260px";
function RewardsHubMasonryPage({
  rootNodeId,
  heading,
  subheading,
  queryParams,
  customLoaderNamespace
}) {
  const MasonryDriver = useMemo(() => {
    const baseDriver = getMasonryDriver(__spreadValues({
      rootNodeId
    }, queryParams && { queryParams }));
    if (!customLoaderNamespace)
      return baseDriver;
    return __spreadProps(__spreadValues({}, baseDriver), {
      node: __spreadProps(__spreadValues({}, baseDriver.node), { namespace: customLoaderNamespace })
    });
  }, [rootNodeId, queryParams, customLoaderNamespace]);
  const belowMobileBreakpoint = queryHelpers8.down("mobileLandscape");
  const isBelowMobile = useMediaQuery8(belowMobileBreakpoint);
  const hasHeader = heading || subheading;
  return /* @__PURE__ */ jsx58(StackLayout19, { horizontalAlignment: "center", children: /* @__PURE__ */ jsxs23(
    Box15,
    {
      className: "rewards-hub-masonry-page-layout",
      css: {
        maxWidth: LAYOUT_MAX_WIDTH,
        margin: "auto",
        width: "100%",
        padding: "$none $oneAndHalf",
        paddingBlockEnd: isBelowMobile ? "$two" : "$three"
      },
      children: [
        /* @__PURE__ */ jsxs23(
          Box15,
          {
            className: "rewards-hub-masonry-back-button-container",
            css: __spreadProps(__spreadValues({
              paddingTop: "$two"
            }, !hasHeader && { paddingBlockEnd: "$twoAndHalf" }), {
              display: "flex",
              flexDirection: "column",
              gap: "$oneAndHalf"
            }),
            children: [
              /* @__PURE__ */ jsx58(Box15, { css: { display: "flex", justifyContent: "flex-start" }, children: /* @__PURE__ */ jsx58(BackButton, {}) }),
              hasHeader && /* @__PURE__ */ jsxs23(
                Box15,
                {
                  as: "header",
                  className: "rewards-hub-masonry-header-content-wrapper",
                  css: {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "inherit",
                    flex: 1,
                    gap: "$one",
                    paddingBlockEnd: isBelowMobile ? "$two" : "$twoAndHalf"
                  },
                  children: [
                    heading && /* @__PURE__ */ jsx58(HeadingText13, { level: "1", size: "xxl", children: heading }),
                    subheading && /* @__PURE__ */ jsx58(ParagraphText8, { css: { maxWidth: "596px" }, size: "base", children: subheading })
                  ]
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx58(MasonryEngine, { driver: MasonryDriver })
      ]
    }
  ) });
}

// src/pages/rewards-hub-overview/rewards-hub-overview.page.tsx
import { Fragment as Fragment2, jsx as jsx59, jsxs as jsxs24 } from "react/jsx-runtime";
var ROOT_NODE_ID = "rewardsHub$root";
function RewardsHubOverviewPage() {
  const { formatMessage } = useIntl21();
  const rewardsHubTitle = formatMessage({ id: "REWARDS_HUB_TITLE" });
  useDocumentTitle(rewardsHubTitle);
  const sponsorId = useSponsorId();
  const queryClient = useQueryClient2();
  const queryParams = useMemo2(
    () => sponsorId ? { sponsorId } : void 0,
    [sponsorId]
  );
  const [showModal, setShowModal] = useState5(false);
  const hasClearedCache = useRef4(false);
  if (!hasClearedCache.current) {
    clearNodeCache2({
      id: ROOT_NODE_ID,
      queryClient,
      strategy: "remove",
      self: true,
      descendants: true
    });
    hasClearedCache.current = true;
  }
  useRecentActivityCatchUp();
  useEffect6(() => {
    const ctaClicked = sessionStorage.getItem(
      SESSION_STORAGE_KEYS.REWARDS_CTA_CLICKED
    );
    const modalShown = sessionStorage.getItem(
      SESSION_STORAGE_KEYS.REWARDS_MODAL_SHOWN
    );
    if (ctaClicked && !modalShown) {
      const timerId = setTimeout(() => {
        setShowModal(true);
        sessionStorage.setItem(
          SESSION_STORAGE_KEYS.REWARDS_MODAL_SHOWN,
          "true"
        );
      }, 500);
      return () => clearTimeout(timerId);
    }
  }, []);
  const handleCloseModal = useCallback4(() => {
    setShowModal(false);
  }, []);
  return /* @__PURE__ */ jsxs24(Fragment2, { children: [
    /* @__PURE__ */ jsx59(
      RewardsHubMasonryPage,
      {
        rootNodeId: ROOT_NODE_ID,
        heading: rewardsHubTitle,
        subheading: formatMessage({
          id: "REWARDS_HUB_DESCRIPTION"
        }),
        queryParams,
        customLoaderNamespace: REWARDS_HUB_OVERVIEW_LOADER_NAMESPACE
      }
    ),
    /* @__PURE__ */ jsx59(RewardsPointsUpdateModal, { open: showModal, onClose: handleCloseModal })
  ] });
}

// src/pages/rewards-hub-history/rewards-hub-history.page.tsx
import { useIntl as useIntl22 } from "@leagueplatform/locales";
import {
  useDocumentTitle as useDocumentTitle2,
  useScrollTopOnLocationChange
} from "@leagueplatform/web-common";
import { jsx as jsx60 } from "react/jsx-runtime";
function RewardsHubHistoryPage() {
  const { formatMessage } = useIntl22();
  useDocumentTitle2(formatMessage({ id: "POINTS_HISTORY_TITLE" }));
  useScrollTopOnLocationChange();
  return /* @__PURE__ */ jsx60(RewardsHubMasonryPage, { rootNodeId: "rewardsHub$pointsHistory$root" });
}

// src/pages/rewards-hub-task/rewards-hub-task.page.tsx
import { useMemo as useMemo3 } from "react";
import { useSearchParams } from "react-router-dom";
import { useIntl as useIntl23 } from "@leagueplatform/locales";
import { useDocumentTitle as useDocumentTitle3 } from "@leagueplatform/web-common";
import { jsx as jsx61 } from "react/jsx-runtime";
function RewardsHubTaskPage() {
  const { formatMessage } = useIntl23();
  useDocumentTitle3(formatMessage({ id: "REWARDS_HUB_TITLE" }));
  const [searchParams] = useSearchParams();
  const taskId = searchParams.get("id");
  const sponsorId = useSponsorId();
  const rootNodeId = "rewardableTaskOverview$root";
  const queryParams = useMemo3(
    () => __spreadValues({
      id: taskId != null ? taskId : ""
    }, sponsorId && { sponsorId }),
    [taskId, sponsorId]
  );
  return /* @__PURE__ */ jsx61(RewardsHubMasonryPage, { rootNodeId, queryParams });
}

// src/routes/rewards-hub-routes.tsx
import { jsx as jsx62, jsxs as jsxs25 } from "react/jsx-runtime";
var REWARDS_HUB_ROUTE = "/rewards-hub";
var RewardsHubRoutes = () => /* @__PURE__ */ jsxs25(Routes, { children: [
  /* @__PURE__ */ jsx62(Route, { index: true, element: /* @__PURE__ */ jsx62(RewardsHubOverviewPage, {}) }),
  /* @__PURE__ */ jsx62(Route, { path: "/history", element: /* @__PURE__ */ jsx62(RewardsHubHistoryPage, {}) }),
  /* @__PURE__ */ jsx62(Route, { path: "/task", element: /* @__PURE__ */ jsx62(RewardsHubTaskPage, {}) })
] });

// src/hooks/useRefreshRewardsAfterUnlink/useRefreshRewardsAfterUnlink.hook.ts
import { useCallback as useCallback5 } from "react";
import { useQueryClient as useQueryClient3 } from "@tanstack/react-query";
import { clearNodeCache as clearNodeCache3 } from "@leagueplatform/masonry-engine";
var REWARDS_NODE_IDS = [
  "rewardsHub$root",
  "homepage$web$rewardHubEntry",
  "rewardsHub$contextualCards$submitClaimWeb"
];
function useRefreshRewardsAfterUnlink() {
  const queryClient = useQueryClient3();
  return useCallback5(() => {
    REWARDS_NODE_IDS.forEach((id) => {
      clearNodeCache3({
        id,
        queryClient,
        // 'invalidate' (not 'remove') so currently-mounted Masonry nodes
        // refetch immediately, and unmounted ones refetch on next mount.
        strategy: "invalidate",
        self: true,
        descendants: true
      });
    });
  }, [queryClient]);
}

// src/hooks/useRefreshRewardsOnPointsUpdate/useRefreshRewardsOnPointsUpdate.hook.ts
import { useEffect as useEffect7, useRef as useRef5 } from "react";
import { useQueryClient as useQueryClient4 } from "@tanstack/react-query";
import { clearNodeCache as clearNodeCache4 } from "@leagueplatform/masonry-engine";
import { ReconnectingSocketController as ReconnectingSocketController2 } from "@leagueplatform/league-socket";
var USER_REWARDS_UPDATES_MESSAGE_TYPE2 = "user_rewards_updates";
var POINTS_NODE_IDS = [
  "rewardsHub$root",
  "homepage$web$rewardHubEntry",
  // A new reward is a new row, so this subtree does remount on refetch (MANU-6277).
  "rewardsHub$pointsHistory$root"
];
var REFRESH_DEBOUNCE_MS2 = 800;
function useRefreshRewardsOnPointsUpdate() {
  const queryClient = useQueryClient4();
  const debounceRef = useRef5();
  useEffect7(() => {
    const removeEventHandler = ReconnectingSocketController2.addEventHandler(
      (event) => {
        if ((event == null ? void 0 : event.message_type) !== USER_REWARDS_UPDATES_MESSAGE_TYPE2) {
          return;
        }
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
          POINTS_NODE_IDS.forEach((id) => {
            clearNodeCache4({
              id,
              queryClient,
              // 'invalidate' keeps previous data on screen (NodeResolver uses
              // keepPreviousData) so points update in place, no loading flash.
              strategy: "invalidate",
              self: true,
              descendants: true
            });
          });
        }, REFRESH_DEBOUNCE_MS2);
      }
    );
    return () => {
      clearTimeout(debounceRef.current);
      removeEventHandler();
    };
  }, [queryClient]);
}

// src/components/rewards-points-refresh-listener/rewards-points-refresh-listener.component.tsx
var RewardsPointsRefreshListener = () => {
  useRefreshRewardsOnPointsUpdate();
  return null;
};

// src/locales/en.ts
var EN_STRING_OVERRIDES = {
  // Common strings, not needed for translations
  AWAY: "Away",
  DOCUMENT_TITLE: "{title}",
  HOME: "Home",
  LOG_OUT: "Log out",
  MANULIFE: "Manulife",
  MANULIFE_LIGHT: "Manulife Light",
  MANULIFE_DARK: "Manulife Dark",
  REWARDS_HUB: "Rewards Hub",
  // Manulife specific strings
  ACTIVITY_CARD_CTA: "View activity",
  AEROPLAN_POINTS_INFO: "Information about Aeroplan points",
  AEROPLAN_POINTS: "{points} Aeroplan Points",
  REWARD_POINTS: "Aeroplan Points",
  CONFIGURABLE_JOURNEY_HEADER_SUB_TITLE: "Balance represents total points earned within the Manulife app. <br/> For more details on total Aeroplan points or what these points mean, visit <a>aircanada.com/aeroplan</a>.",
  PROGRAM_CARD_CTA: "View program details",
  YOUVE_GOT_THIS_NAME: "Welcome to your Journey, {firstName}!",
  YOUVE_GOT_THIS: "Welcome to your Journey",
  VIEW_CONTENT: "View Content",
  MASONRY_CONTAINER: "Masonry Container Viewer",
  PROGRESS_CARD_CTA: "View program",
  POINTS: "pts",
  LOCKED: "Locked",
  PROGRESS_BAR_ACCESSIBILITY_LABEL: "{current} out of {total} Aeroplan points",
  PROGRESS_BAR_TRAILING_VALUE: "{value} points",
  TAG_ACCESSIBILITY_LABEL: "{iconAltText}, {label}",
  REWARDS_HUB_TITLE: "Rewards",
  POINTS_HISTORY_TITLE: "Points History",
  REWARDS_HUB_DESCRIPTION: "Explore offers, complete activities, and track your points\u2014all in one place. Your progress toward Aeroplan rewards starts here.",
  EXPLORE_NOW: "Explore now",
  // Rewards Hub Overview skeleton loader — cycles every 5 seconds
  REWARDS_HUB_LOADER_OFFERS_LOADING: "Your offers are loading",
  REWARDS_HUB_LOADER_WORKING_ON_IT: "We\u2019re working on it",
  REWARDS_HUB_LOADER_PREPARING: "Preparing your offers",
  REWARDS_HUB_LOADER_ALMOST_THERE: "Almost there\u2026",
  REWARDS_HUB_LOADER_FINALIZING: "Finalizing",
  // Rewards Points Update Modal
  REWARDS_POINTS_UPDATE_MODAL_TITLE: "Your points are being updated",
  REWARDS_POINTS_UPDATE_MODAL_DESCRIPTION: "It can take up to 72 hours to get your points after completing an offer. Don't worry if they don't appear right away.\n\nOffers will stay on your feed until your points are updated.",
  REWARDS_POINTS_UPDATE_MODAL_CLOSE: "Close",
  // SDK error state (FullPageError / ErrorState from web-common-components)
  THERE_SEEMS_T0_HAVE_BEEN_A_PROBLEM: "Something went wrong",
  TRY_AGAIN: "Try again",
  PLEASE_TRY_AGAIN_SHORTLY: "Please try again in a moment.",
  REWARD_POINTS_EARNED: "Aeroplan Points Earned",
  CHALLENGE_ACTIVITY_EMPTY_STATE_HEADER: "Nothing to see here (yet!)",
  INSIGHT_CARD_UNIT_STEPS: "{count, plural, one {step/push} other {steps/pushes}}",
  // MANU-5906 — Challenge copy: use "Enrolled" for status-badge consistency, and
  // drop the "League mobile app" mention on the device-connect screen.
  JOINED: "Enrolled",
  TRACK_CHALLENGE_AUTOMATICALLY_DESCRIPTION: "If you choose to track automatically, after you\u2019ve signed up, {instructionsLink} to connect your device.",
  VIEW_CHALLENGE_DETAILS: "View Challenge",
  YOURE_GOOD_TO_GO: "You\u2019re signed up!",
  // "\n\n" = paragraph break, rendered via the inject-styles pre-line rule.
  CHECK_CHALLENGE_DETAILS: "Once your challenge begins, log your progress and mark activities as complete.\n\nFor eligible challenges, you can connect a mobile or wearable device through the Manulife mobile app to track activities automatically.",
  // MANU-5904 — JRNO-2582 removed the SDK's `<a>` chunk, so no link renders without this.
  CHECK_TO_CONFIRM_PRIVACY_POLICY: "By checking this box, I agree to the <a>privacy policy.</a>",
  // MANU-5891 — Hide the SDK's challenge legal disclaimer. The SDK renders the
  // banner unless this string is exactly a single space, so ' ' is the opt-out.
  // Do NOT use '': react-intl then falls back to the message id and the banner
  // renders with the literal text "CHALLENGES_LEGAL_DISCLAIMER" in it. Verified
  // by rendering the SDK's LegalDisclaimer against all three values.
  CHALLENGES_LEGAL_DISCLAIMER: " "
};

// src/locales/fr.ts
var FR_STRING_OVERRIDES = {
  // Common strings, not needed for translations
  AWAY: "Away",
  DOCUMENT_TITLE: "{title}",
  HOME: "Home",
  LOG_OUT: "Log out",
  MANULIFE: "Manulife",
  MANULIFE_LIGHT: "Manulife Light",
  MANULIFE_DARK: "Manulife Dark",
  REWARDS_HUB: "Rewards Hub",
  // Manulife specific strings
  ACTIVITY_CARD_CTA: "Voir l'activit\xE9",
  AEROPLAN_POINTS_INFO: "Information sur les points Aeroplan",
  AEROPLAN_POINTS: "{points} points A\xE9roplan accumul\xE9s",
  REWARD_POINTS: "Points A\xE9roplan",
  CONFIGURABLE_JOURNEY_HEADER_SUB_TITLE: "Le solde repr\xE9sente le total des points actuellement accumul\xE9s au moyen de l'application Services mobiles Manuvie. <br/> Pour plus de d\xE9tails sur vos points A\xE9roplan et la fa\xE7on dont vous pouvez les utiliser, visitez le site <a>aircanada.com/aeroplan</a>.",
  PROGRAM_CARD_CTA: "Afficher les d\xE9tails du programme",
  YOUVE_GOT_THIS_NAME: "Bienvenue dans votre parcours, {firstName}!",
  YOUVE_GOT_THIS: "Bienvenue dans votre parcours",
  VIEW_CONTENT: "Afficher le contenu",
  POINTS: "pts",
  PROGRESS_CARD_CTA: "Voir les programme",
  LOCKED: "Verrouill\xE9",
  PROGRESS_BAR_ACCESSIBILITY_LABEL: "{current} sur {total} points A\xE9roplan",
  PROGRESS_BAR_TRAILING_VALUE: "{value} points",
  TAG_ACCESSIBILITY_LABEL: "{iconAltText}, {label}",
  // TODO: Add french translations
  REWARDS_HUB_TITLE: "Primes",
  POINTS_HISTORY_TITLE: "Historique des points",
  REWARDS_HUB_DESCRIPTION: "D\xE9couvrez les offres, effectuez des activit\xE9s et faites le suivi de vos points, le tout au m\xEAme endroit. Votre parcours vers les primes A\xE9roplan commence ici.",
  EXPLORE_NOW: "Explorez maintenant",
  // Rewards Hub Overview skeleton loader — cycles every 5 seconds
  REWARDS_HUB_LOADER_OFFERS_LOADING: "Vos offres sont en cours de chargement",
  REWARDS_HUB_LOADER_WORKING_ON_IT: "Nous y travaillons",
  REWARDS_HUB_LOADER_PREPARING: "Nous pr\xE9parons vos offres",
  REWARDS_HUB_LOADER_ALMOST_THERE: "Nous y sommes presque\u2026",
  REWARDS_HUB_LOADER_FINALIZING: "En cours de finalisation",
  // Rewards Points Update Modal
  // TODO: Add French translations for the rewards points update modal
  REWARDS_POINTS_UPDATE_MODAL_TITLE: "Mise \xE0 jour de vos points",
  REWARDS_POINTS_UPDATE_MODAL_DESCRIPTION: "Une fois qu\u2019une offre est compl\xE9t\xE9e, il peut s\u2019\xE9couler jusqu\u2019\xE0 72 heures avant que vous obteniez vos points. Ne vous inqui\xE9tez pas s\u2019ils ne s\u2019affichent pas tout de suite.\n\nLes offres resteront dans votre fil jusqu\u2019\xE0 ce que vos points soient mis \xE0 jour.",
  REWARDS_POINTS_UPDATE_MODAL_CLOSE: "Fermer",
  // SDK error state (FullPageError / ErrorState from web-common-components)
  THERE_SEEMS_T0_HAVE_BEEN_A_PROBLEM: "Une erreur s\u2019est produite",
  TRY_AGAIN: "R\xE9essayer",
  PLEASE_TRY_AGAIN_SHORTLY: "Veuillez r\xE9essayer dans un instant.",
  REWARD_POINTS_EARNED: "Points A\xE9roplan accumul\xE9s",
  CHALLENGE_ACTIVITY_EMPTY_STATE_HEADER: "Il n\u2019y a rien \xE0 voir par ici (pour le moment!)",
  // MANU-5468 — Summer challenge "Activities" tab. Override FR translation
  // to reach out compatibility between platforms.
  CHALLENGE_ACTIVITY_UP_NEXT: "Suivante",
  CHALLENGE_ACTIVITY_COMPLETED: "Compl\xE9t\xE9",
  VIEW_ALL: "Voir plus",
  INSIGHT_CARD_UNIT_STEPS: "{count, plural, one {pas/pousser} other {pas/pouss\xE9es}}",
  // MANU-5906 — Challenge copy: use "Inscrit" for status-badge consistency, and
  // drop the "application mobile League" mention on the device-connect screen.
  JOINED: "Inscrit",
  TRACK_CHALLENGE_AUTOMATICALLY_DESCRIPTION: "Si vous d\xE9cidez de faire le suivi automatiquement, apr\xE8s votre adh\xE9sion, {instructionsLink} pour connecter votre appareil.",
  // Manulife prefers the imperative FR sign-up CTA (SDK/Smartling default is "S'inscrire").
  CHALLENGE_SIGN_UP_CTA: "Inscrivez-vous",
  // MANU-6463 — Challenge Details sign-up CTA, aligned with iOS/Android
  // (SDK/Smartling default is "S'inscrire au défi").
  SIGN_UP_FOR_CHALLENGE: "Inscrivez-vous au d\xE9fi",
  VIEW_CHALLENGE_DETAILS: "Voir le d\xE9fi",
  YOURE_GOOD_TO_GO: "Votre inscription est confirm\xE9e!",
  // "\n\n" = paragraph break, rendered via the inject-styles pre-line rule.
  CHECK_CHALLENGE_DETAILS: "Lorsque votre d\xE9fi aura commenc\xE9, consignez vos progr\xE8s et marquez les activit\xE9s comme termin\xE9es.\n\nPour les d\xE9fis admissibles, vous pouvez connecter votre t\xE9l\xE9phone cellulaire ou votre appareil portable \xE0 l\u2019appli mobile de Manuvie pour suivre automatiquement vos activit\xE9s.",
  // MANU-5904 — See the note in en.ts.
  CHECK_TO_CONFIRM_PRIVACY_POLICY: "En cochant cette case, j\u2019accepte la <a>politique de confidentialit\xE9.</a>",
  // MANU-5891 — Hide the SDK's challenge legal disclaimer. See the note in en.ts:
  // ' ' is the SDK's opt-out sentinel; '' would render the banner with the raw
  // message id in it.
  CHALLENGES_LEGAL_DISCLAIMER: " "
};

// src/theme/theme.ts
var manulifeTheme = {
  colors: {
    surface: {
      background: {
        primary: "#FFFFFFFF",
        secondary: "#FAFAFAFF",
        tertiary: "#EDEDEDFF"
      },
      card: {
        primary: "#FFFFFFFF",
        secondary: "#FAFAFAFF",
        disabled: "#DFE0E2FF"
      },
      screenHeader: { background: "#DEF3FCFF" },
      skeleton: {
        shimmer: {
          background: "#E7E7E7FF",
          overlay: "linear-gradient(90.0deg, #FFFFFF00 0%, #FFFFFF80 50%, #FFFFFFE5 70%, #FFFFFF00 100%)"
        }
      }
    },
    onSurface: {
      text: {
        primary: "#282B3EFF",
        subdued: "#5E6073FF",
        reversed: "#FFFFFFFF",
        critical: "#DB1F00FF",
        success: "#046138",
        warning: "#F49600FF"
      },
      border: { subdued: "#EDEDEDFF", default: "#DDDEE4FF", card: "#EDEDEDFF" },
      icon: { primary: "#282B3EFF" }
    },
    interactive: {
      action: {
        primary: "#06874EFF",
        hovered: "#046138FF",
        pressed: "#004427FF",
        subdued: "#666666FF",
        disabled: "#C2C3C9FF"
      },
      icon: { default: "#FFFFFFFF", disabled: "#8E90A2FF" },
      background: {
        default: "#FFFFFFFF",
        disabled: "#DFE0E2FF",
        hovered: "#F8F8F8FF",
        pressed: "#F0F0F0FF"
      },
      border: {
        default: "#949494FF",
        hovered: "#046138FF",
        disabled: "#D6D6D6FF",
        critical: { default: "#DB1F00FF" }
      },
      focus: { inner: "#06874EFF", outer: "#06874EFF" }
    },
    critical: {
      background: { subdued: "#F6CCC7FF", secondary: "#EDEDEDFF" },
      border: { default: "#DB1F00FF" },
      icon: "#DB1F00FF"
    },
    warning: {
      background: { subdued: "#F8E9C6FF", secondary: "#FFFFFFFF" },
      border: { default: "#A75900FF" },
      icon: "#F49600FF"
    },
    success: {
      background: { subdued: "#EDEDEDFF", secondary: "#CAEED9FF" },
      border: { default: "#06874EFF" },
      icon: "#06874EFF"
    },
    highlight: {
      background: { subdued: "#E8F8FFFF", secondary: "#EDEDEDFF" },
      border: { default: "#2E5CDFFF" },
      icon: "#2D69FFFF"
    },
    decorative: {
      brand: {
        primary: {
          darkest: "#261848FF",
          dark: "#4C336BFF",
          default: "#6F5693FF",
          bright: "#9D8DBCFF",
          brightest: "#D4D2E9FF",
          pastel: "#F5F5F5FF"
        },
        secondary: {
          darkest: "#0B9189FF",
          dark: "#05B2A7FF",
          default: "#06C7BAFF",
          bright: "#68E7DFFF",
          brightest: "#9DF3EDFF",
          pastel: "#C5F4F1FF"
        },
        tertiary: {
          darkest: "#845A09FF",
          dark: "#C2891BFF",
          default: "#F49600FF",
          bright: "#F5C464FF",
          brightest: "#F8D38AFF",
          pastel: "#FBE9C6FF"
        }
      }
    },
    primary: {
      background: {
        default: "#EC6453FF",
        hovered: "#D03A39FF",
        pressed: "#A00E18FF",
        critical: {
          default: "#DB1F00FF",
          hovered: "#DB1F00FF",
          pressed: "#DB1F00FF"
        }
      },
      text: { default: "#FFFFFFFF", critical: { default: "#FFFFFFFF" } }
    },
    secondary: {
      background: {
        default: "#FFFFFF00",
        hovered: "#D03A39FF",
        pressed: "#A00E18FF"
      },
      text: { default: "#EC6453FF", hovered: "#FFFFFFFF" },
      border: { default: "#EC6453FF" }
    },
    tertiary: {
      background: {
        default: "#FFFFFF00",
        hovered: "#046138FF",
        pressed: "#004427FF"
      },
      text: { default: "#046138FF", hovered: "#FFFFFFFF" },
      border: { default: "#00A758FF" }
    },
    input: {
      border: {
        success: "#4C336BFF",
        warning: "#F49600FF",
        default: "#949494FF",
        hovered: "#046138FF",
        disabled: "#D6D6D6FF",
        critical: "#DB1F00FF"
      },
      background: {
        default: "#FFFFFFFF",
        disabled: "#DFE0E2FF",
        hovered: "#F8F8F8FF",
        pressed: "#F0F0F0FF"
      }
    },
    dataViz: {
      interface: { track: { border: "#959595FF", background: "#F5F5F5FF" } },
      singleColor: { brand: "#06874EFF", neutral: "#272A38FF" },
      status: {
        critical: "#CB2A32FF",
        warning: "#DE6F12FF",
        success: "#159369FF"
      },
      categorical: {
        one: "#008BCCFF",
        two: "#074664FF",
        three: "#00699AFF",
        four: "#C2891BFF",
        five: "#845A09FF",
        six: "#008B82FF"
      }
    },
    tag: {
      neutral: {
        background: { bold: "#3B3B3BFF", subdued: "#E9E9E9FF" },
        border: { bold: "#3B3B3BFF", subdued: "#E9E9E9FF" },
        text: { bold: "#FFFFFFFF", subdued: "#1A1A1AFF" }
      },
      one: {
        background: { bold: "#6F5693FF", subdued: "#F5F5F5FF" },
        border: { bold: "#6F5693FF", subdued: "#F5F5F5FF" },
        text: { bold: "#FFFFFFFF", subdued: "#1A1A1AFF" }
      },
      two: {
        background: { bold: "#68E7DFFF", subdued: "#C5F4F1FF" },
        border: { bold: "#68E7DFFF", subdued: "#C5F4F1FF" },
        text: { bold: "#FFFFFFFF", subdued: "#1A1A1AFF" }
      },
      three: {
        background: { bold: "#994000FF", subdued: "#F2EEE6FF" },
        border: { bold: "#994000FF", subdued: "#F2EEE6FF" },
        text: { bold: "#FFFFFFFF", subdued: "#1A1A1AFF" }
      },
      four: {
        background: { bold: "#870644FF", subdued: "#F2E1F0FF" },
        border: { bold: "#870644FF", subdued: "#F2E1F0FF" },
        text: { bold: "#FFFFFFFF", subdued: "#1A1A1AFF" }
      },
      success: {
        background: { bold: "#008A09FF", subdued: "#E3F7F0FF" },
        border: { bold: "#008A09FF", subdued: "#E3F7F0FF" },
        text: { bold: "#FFFFFFFF", subdued: "#02692BFF" }
      },
      warning: {
        background: { bold: "#B85B0FFF", subdued: "#FAE8D6FF" },
        border: { bold: "#B85B0FFF", subdued: "#FAE8D6FF" },
        text: { bold: "#FFFFFFFF", subdued: "#9F3703FF" }
      },
      critical: {
        background: { bold: "#DD0E0EFF", subdued: "#F9E1E2FF" },
        border: { bold: "#DD0E0EFF", subdued: "#F9E1E2FF" },
        text: { bold: "#FFFFFFFF", subdued: "#BB1111FF" }
      },
      informational: {
        background: { bold: "#2E5CDFFF", subdued: "#E8F8FFFF" },
        border: { bold: "#2E5CDFFF", subdued: "#E8F8FFFF" },
        text: { bold: "#FFFFFFFF", subdued: "#225ECEFF" }
      }
    }
  },
  shadows: {
    card: { x: 0, y: 0, blur: 0, spread: 0, color: "#FFFFFF00" },
    dropdown: { x: 0, y: 4, blur: 8, spread: 0, color: "#0000001A" }
  },
  typography: {
    headingOne: {
      fontFamily: "'Manulife JH Sans', Helvetica, Arial, sans-serif",
      fontWeight: 300,
      lineHeight: 54,
      fontSize: 44,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    headingTwo: {
      fontFamily: "'Manulife JH Sans', Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 44,
      fontSize: 32,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    headingThree: {
      fontFamily: "'Manulife JH Sans', Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 32,
      fontSize: 22,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    headingFour: {
      fontFamily: "'Manulife JH Sans', Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 26,
      fontSize: 18,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    subtitleOne: {
      fontFamily: "'Manulife JH Sans', Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 26,
      fontSize: 18,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    subtitleTwo: {
      fontFamily: "'Manulife JH Sans', Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    bodyOne: {
      fontFamily: "'Manulife JH Sans', Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none"
    },
    bodyOneSecondary: {
      fontFamily: "'Manulife JH Sans', Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none"
    },
    bodyTwo: {
      fontFamily: "'Manulife JH Sans', Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none"
    },
    bodyTwoSecondary: {
      fontFamily: "'Manulife JH Sans', Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none"
    },
    buttonOne: {
      fontFamily: "'Manulife JH Sans', Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 24,
      fontSize: 19,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    buttonTwo: {
      fontFamily: "'Manulife JH Sans', Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 24,
      fontSize: 19,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    label: {
      fontFamily: "'Manulife JH Sans', Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    overline: {
      fontFamily: "'Manulife JH Sans', Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0.6000000238418579,
      paragraphSpacing: 0,
      textCase: "uppercase",
      textDecoration: "none"
    },
    caption: {
      fontFamily: "'Manulife JH Sans', Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 4,
      textCase: "none",
      textDecoration: "none"
    },
    tab: {
      fontFamily: "'Manulife JH Sans', Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 12,
      fontSize: 10,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    }
  },
  spacing: {
    none: 0,
    quarter: 4,
    half: 8,
    threeQuarters: 12,
    one: 16,
    oneAndHalf: 24,
    two: 32,
    twoAndHalf: 40,
    three: 48,
    four: 64,
    five: 80,
    eighth: 2
  },
  borderWidths: { thin: 1, thick: 2, outerFocus: 3, innerFocus: 3, card: 1 },
  borderRadii: {
    none: 0,
    thin: 1,
    thick: 2,
    small: 3,
    medium: 6,
    large: 9,
    extraLarge: 12,
    huge: 20,
    circle: 99999,
    pill: 3,
    button: 0,
    inputField: 0,
    card: 0,
    progressBar: 9999,
    tags: 3
  },
  zIndices: {
    default: 1,
    sticky: 100,
    dropdown: 4e3,
    tooltip: 5e3,
    modal: 8e3,
    toast: 9e3
  },
  rem: {
    fontSizes: {
      headingOne: 2.75,
      headingTwo: 2,
      headingThree: 1.375,
      headingFour: 1.125,
      subtitleOne: 1.125,
      subtitleTwo: 1,
      bodyOne: 1,
      bodyOneSecondary: 1,
      bodyTwo: 0.875,
      bodyTwoSecondary: 0.875,
      buttonOne: 1.1875,
      buttonTwo: 1,
      label: 0.875,
      overline: 0.875,
      caption: 0.875,
      tab: 0.625
    },
    lineHeights: {
      headingOne: 3.375,
      headingTwo: 2.75,
      headingThree: 2,
      headingFour: 1.625,
      subtitleOne: 1.625,
      subtitleTwo: 1.5,
      bodyOne: 1.5,
      bodyOneSecondary: 1.5,
      bodyTwo: 1.25,
      bodyTwoSecondary: 1.25,
      buttonOne: 1.5,
      buttonTwo: 1.5,
      label: 1.25,
      overline: 1.25,
      caption: 1.25,
      tab: 0.75
    },
    baseSize: 16
  },
  fonts: {
    headings: "'Manulife JH Sans', Helvetica, Arial, sans-serif",
    body: "'Manulife JH Sans', Helvetica, Arial, sans-serif"
  },
  transitions: { defaultTime: "200ms" }
};

// src/index.ts
import { default as default2 } from "././assets/error-state.svg";
import { default as default3 } from "././assets/tooltip.svg";
import { default as default4 } from "././assets/aeroplan-icon.svg";
import { default as default5 } from "././assets/almost-there.svg";
import { default as default6 } from "././assets/signup-success.svg";
import { default as default7 } from "././assets/transparent.svg";
var initManulifeWebExtensionsSDK = () => {
  initModule();
  initMasonryRegistry();
  injectStyles();
  setupLocaleProfileSync();
};
export {
  default4 as AEROPLAN_ICON,
  default5 as ALMOST_THERE_ILLUSTRATION,
  BackButton,
  EN_STRING_OVERRIDES,
  default2 as ERROR_STATE_IMAGE,
  FR_STRING_OVERRIDES,
  PointsPill,
  REWARDS_HUB_ROUTE,
  RewardsHubRoutes,
  RewardsPointsRefreshListener,
  default6 as SIGNUP_SUCCESS_ILLUSTRATION,
  default3 as TOOLTIP_ICON,
  default7 as TRANSPARENT_IMAGE,
  initManulifeWebExtensionsSDK,
  manulifeTheme,
  useRefreshRewardsAfterUnlink,
  useRefreshRewardsOnPointsUpdate,
  useSponsorId
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/manulife-web-extensions'] = window.leagueSDKsPresent['@leagueplatform/manulife-web-extensions'] || [];
    window.leagueSDKsPresent['@leagueplatform/manulife-web-extensions'].push('1.1.37');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/manulife-web-extensions'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/manulife-web-extensions module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map